import * as Hr from "react";
import Yt, { useEffect as ye, useState as z, createContext as Ur, useContext as Nr, useCallback as Dt, useMemo as On, useRef as $t, Fragment as Au } from "react";
import Ce from "@mui/material/Box";
import Iu from "@mui/material/Avatar";
import Lu from "@mui/material/Menu";
import dr from "@mui/material/MenuItem";
import ds from "@mui/material/ListItemIcon";
import Uu from "@mui/material/Divider";
import Nu from "@mui/material/IconButton";
import Yo from "@mui/material/Tooltip";
import Du from "@mui/icons-material/Person";
import $u from "@mui/material/AppBar";
import Fu from "@mui/material/Toolbar";
import { Box as ue, CircularProgress as Ln, Typography as ze, Button as Ie, Breadcrumbs as Bu, CardActionArea as Mu, Card as fr, CardContent as hr, Stack as rn, Chip as Xo, IconButton as pr, TextField as En, FormControlLabel as Qo, Checkbox as ea, Link as yi, Alert as jn, List as zu, ListItemButton as qu, ListItemText as Zu, MenuItem as Hu, Table as Wu, TableHead as Ju, TableRow as bi, TableCell as xt, TableBody as Vu, Divider as Ku, Dialog as Vn, DialogTitle as Wr, DialogContent as Kn, DialogActions as fs, Snackbar as Gu } from "@mui/material";
import { AuthProvider as Yu, useAuth as zt } from "react-oidc-context";
import { Delete as Xu, ArrowBack as Qu, Add as ec, People as tc, Edit as nc } from "@mui/icons-material";
import mr from "@mui/material/Skeleton";
import gr from "@mui/material/Stack";
import { ThemeProvider as rc, styled as $s, useColorScheme as sc } from "@mui/material/styles";
import ic from "@mui/material/CssBaseline";
import oc from "@mui/material/List";
import ac from "@mui/material/ListItem";
import uc from "@mui/material/ListItemText";
import ta from "@mui/icons-material/Home";
import na from "@mui/icons-material/Settings";
import { Navigate as ra, useLocation as cc } from "react-router-dom";
import vr from "@mui/material/Typography";
import sa from "@mui/material/Select";
import lc from "@mui/icons-material/Event";
import ia from "@mui/material/Chip";
import dc from "@mui/icons-material/Business";
import fc from "@mui/icons-material/AdminPanelSettings";
import { Logo as hc } from "brand";
import pc from "@mui/icons-material/DeleteOutline";
import mc from "@mui/icons-material/Lock";
import gc from "@mui/icons-material/Brightness4";
import vc from "@mui/icons-material/Brightness7";
import yc from "@mui/icons-material/Logout";
import bc from "axios";
var hs = { exports: {} }, dn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wi;
function wc() {
  if (wi) return dn;
  wi = 1;
  var t = Yt, e = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, s = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(a, u, c) {
    var l, d = {}, f = null, p = null;
    c !== void 0 && (f = "" + c), u.key !== void 0 && (f = "" + u.key), u.ref !== void 0 && (p = u.ref);
    for (l in u) r.call(u, l) && !i.hasOwnProperty(l) && (d[l] = u[l]);
    if (a && a.defaultProps) for (l in u = a.defaultProps, u) d[l] === void 0 && (d[l] = u[l]);
    return { $$typeof: e, type: a, key: f, ref: p, props: d, _owner: s.current };
  }
  return dn.Fragment = n, dn.jsx = o, dn.jsxs = o, dn;
}
var fn = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xi;
function xc() {
  return xi || (xi = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Yt, e = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), v = Symbol.iterator, h = "@@iterator";
    function R(g) {
      if (g === null || typeof g != "object")
        return null;
      var _ = v && g[v] || g[h];
      return typeof _ == "function" ? _ : null;
    }
    var J = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function j(g) {
      {
        for (var _ = arguments.length, C = new Array(_ > 1 ? _ - 1 : 0), q = 1; q < _; q++)
          C[q - 1] = arguments[q];
        W("error", g, C);
      }
    }
    function W(g, _, C) {
      {
        var q = J.ReactDebugCurrentFrame, ae = q.getStackAddendum();
        ae !== "" && (_ += "%s", C = C.concat([ae]));
        var fe = C.map(function(re) {
          return String(re);
        });
        fe.unshift("Warning: " + _), Function.prototype.apply.call(console[g], console, fe);
      }
    }
    var L = !1, ne = !1, G = !1, Oe = !1, me = !1, Me;
    Me = Symbol.for("react.module.reference");
    function Ye(g) {
      return !!(typeof g == "string" || typeof g == "function" || g === r || g === i || me || g === s || g === c || g === l || Oe || g === p || L || ne || G || typeof g == "object" && g !== null && (g.$$typeof === f || g.$$typeof === d || g.$$typeof === o || g.$$typeof === a || g.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      g.$$typeof === Me || g.getModuleId !== void 0));
    }
    function le(g, _, C) {
      var q = g.displayName;
      if (q)
        return q;
      var ae = _.displayName || _.name || "";
      return ae !== "" ? C + "(" + ae + ")" : C;
    }
    function Ee(g) {
      return g.displayName || "Context";
    }
    function ce(g) {
      if (g == null)
        return null;
      if (typeof g.tag == "number" && j("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof g == "function")
        return g.displayName || g.name || null;
      if (typeof g == "string")
        return g;
      switch (g) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case s:
          return "StrictMode";
        case c:
          return "Suspense";
        case l:
          return "SuspenseList";
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case a:
            var _ = g;
            return Ee(_) + ".Consumer";
          case o:
            var C = g;
            return Ee(C._context) + ".Provider";
          case u:
            return le(g, g.render, "ForwardRef");
          case d:
            var q = g.displayName || null;
            return q !== null ? q : ce(g.type) || "Memo";
          case f: {
            var ae = g, fe = ae._payload, re = ae._init;
            try {
              return ce(re(fe));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var se = Object.assign, oe = 0, qe, ve, it, pt, he, pe, je;
    function V() {
    }
    V.__reactDisabledLog = !0;
    function de() {
      {
        if (oe === 0) {
          qe = console.log, ve = console.info, it = console.warn, pt = console.error, he = console.group, pe = console.groupCollapsed, je = console.groupEnd;
          var g = {
            configurable: !0,
            enumerable: !0,
            value: V,
            writable: !0
          };
          Object.defineProperties(console, {
            info: g,
            log: g,
            warn: g,
            error: g,
            group: g,
            groupCollapsed: g,
            groupEnd: g
          });
        }
        oe++;
      }
    }
    function Te() {
      {
        if (oe--, oe === 0) {
          var g = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: se({}, g, {
              value: qe
            }),
            info: se({}, g, {
              value: ve
            }),
            warn: se({}, g, {
              value: it
            }),
            error: se({}, g, {
              value: pt
            }),
            group: se({}, g, {
              value: he
            }),
            groupCollapsed: se({}, g, {
              value: pe
            }),
            groupEnd: se({}, g, {
              value: je
            })
          });
        }
        oe < 0 && j("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Xe = J.ReactCurrentDispatcher, mt;
    function Tt(g, _, C) {
      {
        if (mt === void 0)
          try {
            throw Error();
          } catch (ae) {
            var q = ae.stack.trim().match(/\n( *(at )?)/);
            mt = q && q[1] || "";
          }
        return `
` + mt + g;
      }
    }
    var Qe = !1, gt;
    {
      var Fr = typeof WeakMap == "function" ? WeakMap : Map;
      gt = new Fr();
    }
    function ri(g, _) {
      if (!g || Qe)
        return "";
      {
        var C = gt.get(g);
        if (C !== void 0)
          return C;
      }
      var q;
      Qe = !0;
      var ae = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var fe;
      fe = Xe.current, Xe.current = null, de();
      try {
        if (_) {
          var re = function() {
            throw Error();
          };
          if (Object.defineProperty(re.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(re, []);
            } catch (Ue) {
              q = Ue;
            }
            Reflect.construct(g, [], re);
          } else {
            try {
              re.call();
            } catch (Ue) {
              q = Ue;
            }
            g.call(re.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ue) {
            q = Ue;
          }
          g();
        }
      } catch (Ue) {
        if (Ue && q && typeof Ue.stack == "string") {
          for (var Q = Ue.stack.split(`
`), Ae = q.stack.split(`
`), be = Q.length - 1, xe = Ae.length - 1; be >= 1 && xe >= 0 && Q[be] !== Ae[xe]; )
            xe--;
          for (; be >= 1 && xe >= 0; be--, xe--)
            if (Q[be] !== Ae[xe]) {
              if (be !== 1 || xe !== 1)
                do
                  if (be--, xe--, xe < 0 || Q[be] !== Ae[xe]) {
                    var Ze = `
` + Q[be].replace(" at new ", " at ");
                    return g.displayName && Ze.includes("<anonymous>") && (Ze = Ze.replace("<anonymous>", g.displayName)), typeof g == "function" && gt.set(g, Ze), Ze;
                  }
                while (be >= 1 && xe >= 0);
              break;
            }
        }
      } finally {
        Qe = !1, Xe.current = fe, Te(), Error.prepareStackTrace = ae;
      }
      var Zt = g ? g.displayName || g.name : "", Ct = Zt ? Tt(Zt) : "";
      return typeof g == "function" && gt.set(g, Ct), Ct;
    }
    function uu(g, _, C) {
      return ri(g, !1);
    }
    function cu(g) {
      var _ = g.prototype;
      return !!(_ && _.isReactComponent);
    }
    function Dn(g, _, C) {
      if (g == null)
        return "";
      if (typeof g == "function")
        return ri(g, cu(g));
      if (typeof g == "string")
        return Tt(g);
      switch (g) {
        case c:
          return Tt("Suspense");
        case l:
          return Tt("SuspenseList");
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case u:
            return uu(g.render);
          case d:
            return Dn(g.type, _, C);
          case f: {
            var q = g, ae = q._payload, fe = q._init;
            try {
              return Dn(fe(ae), _, C);
            } catch {
            }
          }
        }
      return "";
    }
    var ln = Object.prototype.hasOwnProperty, si = {}, ii = J.ReactDebugCurrentFrame;
    function $n(g) {
      if (g) {
        var _ = g._owner, C = Dn(g.type, g._source, _ ? _.type : null);
        ii.setExtraStackFrame(C);
      } else
        ii.setExtraStackFrame(null);
    }
    function lu(g, _, C, q, ae) {
      {
        var fe = Function.call.bind(ln);
        for (var re in g)
          if (fe(g, re)) {
            var Q = void 0;
            try {
              if (typeof g[re] != "function") {
                var Ae = Error((q || "React class") + ": " + C + " type `" + re + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof g[re] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ae.name = "Invariant Violation", Ae;
              }
              Q = g[re](_, re, q, C, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (be) {
              Q = be;
            }
            Q && !(Q instanceof Error) && ($n(ae), j("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", q || "React class", C, re, typeof Q), $n(null)), Q instanceof Error && !(Q.message in si) && (si[Q.message] = !0, $n(ae), j("Failed %s type: %s", C, Q.message), $n(null));
          }
      }
    }
    var du = Array.isArray;
    function Br(g) {
      return du(g);
    }
    function fu(g) {
      {
        var _ = typeof Symbol == "function" && Symbol.toStringTag, C = _ && g[Symbol.toStringTag] || g.constructor.name || "Object";
        return C;
      }
    }
    function hu(g) {
      try {
        return oi(g), !1;
      } catch {
        return !0;
      }
    }
    function oi(g) {
      return "" + g;
    }
    function ai(g) {
      if (hu(g))
        return j("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", fu(g)), oi(g);
    }
    var ui = J.ReactCurrentOwner, pu = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ci, li;
    function mu(g) {
      if (ln.call(g, "ref")) {
        var _ = Object.getOwnPropertyDescriptor(g, "ref").get;
        if (_ && _.isReactWarning)
          return !1;
      }
      return g.ref !== void 0;
    }
    function gu(g) {
      if (ln.call(g, "key")) {
        var _ = Object.getOwnPropertyDescriptor(g, "key").get;
        if (_ && _.isReactWarning)
          return !1;
      }
      return g.key !== void 0;
    }
    function vu(g, _) {
      typeof g.ref == "string" && ui.current;
    }
    function yu(g, _) {
      {
        var C = function() {
          ci || (ci = !0, j("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _));
        };
        C.isReactWarning = !0, Object.defineProperty(g, "key", {
          get: C,
          configurable: !0
        });
      }
    }
    function bu(g, _) {
      {
        var C = function() {
          li || (li = !0, j("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _));
        };
        C.isReactWarning = !0, Object.defineProperty(g, "ref", {
          get: C,
          configurable: !0
        });
      }
    }
    var wu = function(g, _, C, q, ae, fe, re) {
      var Q = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: g,
        key: _,
        ref: C,
        props: re,
        // Record the component responsible for creating this element.
        _owner: fe
      };
      return Q._store = {}, Object.defineProperty(Q._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Q, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: q
      }), Object.defineProperty(Q, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ae
      }), Object.freeze && (Object.freeze(Q.props), Object.freeze(Q)), Q;
    };
    function xu(g, _, C, q, ae) {
      {
        var fe, re = {}, Q = null, Ae = null;
        C !== void 0 && (ai(C), Q = "" + C), gu(_) && (ai(_.key), Q = "" + _.key), mu(_) && (Ae = _.ref, vu(_, ae));
        for (fe in _)
          ln.call(_, fe) && !pu.hasOwnProperty(fe) && (re[fe] = _[fe]);
        if (g && g.defaultProps) {
          var be = g.defaultProps;
          for (fe in be)
            re[fe] === void 0 && (re[fe] = be[fe]);
        }
        if (Q || Ae) {
          var xe = typeof g == "function" ? g.displayName || g.name || "Unknown" : g;
          Q && yu(re, xe), Ae && bu(re, xe);
        }
        return wu(g, Q, Ae, ae, q, ui.current, re);
      }
    }
    var Mr = J.ReactCurrentOwner, di = J.ReactDebugCurrentFrame;
    function qt(g) {
      if (g) {
        var _ = g._owner, C = Dn(g.type, g._source, _ ? _.type : null);
        di.setExtraStackFrame(C);
      } else
        di.setExtraStackFrame(null);
    }
    var zr;
    zr = !1;
    function qr(g) {
      return typeof g == "object" && g !== null && g.$$typeof === e;
    }
    function fi() {
      {
        if (Mr.current) {
          var g = ce(Mr.current.type);
          if (g)
            return `

Check the render method of \`` + g + "`.";
        }
        return "";
      }
    }
    function Su(g) {
      return "";
    }
    var hi = {};
    function Ru(g) {
      {
        var _ = fi();
        if (!_) {
          var C = typeof g == "string" ? g : g.displayName || g.name;
          C && (_ = `

Check the top-level render call using <` + C + ">.");
        }
        return _;
      }
    }
    function pi(g, _) {
      {
        if (!g._store || g._store.validated || g.key != null)
          return;
        g._store.validated = !0;
        var C = Ru(_);
        if (hi[C])
          return;
        hi[C] = !0;
        var q = "";
        g && g._owner && g._owner !== Mr.current && (q = " It was passed a child from " + ce(g._owner.type) + "."), qt(g), j('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', C, q), qt(null);
      }
    }
    function mi(g, _) {
      {
        if (typeof g != "object")
          return;
        if (Br(g))
          for (var C = 0; C < g.length; C++) {
            var q = g[C];
            qr(q) && pi(q, _);
          }
        else if (qr(g))
          g._store && (g._store.validated = !0);
        else if (g) {
          var ae = R(g);
          if (typeof ae == "function" && ae !== g.entries)
            for (var fe = ae.call(g), re; !(re = fe.next()).done; )
              qr(re.value) && pi(re.value, _);
        }
      }
    }
    function _u(g) {
      {
        var _ = g.type;
        if (_ == null || typeof _ == "string")
          return;
        var C;
        if (typeof _ == "function")
          C = _.propTypes;
        else if (typeof _ == "object" && (_.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        _.$$typeof === d))
          C = _.propTypes;
        else
          return;
        if (C) {
          var q = ce(_);
          lu(C, g.props, "prop", q, g);
        } else if (_.PropTypes !== void 0 && !zr) {
          zr = !0;
          var ae = ce(_);
          j("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ae || "Unknown");
        }
        typeof _.getDefaultProps == "function" && !_.getDefaultProps.isReactClassApproved && j("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ou(g) {
      {
        for (var _ = Object.keys(g.props), C = 0; C < _.length; C++) {
          var q = _[C];
          if (q !== "children" && q !== "key") {
            qt(g), j("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", q), qt(null);
            break;
          }
        }
        g.ref !== null && (qt(g), j("Invalid attribute `ref` supplied to `React.Fragment`."), qt(null));
      }
    }
    var gi = {};
    function vi(g, _, C, q, ae, fe) {
      {
        var re = Ye(g);
        if (!re) {
          var Q = "";
          (g === void 0 || typeof g == "object" && g !== null && Object.keys(g).length === 0) && (Q += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ae = Su();
          Ae ? Q += Ae : Q += fi();
          var be;
          g === null ? be = "null" : Br(g) ? be = "array" : g !== void 0 && g.$$typeof === e ? (be = "<" + (ce(g.type) || "Unknown") + " />", Q = " Did you accidentally export a JSX literal instead of a component?") : be = typeof g, j("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", be, Q);
        }
        var xe = xu(g, _, C, ae, fe);
        if (xe == null)
          return xe;
        if (re) {
          var Ze = _.children;
          if (Ze !== void 0)
            if (q)
              if (Br(Ze)) {
                for (var Zt = 0; Zt < Ze.length; Zt++)
                  mi(Ze[Zt], g);
                Object.freeze && Object.freeze(Ze);
              } else
                j("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              mi(Ze, g);
        }
        if (ln.call(_, "key")) {
          var Ct = ce(g), Ue = Object.keys(_).filter(function(Pu) {
            return Pu !== "key";
          }), Zr = Ue.length > 0 ? "{key: someKey, " + Ue.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!gi[Ct + Zr]) {
            var ku = Ue.length > 0 ? "{" + Ue.join(": ..., ") + ": ...}" : "{}";
            j(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Zr, Ct, ku, Ct), gi[Ct + Zr] = !0;
          }
        }
        return g === r ? Ou(xe) : _u(xe), xe;
      }
    }
    function Eu(g, _, C) {
      return vi(g, _, C, !0);
    }
    function ju(g, _, C) {
      return vi(g, _, C, !1);
    }
    var Tu = ju, Cu = Eu;
    fn.Fragment = r, fn.jsx = Tu, fn.jsxs = Cu;
  }()), fn;
}
process.env.NODE_ENV === "production" ? hs.exports = wc() : hs.exports = xc();
var m = hs.exports;
function kh({ menuItems: t }) {
  const [e, n] = Hr.useState(null), r = !!e, s = (o) => {
    n(o.currentTarget);
  }, i = () => {
    n(null);
  };
  return /* @__PURE__ */ m.jsxs(Hr.Fragment, { children: [
    /* @__PURE__ */ m.jsx(Ce, { sx: { display: "flex", alignItems: "center", textAlign: "center" }, children: /* @__PURE__ */ m.jsx(Yo, { title: "Account settings", children: /* @__PURE__ */ m.jsx(
      Nu,
      {
        onClick: s,
        size: "small",
        sx: { ml: 2 },
        "aria-controls": r ? "account-menu" : void 0,
        "aria-haspopup": "true",
        "aria-expanded": r ? "true" : void 0,
        children: /* @__PURE__ */ m.jsx(Iu, { sx: { width: 32, height: 32 }, children: /* @__PURE__ */ m.jsx(Du, {}) })
      }
    ) }) }),
    /* @__PURE__ */ m.jsx(
      Lu,
      {
        anchorEl: e,
        id: "account-menu",
        open: r,
        onClose: i,
        onClick: i,
        disableScrollLock: !0,
        slotProps: {
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0
              }
            }
          }
        },
        transformOrigin: { horizontal: "right", vertical: "top" },
        anchorOrigin: { horizontal: "right", vertical: "bottom" },
        children: t.map((o, a) => /* @__PURE__ */ m.jsxs(Hr.Fragment, { children: [
          o.divider && /* @__PURE__ */ m.jsx(Uu, {}),
          o.href ? /* @__PURE__ */ m.jsxs(dr, { component: "a", href: o.href, onClick: i, children: [
            o.icon && /* @__PURE__ */ m.jsx(ds, { children: o.icon }),
            o.text
          ] }) : /* @__PURE__ */ m.jsxs(
            dr,
            {
              onClick: () => {
                var u;
                (u = o.onClick) == null || u.call(o), i();
              },
              children: [
                o.icon && /* @__PURE__ */ m.jsx(ds, { children: o.icon }),
                o.text
              ]
            }
          )
        ] }, a))
      }
    )
  ] });
}
const Sc = 64, Rc = () => typeof __BUILD_ID__ < "u" ? __BUILD_ID__ : "dev", Ph = ({ rightContent: t = null, brandLogo: e = null, sx: n = {} }) => {
  const r = Rc();
  return /* @__PURE__ */ m.jsx($u, { sx: { ...n }, position: "fixed", elevation: 1, children: /* @__PURE__ */ m.jsxs(
    Fu,
    {
      sx: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        pl: 0,
        minHeight: `${Sc}px !important`
      },
      children: [
        e,
        /* @__PURE__ */ m.jsxs(Ce, { sx: { display: "flex", alignItems: "center", gap: 2 }, children: [
          t,
          r && /* @__PURE__ */ m.jsx(
            Ce,
            {
              component: "span",
              "data-testid": "app-version",
              "aria-hidden": "true",
              sx: {
                color: "rgba(255, 255, 255, 0.4)",
                fontFamily: "monospace",
                fontSize: "11px",
                lineHeight: 1,
                whiteSpace: "nowrap",
                userSelect: "none",
                pr: 1
              },
              children: r
            }
          )
        ] })
      ]
    }
  ) });
}, Ah = ({ children: t, sx: e = {} }) => /* @__PURE__ */ m.jsx(
  Ce,
  {
    component: "footer",
    sx: {
      position: "fixed",
      left: 0,
      bottom: 0,
      width: "100%",
      height: "56px",
      borderTop: 1,
      borderColor: "divider",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: (n) => n.zIndex.appBar,
      ...e
    },
    children: t
  }
), _c = 64, Oc = ({ children: t }) => /* @__PURE__ */ m.jsx(
  Ce,
  {
    component: "main",
    sx: {
      p: "20px",
      pb: 0,
      flexGrow: 1,
      mb: "56px",
      // space for footer
      minHeight: `calc(100vh - ${_c}px - 56px)`,
      overflow: "auto"
    },
    children: t || /* @__PURE__ */ m.jsx("div", { children: "MainContent (stub)" })
  }
), Jr = 64, Si = 72, Ec = { xs: 2, sm: 4, md: 8 }, Ih = ({
  appFooterEnabled: t = !0,
  children: e,
  appFooter: n = null,
  appBar: r = null,
  navRail: s = null
}) => /* @__PURE__ */ m.jsxs(Ce, { sx: { minHeight: "100vh", width: "100%" }, children: [
  /* @__PURE__ */ m.jsx(
    Ce,
    {
      sx: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        zIndex: 1300
      },
      children: r
    }
  ),
  /* @__PURE__ */ m.jsxs(
    Ce,
    {
      sx: {
        display: "flex",
        flexDirection: "row",
        pt: `${Jr}px`
      },
      children: [
        s && /* @__PURE__ */ m.jsx(
          Ce,
          {
            sx: {
              width: Si,
              flexShrink: 0,
              position: "fixed",
              height: `calc(100vh - ${Jr}px)`,
              top: Jr,
              left: 0,
              zIndex: 1200
            },
            children: s
          }
        ),
        /* @__PURE__ */ m.jsx(
          Ce,
          {
            sx: {
              flexGrow: 1,
              minWidth: 0,
              ml: s ? `${Si}px` : 0,
              px: Ec
            },
            children: /* @__PURE__ */ m.jsx(Oc, { children: e })
          }
        )
      ]
    }
  ),
  t && n
] });
function Gn({ message: t }) {
  return /* @__PURE__ */ m.jsxs(
    ue,
    {
      sx: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "background.default",
        zIndex: 13e3
        // higher than MUI modal
      },
      children: [
        /* @__PURE__ */ m.jsx(Ln, {}),
        t && /* @__PURE__ */ m.jsx(ze, { variant: "h6", sx: { mt: 2 }, children: t })
      ]
    }
  );
}
const oa = ["/", "/callback", "/logout", "/logged-out"];
function jc(t) {
  return typeof t == "string" && t.startsWith("/") && !oa.includes(t);
}
function Lh({ navigateFunction: t, location: e }) {
  return ye(() => {
    const n = setTimeout(() => {
      const r = localStorage.getItem("redirect_url");
      localStorage.removeItem("redirect_url");
      const s = jc(r) ? r : "/";
      t(s, { replace: !0 });
    }, 500);
    return () => clearTimeout(n);
  }, [t, e]), /* @__PURE__ */ m.jsx(Gn, { message: "Signing you in..." });
}
let aa = !1;
function Uh() {
  aa = !0;
}
function Tc() {
  return aa;
}
function Cc({ children: t }) {
  const e = zt();
  return ye(() => {
    const n = window.location.pathname;
    oa.includes(n) || localStorage.setItem("redirect_url", n);
  }, []), ye(() => {
    !e.isLoading && !e.isAuthenticated && !e.error && !Tc() && e.signinRedirect();
  }, [e.isLoading, e.isAuthenticated, e.error, e]), e.isLoading ? /* @__PURE__ */ m.jsx(Gn, { message: "Loading..." }) : e.error ? /* @__PURE__ */ m.jsx(
    Gn,
    {
      message: `Encountering error... ${e.error.message}`
    }
  ) : e.isAuthenticated ? t : /* @__PURE__ */ m.jsx(Gn, { message: "Redirecting to login..." });
}
function Nh({ cognitoAuthConfig: t, children: e }) {
  return /* @__PURE__ */ m.jsx(Yu, { ...t, children: /* @__PURE__ */ m.jsx(Cc, { children: e }) });
}
const Dh = ({
  onConfirm: t,
  onCancel: e,
  confirmText: n = "Confirm",
  cancelText: r = "Cancel",
  buttonText: s = "Delete",
  buttonIcon: i = /* @__PURE__ */ m.jsx(Xu, {}),
  variant: o = "outlined",
  color: a = "error",
  size: u = "small",
  disabled: c = !1,
  "data-testid": l,
  confirmButtonTestId: d,
  cancelButtonTestId: f
}) => {
  const [p, v] = z(!1), h = () => {
    v(!0);
  }, R = () => {
    v(!1), t();
  }, J = () => {
    v(!1), e && e();
  };
  return p ? /* @__PURE__ */ m.jsxs(ue, { sx: { display: "flex", gap: 1 }, children: [
    /* @__PURE__ */ m.jsx(
      Ie,
      {
        variant: "contained",
        color: a,
        size: u,
        onClick: R,
        "data-testid": d,
        children: n
      }
    ),
    /* @__PURE__ */ m.jsx(
      Ie,
      {
        variant: "outlined",
        size: u,
        onClick: J,
        "data-testid": f,
        children: r
      }
    )
  ] }) : /* @__PURE__ */ m.jsx(
    Ie,
    {
      variant: o,
      color: a,
      size: u,
      startIcon: i,
      onClick: h,
      disabled: c,
      "data-testid": l,
      children: s
    }
  );
};
function $h({
  rows: t = 5,
  columns: e = 1,
  showHeader: n = !0,
  dense: r = !1,
  sx: s,
  ...i
}) {
  const o = r ? 28 : 40, a = r ? 0.75 : 1.25, u = Math.max(1, e), c = (l, d) => /* @__PURE__ */ m.jsx(gr, { direction: "row", spacing: a, sx: { width: "100%" }, children: Array.from({ length: u }).map((f, p) => /* @__PURE__ */ m.jsx(
    mr,
    {
      variant: "rounded",
      height: d,
      sx: { flex: 1, borderRadius: 1 }
    },
    p
  )) }, l);
  return /* @__PURE__ */ m.jsx(
    Ce,
    {
      role: "progressbar",
      "aria-busy": "true",
      "aria-label": "Loading",
      "data-testid": "table-skeleton",
      sx: { width: "100%", ...s },
      ...i,
      children: /* @__PURE__ */ m.jsxs(gr, { spacing: a, children: [
        n && c("header", o * 0.7),
        Array.from({ length: Math.max(1, t) }).map(
          (l, d) => c(`row-${d}`, o)
        )
      ] })
    }
  );
}
function Fh() {
  return /* @__PURE__ */ m.jsxs("div", { children: [
    "You have been logged out. ",
    /* @__PURE__ */ m.jsx("a", { href: "/", children: "Go to home" })
  ] });
}
function Bh({ navigateFunction: t }) {
  const e = zt();
  return ye(() => {
    let n = !0;
    async function r() {
      await e.removeUser(), n && t("/logged-out", { replace: !0 });
    }
    return r(), () => {
      n = !1;
    };
  }, [e, t]), /* @__PURE__ */ m.jsx("div", { children: "You have been logged out." });
}
function Mh({ theme: t, children: e }) {
  return !t || typeof t != "object" ? (console.error("Invalid theme object provided to MuiThemeProvider"), e) : /* @__PURE__ */ m.jsxs(rc, { theme: t, children: [
    /* @__PURE__ */ m.jsx(ic, {}),
    e
  ] });
}
const kc = $s(Ce)(({ theme: t, backgroundColor: e, color: n }) => ({
  width: 72,
  height: "100%",
  backgroundColor: e || t.palette.background.paper,
  color: n || t.palette.text.primary,
  borderRight: `1px solid ${t.palette.divider}`,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  paddingTop: t.spacing(2)
})), zh = ({
  navItems: t,
  backgroundColor: e = "#1a1a1a",
  color: n = "inherit"
}) => {
  const r = [
    {
      icon: /* @__PURE__ */ m.jsx(ta, {}),
      text: "Home",
      onClick: () => {
      }
    },
    {
      icon: /* @__PURE__ */ m.jsx(na, {}),
      text: "Settings",
      onClick: () => {
      }
    }
  ], s = t && t.length > 0 ? t : r;
  return /* @__PURE__ */ m.jsx(kc, { backgroundColor: e, color: n, children: /* @__PURE__ */ m.jsx(oc, { sx: { width: "100%", p: 0 }, children: s.map((i, o) => /* @__PURE__ */ m.jsxs(
    ac,
    {
      onClick: i.onClick,
      sx: {
        flexDirection: "column",
        py: 1,
        px: 0,
        color: "inherit",
        // #582 — nav items are clickable; show the pointer (hand) cursor
        // on hover (ListItem alone doesn't imply a button cursor).
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "transparent",
          opacity: 0.8
        }
      },
      children: [
        /* @__PURE__ */ m.jsx(
          ds,
          {
            sx: {
              minWidth: "auto",
              color: "inherit"
            },
            children: i.icon
          }
        ),
        /* @__PURE__ */ m.jsx(
          uc,
          {
            primary: i.text,
            primaryTypographyProps: {
              variant: "caption",
              align: "center",
              sx: {
                fontSize: "0.7rem",
                mt: 0.5,
                color: "inherit"
              }
            }
          }
        )
      ]
    },
    o
  )) }) });
};
function qh({ children: t }) {
  return zt().isAuthenticated ? t : /* @__PURE__ */ m.jsx(ra, { to: "/callback", replace: !0 });
}
const Zh = ({
  children: t,
  maxWidth: e = 600,
  minWidth: n = 320,
  backTo: r,
  backLabel: s,
  breadcrumbs: i,
  onBack: o
}) => {
  const a = () => {
    o && o();
  };
  return /* @__PURE__ */ m.jsxs(
    ue,
    {
      maxWidth: e,
      minWidth: n,
      mt: 4,
      pb: 8,
      sx: {
        overflowX: "auto"
      },
      children: [
        /* @__PURE__ */ m.jsx(
          ue,
          {
            sx: {
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 2,
              mb: 3
            },
            children: /* @__PURE__ */ m.jsxs(ue, { sx: { display: "flex", alignItems: "center", gap: 2, flex: 1 }, children: [
              r && /* @__PURE__ */ m.jsx(
                Ie,
                {
                  startIcon: /* @__PURE__ */ m.jsx(Qu, {}),
                  onClick: a,
                  variant: "outlined",
                  size: "small",
                  children: s || "Back"
                }
              ),
              i && /* @__PURE__ */ m.jsx(Bu, { separator: "", children: Yt.Children.map(i, (u, c) => {
                const l = Yt.Children.count(i);
                let d = "middle";
                return l === 1 ? d = "single" : c === 0 ? d = "first" : c === l - 1 && (d = "last"), Yt.cloneElement(u, { position: d });
              }) })
            ] })
          }
        ),
        t
      ]
    }
  );
}, et = "12px", Pc = $s(Ce, {
  shouldForwardProp: (t) => t !== "position"
})(({ theme: t, position: e }) => {
  const n = () => {
    switch (e) {
      case "first":
        return `polygon(0 0, 100% 0, calc(100% - ${et}) 100%, 0 100%)`;
      case "middle":
        return `polygon(${et} 0, 100% 0, calc(100% - ${et}) 100%, 0 100%)`;
      case "last":
        return `polygon(${et} 0, calc(100% - ${et}) 0, 100% 50%, calc(100% - ${et}) 100%, 0 100%)`;
      case "single":
      default:
        return `polygon(0 0, calc(100% - ${et}) 0, 100% 50%, calc(100% - ${et}) 100%, 0 100%)`;
    }
  };
  return {
    position: "relative",
    display: "flex",
    alignItems: "center",
    height: "24px",
    backgroundColor: t.palette.mode === "dark" ? t.palette.grey[800] : t.palette.grey[200],
    color: t.palette.getContrastText(
      t.palette.mode === "dark" ? t.palette.grey[800] : t.palette.grey[200]
    ),
    cursor: "pointer",
    textDecoration: "none",
    clipPath: n(),
    // Nudge the items together to overlap
    marginLeft: e === "middle" || e === "last" ? `-${et}` : 0,
    // Adjust padding to make space for the clipped areas
    paddingLeft: e === "middle" || e === "last" ? `calc(${et} + ${t.spacing(1)})` : t.spacing(2),
    paddingRight: `calc(${et} + ${t.spacing(1)})`,
    "&:hover, &:focus-within": {
      backgroundColor: t.palette.mode === "dark" ? t.palette.grey[700] : t.palette.grey[300]
    }
  };
}), Ac = $s(vr)({
  whiteSpace: "nowrap",
  fontSize: "0.8125rem",
  fontWeight: 400,
  color: "inherit"
}), Hh = ({ label: t, component: e = "a", ...n }) => /* @__PURE__ */ m.jsx(Pc, { component: e, ...n, children: /* @__PURE__ */ m.jsx(Ac, { children: t }) }), Wh = ({ onClick: t, label: e, "data-testid": n }) => /* @__PURE__ */ m.jsx(
  Mu,
  {
    onClick: t,
    sx: {
      height: "100%",
      minHeight: 140,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: (r) => r.palette.mode === "dark" ? r.palette.grey[800] : r.palette.grey[200],
      borderRadius: (r) => r.shape.borderRadius,
      padding: 2,
      "&:hover": {
        backgroundColor: (r) => r.palette.mode === "dark" ? r.palette.grey[700] : r.palette.grey[300]
      }
    },
    "data-testid": n || "new-item-card-button",
    children: /* @__PURE__ */ m.jsxs(
      ue,
      {
        sx: {
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          border: "3px dashed",
          borderColor: "grey.500",
          borderRadius: "10px",
          padding: "20px",
          color: "grey.500"
        },
        children: [
          /* @__PURE__ */ m.jsx(
            ue,
            {
              sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 48,
                height: 48,
                borderRadius: "50%",
                border: "3px solid",
                borderColor: "inherit",
                mb: 1
              },
              children: /* @__PURE__ */ m.jsx(ec, { sx: { fontSize: 32 } })
            }
          ),
          /* @__PURE__ */ m.jsx(ze, { variant: "button", component: "span", children: e })
        ]
      }
    )
  }
), Jh = ({ title: t, icon: e, tags: n = [], onEdit: r, showEdit: s, onMembers: i, showMembers: o, "data-testid": a, editButtonTestId: u, membersButtonTestId: c }) => /* @__PURE__ */ m.jsxs(
  fr,
  {
    sx: {
      position: "relative",
      minHeight: 120,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      borderRadius: 0,
      backgroundColor: (l) => l.palette.mode === "dark" ? l.palette.grey[900] : l.palette.background.paper
    },
    "data-testid": a,
    elevation: 1,
    children: [
      /* @__PURE__ */ m.jsx(hr, { sx: { pb: 1 }, children: /* @__PURE__ */ m.jsxs(ue, { sx: { display: "flex", alignItems: "center", mb: 2 }, children: [
        e && Yt.cloneElement(e, { sx: { mr: 1.5, color: "text.secondary" } }),
        /* @__PURE__ */ m.jsx(ze, { variant: "h6", component: "div", noWrap: !0, children: t })
      ] }) }),
      /* @__PURE__ */ m.jsx(hr, { sx: { pt: 0, flexGrow: 1 }, children: /* @__PURE__ */ m.jsx(rn, { direction: "row", spacing: 1, children: n.map((l, d) => /* @__PURE__ */ m.jsx(
        Xo,
        {
          label: l.label,
          color: l.color || "default",
          size: l.size || "small",
          variant: "outlined"
        },
        d
      )) }) }),
      /* @__PURE__ */ m.jsxs(ue, { sx: { position: "absolute", top: 8, right: 8, display: "flex", gap: 0.5 }, children: [
        o && /* @__PURE__ */ m.jsx(
          pr,
          {
            "aria-label": `manage members for ${t}`,
            onClick: i,
            sx: {
              color: "text.secondary"
            },
            "data-testid": c,
            children: /* @__PURE__ */ m.jsx(tc, {})
          }
        ),
        s && /* @__PURE__ */ m.jsx(
          pr,
          {
            "aria-label": `edit ${t}`,
            onClick: r,
            sx: {
              color: "text.secondary"
            },
            "data-testid": u,
            children: /* @__PURE__ */ m.jsx(nc, {})
          }
        )
      ] })
    ]
  }
);
class wn extends Error {
}
wn.prototype.name = "InvalidTokenError";
function Ic(t) {
  return decodeURIComponent(atob(t).replace(/(.)/g, (e, n) => {
    let r = n.charCodeAt(0).toString(16).toUpperCase();
    return r.length < 2 && (r = "0" + r), "%" + r;
  }));
}
function Lc(t) {
  let e = t.replace(/-/g, "+").replace(/_/g, "/");
  switch (e.length % 4) {
    case 0:
      break;
    case 2:
      e += "==";
      break;
    case 3:
      e += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return Ic(e);
  } catch {
    return atob(e);
  }
}
function ua(t, e) {
  if (typeof t != "string")
    throw new wn("Invalid token specified: must be a string");
  e || (e = {});
  const n = e.header === !0 ? 0 : 1, r = t.split(".")[n];
  if (typeof r != "string")
    throw new wn(`Invalid token specified: missing part #${n + 1}`);
  let s;
  try {
    s = Lc(r);
  } catch (i) {
    throw new wn(`Invalid token specified: invalid base64 for part #${n + 1} (${i.message})`);
  }
  try {
    return JSON.parse(s);
  } catch (i) {
    throw new wn(`Invalid token specified: invalid json for part #${n + 1} (${i.message})`);
  }
}
const ps = "common-fe.activeOrgId", Uc = "426e8750-5b55-59f4-90c7-835b46d6a990", Nc = (t) => {
  const e = t.filter((n) => n.id !== Uc);
  return e.length ? e : t;
}, Dc = (t) => {
  if (!t) return !1;
  try {
    const e = ua(t), n = e["custom:super"] ?? e.super;
    return n === "true" || n === !0;
  } catch {
    return !1;
  }
}, ca = Ur({
  orgs: [],
  activeOrgId: null,
  setActiveOrgId: () => {
  },
  loading: !1,
  error: null,
  isSuper: !1
}), $c = () => {
  try {
    return window.localStorage.getItem(ps) || null;
  } catch {
    return null;
  }
}, Fc = (t) => {
  try {
    t ? window.localStorage.setItem(ps, t) : window.localStorage.removeItem(ps);
  } catch {
  }
}, Vh = ({ listOrgs: t, children: e }) => {
  var v;
  const r = (v = zt().user) == null ? void 0 : v.access_token, s = Dc(r), [i, o] = z([]), [a, u] = z(!0), [c, l] = z(null), [d, f] = z(() => $c()), p = Dt((h) => {
    f(h), Fc(h);
  }, []);
  return ye(() => {
    if (!t) {
      u(!1);
      return;
    }
    let h = !1;
    return (async () => {
      try {
        u(!0), l(null);
        const R = await t(s);
        if (h) return;
        o(Nc(Array.isArray(R) ? R : []));
      } catch (R) {
        if (h) return;
        console.error("Failed to load orgs for switcher:", R), l(R), o([]);
      } finally {
        h || u(!1);
      }
    })(), () => {
      h = !0;
    };
  }, [t, s]), ye(() => {
    if (!i.length) return;
    i.some((R) => R.id === d) || p(i[0].id);
  }, [i, d, p]), /* @__PURE__ */ m.jsx(
    ca.Provider,
    {
      value: { orgs: i, activeOrgId: d, setActiveOrgId: p, loading: a, error: c, isSuper: s },
      children: e
    }
  );
}, la = () => Nr(ca), ms = "common-fe.activeShowId", da = Ur({
  shows: [],
  activeShowId: null,
  activeShow: null,
  setActiveShowId: () => {
  },
  loading: !1,
  error: null
}), Bc = () => {
  try {
    return window.localStorage.getItem(ms) || null;
  } catch {
    return null;
  }
}, Mc = (t) => {
  try {
    t ? window.localStorage.setItem(ms, t) : window.localStorage.removeItem(ms);
  } catch {
  }
}, Kh = ({ listShows: t, orgId: e, children: n }) => {
  const [r, s] = z([]), [i, o] = z(!0), [a, u] = z(null), [c, l] = z(() => Bc()), d = Dt((v) => {
    l(v), Mc(v);
  }, []);
  ye(() => {
    if (!t) {
      o(!1);
      return;
    }
    let v = !1;
    return (async () => {
      try {
        o(!0), u(null);
        const h = await t();
        if (v) return;
        s(Array.isArray(h) ? h : []);
      } catch (h) {
        if (v) return;
        console.error("Failed to load shows for switcher:", h), u(h), s([]);
      } finally {
        v || o(!1);
      }
    })(), () => {
      v = !0;
    };
  }, [t, e]), ye(() => {
    if (!r.length) return;
    r.some((h) => h.id === c) || d(r[0].id);
  }, [r, c, d]);
  const f = On(
    () => r.find((v) => v.id === c) || null,
    [r, c]
  ), p = On(
    () => ({ shows: r, activeShowId: c, activeShow: f, setActiveShowId: d, loading: i, error: a }),
    [r, c, f, d, i, a]
  );
  return /* @__PURE__ */ m.jsx(da.Provider, { value: p, children: n });
}, zc = () => Nr(da), Gh = ({ onShowChange: t }) => {
  const { shows: e, activeShowId: n, setActiveShowId: r, loading: s } = zc();
  if (s && !e.length)
    return /* @__PURE__ */ m.jsx(
      mr,
      {
        "data-testid": "show-switcher-loading",
        variant: "rounded",
        width: 140,
        height: 24,
        sx: { bgcolor: "rgba(255,255,255,0.18)" }
      }
    );
  if (!e || e.length === 0) return null;
  const i = (o) => {
    const a = o.target.value;
    r(a), t && t(a);
  };
  return /* @__PURE__ */ m.jsxs(
    Ce,
    {
      "data-testid": "show-switcher",
      sx: { display: "flex", alignItems: "center", gap: 0.75, color: "inherit" },
      children: [
        /* @__PURE__ */ m.jsx(lc, { fontSize: "small", sx: { color: "inherit", opacity: 0.9 } }),
        /* @__PURE__ */ m.jsx(
          sa,
          {
            value: n || "",
            onChange: i,
            variant: "standard",
            disableUnderline: !0,
            inputProps: { "aria-label": "Show switcher" },
            renderValue: (o) => {
              const a = e.find((u) => u.id === o);
              return a ? a.name || a.id : "";
            },
            sx: {
              color: "inherit",
              fontSize: "0.9rem",
              maxWidth: 240,
              "& .MuiSelect-select": { py: 0.25 },
              "& .MuiSelect-icon": { color: "inherit" }
            },
            children: e.map((o) => /* @__PURE__ */ m.jsx(dr, { value: o.id, children: o.name || o.id }, o.id))
          }
        )
      ]
    }
  );
}, fa = Ur({
  appNamespace: null,
  isSuper: !1,
  permissions: /* @__PURE__ */ new Set()
}), qc = (t, e) => typeof e == "string" && e.includes(":") ? e : `${t}:${e}`, Zc = (t) => {
  if (!t) return { isSuper: !1, permissions: /* @__PURE__ */ new Set() };
  try {
    const e = ua(t), n = e["custom:super"] ?? e.super, r = n === "true" || n === !0, s = new Set(
      Array.isArray(e.permissions) ? e.permissions : []
    );
    return { isSuper: r, permissions: s };
  } catch {
    return { isSuper: !1, permissions: /* @__PURE__ */ new Set() };
  }
}, Yh = ({ appNamespace: t, children: e }) => {
  var i;
  const r = (i = zt().user) == null ? void 0 : i.access_token, s = On(() => {
    const { isSuper: o, permissions: a } = Zc(r);
    return { appNamespace: t, isSuper: o, permissions: a };
  }, [t, r]);
  return /* @__PURE__ */ m.jsx(fa.Provider, { value: s, children: e });
}, Xh = (t) => {
  const { appNamespace: e, isSuper: n, permissions: r } = Nr(fa);
  return n ? !0 : r.has(qc(e, t));
}, Hc = (t, e) => t.length > e ? `${t.slice(0, Math.max(0, e - 1))}…` : t;
function Qh({ maxEmailChars: t = 28 }) {
  var u;
  const n = ((u = zt().user) == null ? void 0 : u.profile) || {}, r = (n.given_name || "").trim(), s = (n.family_name || "").trim(), i = [r, s].filter(Boolean).join(" "), o = (n.email || "").trim(), a = i || (o ? Hc(o, t) : "");
  return a ? /* @__PURE__ */ m.jsx(Yo, { title: i || o, children: /* @__PURE__ */ m.jsx(
    vr,
    {
      variant: "body2",
      noWrap: !0,
      "data-testid": "nav-user-name",
      sx: { color: "inherit", maxWidth: 220 },
      children: a
    }
  ) }) : null;
}
const ep = () => {
  const { orgs: t, activeOrgId: e, setActiveOrgId: n, isSuper: r } = la();
  return !t || t.length <= 1 ? null : /* @__PURE__ */ m.jsxs(
    Ce,
    {
      "data-testid": "org-switcher",
      sx: { display: "flex", alignItems: "center", gap: 0.75, color: "inherit" },
      children: [
        r && /* @__PURE__ */ m.jsx(
          ia,
          {
            size: "small",
            "data-testid": "super-badge",
            icon: /* @__PURE__ */ m.jsx(
              fc,
              {
                fontSize: "small",
                sx: { color: "inherit !important" }
              }
            ),
            label: "All orgs",
            sx: {
              color: "inherit",
              bgcolor: "rgba(255, 255, 255, 0.18)",
              fontWeight: 600
            }
          }
        ),
        /* @__PURE__ */ m.jsx(dc, { fontSize: "small", sx: { color: "inherit", opacity: 0.9 } }),
        /* @__PURE__ */ m.jsx(
          sa,
          {
            value: e || "",
            onChange: (s) => n(s.target.value),
            variant: "standard",
            disableUnderline: !0,
            inputProps: { "aria-label": "Organization switcher" },
            renderValue: (s) => {
              const i = t.find((o) => o.id === s);
              return i ? i.name : "";
            },
            sx: {
              color: "inherit",
              fontSize: "0.9rem",
              maxWidth: 220,
              "& .MuiSelect-select": { py: 0.25 },
              "& .MuiSelect-icon": { color: "inherit" }
            },
            children: t.map((s) => /* @__PURE__ */ m.jsx(dr, { value: s.id, children: s.name }, s.id))
          }
        )
      ]
    }
  );
}, ha = "common-fe.mockAuth", pa = Ur(null), Wc = {
  email: "jaybill@foxvillage.com",
  displayName: "Jaybill"
};
function Jc() {
  try {
    const t = localStorage.getItem(ha);
    return t ? JSON.parse(t) : { signedIn: !1, user: null };
  } catch {
    return { signedIn: !1, user: null };
  }
}
function Vc(t) {
  try {
    localStorage.setItem(ha, JSON.stringify(t));
  } catch {
  }
}
function tp({ children: t, defaultUser: e = Wc }) {
  const [n, r] = z(Jc);
  ye(() => {
    Vc(n);
  }, [n]);
  const s = Dt(
    (a) => {
      r({ signedIn: !0, user: a ?? e });
    },
    [e]
  ), i = Dt(() => {
    r({ signedIn: !1, user: null });
  }, []), o = On(
    () => ({
      isAuthenticated: n.signedIn,
      user: n.user,
      signIn: s,
      signOut: i
    }),
    [n, s, i]
  );
  return /* @__PURE__ */ m.jsx(pa.Provider, { value: o, children: t });
}
function ma() {
  const t = Nr(pa);
  if (!t)
    throw new Error("useMockAuth must be used within a MockAuthProvider");
  return t;
}
function np({ children: t, loginPath: e = "/login" }) {
  const { isAuthenticated: n } = ma(), r = cc();
  return n ? t : /* @__PURE__ */ m.jsx(ra, { to: e, replace: !0, state: { from: r.pathname } });
}
const Kc = "jaybill@foxvillage.com", Gc = "demo-password", Yc = {
  heading: "Sign in",
  subheading: "Sign in to your account.",
  emailLabel: "Email address",
  passwordLabel: "Password",
  showPassword: "Show password",
  forgotPassword: "Forgot your password?",
  submit: "Sign in",
  newUserPrompt: "New user?",
  createAccount: "Create an account"
};
function rp({
  onSignIn: t,
  brandLogo: e,
  labels: n = {}
}) {
  const { signIn: r } = ma(), [s, i] = z(Kc), [o, a] = z(Gc), [u, c] = z(!1), l = { ...Yc, ...n }, d = (p) => {
    p.preventDefault();
    const v = { email: s, displayName: s.split("@")[0] };
    t ? t(v) : r(v);
  }, f = e ?? hc;
  return /* @__PURE__ */ m.jsx(
    ue,
    {
      sx: {
        minHeight: "100vh",
        width: "100%",
        bgcolor: (p) => p.palette.mode === "dark" ? "#2a2a2a" : "grey.100",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2
      },
      children: /* @__PURE__ */ m.jsxs(
        fr,
        {
          elevation: 6,
          sx: {
            width: "100%",
            maxWidth: 480,
            p: { xs: 3, sm: 5 },
            bgcolor: (p) => p.palette.mode === "dark" ? "#000" : "background.paper",
            color: (p) => p.palette.mode === "dark" ? "#fff" : "text.primary",
            borderRadius: 3
          },
          children: [
            /* @__PURE__ */ m.jsx(
              ue,
              {
                sx: {
                  display: "flex",
                  justifyContent: "center",
                  mb: 4,
                  color: "inherit"
                },
                children: /* @__PURE__ */ m.jsx(f, { style: { width: 240, height: "auto" } })
              }
            ),
            /* @__PURE__ */ m.jsx(ze, { variant: "h4", component: "h1", fontWeight: 700, gutterBottom: !0, children: l.heading }),
            /* @__PURE__ */ m.jsx(
              ze,
              {
                variant: "body1",
                sx: { opacity: 0.7, mb: 4 },
                children: l.subheading
              }
            ),
            /* @__PURE__ */ m.jsx(ue, { component: "form", onSubmit: d, children: /* @__PURE__ */ m.jsxs(rn, { spacing: 3, children: [
              /* @__PURE__ */ m.jsx(
                En,
                {
                  label: l.emailLabel,
                  type: "email",
                  fullWidth: !0,
                  value: s,
                  onChange: (p) => i(p.target.value),
                  InputLabelProps: {
                    sx: { fontWeight: 600 }
                  }
                }
              ),
              /* @__PURE__ */ m.jsxs(ue, { children: [
                /* @__PURE__ */ m.jsx(
                  En,
                  {
                    label: l.passwordLabel,
                    type: u ? "text" : "password",
                    fullWidth: !0,
                    value: o,
                    onChange: (p) => a(p.target.value),
                    InputLabelProps: {
                      sx: { fontWeight: 600 }
                    }
                  }
                ),
                /* @__PURE__ */ m.jsxs(
                  rn,
                  {
                    direction: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    sx: { mt: 1 },
                    children: [
                      /* @__PURE__ */ m.jsx(
                        Qo,
                        {
                          control: /* @__PURE__ */ m.jsx(
                            ea,
                            {
                              size: "small",
                              checked: u,
                              onChange: (p) => c(p.target.checked),
                              sx: { color: "inherit" }
                            }
                          ),
                          label: l.showPassword
                        }
                      ),
                      /* @__PURE__ */ m.jsx(
                        yi,
                        {
                          component: "button",
                          type: "button",
                          underline: "hover",
                          onClick: () => {
                          },
                          sx: { color: "primary.light" },
                          children: l.forgotPassword
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ m.jsx(
                Ie,
                {
                  type: "submit",
                  variant: "contained",
                  fullWidth: !0,
                  size: "large",
                  sx: { py: 1.5, fontWeight: 600 },
                  children: l.submit
                }
              ),
              /* @__PURE__ */ m.jsxs(
                ze,
                {
                  variant: "body2",
                  align: "center",
                  sx: { opacity: 0.8 },
                  children: [
                    l.newUserPrompt,
                    " ",
                    /* @__PURE__ */ m.jsx(
                      yi,
                      {
                        component: "button",
                        type: "button",
                        underline: "hover",
                        onClick: () => {
                        },
                        sx: { color: "primary.light" },
                        children: l.createAccount
                      }
                    )
                  ]
                }
              )
            ] }) })
          ]
        }
      )
    }
  );
}
var yr = { d: (t, e) => {
  for (var n in e) yr.o(e, n) && !yr.o(t, n) && Object.defineProperty(t, n, { enumerable: !0, get: e[n] });
}, o: (t, e) => Object.prototype.hasOwnProperty.call(t, e), r: (t) => {
  typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
} }, gs = {};
function ga(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
yr.r(gs), yr.d(gs, { hasBrowserEnv: () => Bs, hasStandardBrowserEnv: () => vl, hasStandardBrowserWebWorkerEnv: () => yl, navigator: () => vs, origin: () => bl });
const { toString: Xc } = Object.prototype, { getPrototypeOf: Fs } = Object, { iterator: Yn, toStringTag: va } = Symbol, br = (Vr = /* @__PURE__ */ Object.create(null), (t) => {
  const e = Xc.call(t);
  return Vr[e] || (Vr[e] = e.slice(8, -1).toLowerCase());
});
var Vr;
const rt = (t) => (t = t.toLowerCase(), (e) => br(e) === t), Dr = (t) => (e) => typeof e === t, { isArray: Wt } = Array, Xt = Dr("undefined");
function Rn(t) {
  return t !== null && !Xt(t) && t.constructor !== null && !Xt(t.constructor) && Ne(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const Ri = rt("ArrayBuffer"), Qc = Dr("string"), Ne = Dr("function"), _i = Dr("number"), hn = (t) => t !== null && typeof t == "object", Fn = (t) => {
  if (br(t) !== "object") return !1;
  const e = Fs(t);
  return !(e !== null && e !== Object.prototype && Object.getPrototypeOf(e) !== null || va in t || Yn in t);
}, el = rt("Date"), tl = rt("File"), nl = rt("Blob"), rl = rt("FileList"), sl = rt("URLSearchParams"), [il, ol, al, ul] = ["ReadableStream", "Request", "Response", "Headers"].map(rt);
function xn(t, e, { allOwnKeys: n = !1 } = {}) {
  if (t == null) return;
  let r, s;
  if (typeof t != "object" && (t = [t]), Wt(t)) for (r = 0, s = t.length; r < s; r++) e.call(null, t[r], r, t);
  else {
    if (Rn(t)) return;
    const i = n ? Object.getOwnPropertyNames(t) : Object.keys(t), o = i.length;
    let a;
    for (r = 0; r < o; r++) a = i[r], e.call(null, t[a], a, t);
  }
}
function Oi(t, e) {
  if (Rn(t)) return null;
  e = e.toLowerCase();
  const n = Object.keys(t);
  let r, s = n.length;
  for (; s-- > 0; ) if (r = n[s], e === r.toLowerCase()) return r;
  return null;
}
const kt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Ei = (t) => !Xt(t) && t !== kt, cl = (Kr = typeof Uint8Array < "u" && Fs(Uint8Array), (t) => Kr && t instanceof Kr);
var Kr;
const ll = rt("HTMLFormElement"), ji = (({ hasOwnProperty: t }) => (e, n) => t.call(e, n))(Object.prototype), dl = rt("RegExp"), Ti = (t, e) => {
  const n = Object.getOwnPropertyDescriptors(t), r = {};
  xn(n, (s, i) => {
    let o;
    (o = e(s, i, t)) !== !1 && (r[i] = o || s);
  }), Object.defineProperties(t, r);
}, fl = rt("AsyncFunction"), ya = (Ci = typeof setImmediate == "function", ki = Ne(kt.postMessage), Ci ? setImmediate : ki ? (Gr = `axios@${Math.random()}`, Bn = [], kt.addEventListener("message", ({ source: t, data: e }) => {
  t === kt && e === Gr && Bn.length && Bn.shift()();
}, !1), (t) => {
  Bn.push(t), kt.postMessage(Gr, "*");
}) : (t) => setTimeout(t));
var Ci, ki, Gr, Bn;
const hl = typeof queueMicrotask < "u" ? queueMicrotask.bind(kt) : typeof process < "u" && process.nextTick || ya, y = { isArray: Wt, isArrayBuffer: Ri, isBuffer: Rn, isFormData: (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || Ne(t.append) && ((e = br(t)) === "formdata" || e === "object" && Ne(t.toString) && t.toString() === "[object FormData]"));
}, isArrayBufferView: function(t) {
  let e;
  return e = typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(t) : t && t.buffer && Ri(t.buffer), e;
}, isString: Qc, isNumber: _i, isBoolean: (t) => t === !0 || t === !1, isObject: hn, isPlainObject: Fn, isEmptyObject: (t) => {
  if (!hn(t) || Rn(t)) return !1;
  try {
    return Object.keys(t).length === 0 && Object.getPrototypeOf(t) === Object.prototype;
  } catch {
    return !1;
  }
}, isReadableStream: il, isRequest: ol, isResponse: al, isHeaders: ul, isUndefined: Xt, isDate: el, isFile: tl, isBlob: nl, isRegExp: dl, isFunction: Ne, isStream: (t) => hn(t) && Ne(t.pipe), isURLSearchParams: sl, isTypedArray: cl, isFileList: rl, forEach: xn, merge: function t() {
  const { caseless: e, skipUndefined: n } = Ei(this) && this || {}, r = {}, s = (i, o) => {
    const a = e && Oi(r, o) || o;
    Fn(r[a]) && Fn(i) ? r[a] = t(r[a], i) : Fn(i) ? r[a] = t({}, i) : Wt(i) ? r[a] = i.slice() : n && Xt(i) || (r[a] = i);
  };
  for (let i = 0, o = arguments.length; i < o; i++) arguments[i] && xn(arguments[i], s);
  return r;
}, extend: (t, e, n, { allOwnKeys: r } = {}) => (xn(e, (s, i) => {
  n && Ne(s) ? t[i] = ga(s, n) : t[i] = s;
}, { allOwnKeys: r }), t), trim: (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""), stripBOM: (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), inherits: (t, e, n, r) => {
  t.prototype = Object.create(e.prototype, r), t.prototype.constructor = t, Object.defineProperty(t, "super", { value: e.prototype }), n && Object.assign(t.prototype, n);
}, toFlatObject: (t, e, n, r) => {
  let s, i, o;
  const a = {};
  if (e = e || {}, t == null) return e;
  do {
    for (s = Object.getOwnPropertyNames(t), i = s.length; i-- > 0; ) o = s[i], r && !r(o, t, e) || a[o] || (e[o] = t[o], a[o] = !0);
    t = n !== !1 && Fs(t);
  } while (t && (!n || n(t, e)) && t !== Object.prototype);
  return e;
}, kindOf: br, kindOfTest: rt, endsWith: (t, e, n) => {
  t = String(t), (n === void 0 || n > t.length) && (n = t.length), n -= e.length;
  const r = t.indexOf(e, n);
  return r !== -1 && r === n;
}, toArray: (t) => {
  if (!t) return null;
  if (Wt(t)) return t;
  let e = t.length;
  if (!_i(e)) return null;
  const n = new Array(e);
  for (; e-- > 0; ) n[e] = t[e];
  return n;
}, forEachEntry: (t, e) => {
  const n = (t && t[Yn]).call(t);
  let r;
  for (; (r = n.next()) && !r.done; ) {
    const s = r.value;
    e.call(t, s[0], s[1]);
  }
}, matchAll: (t, e) => {
  let n;
  const r = [];
  for (; (n = t.exec(e)) !== null; ) r.push(n);
  return r;
}, isHTMLForm: ll, hasOwnProperty: ji, hasOwnProp: ji, reduceDescriptors: Ti, freezeMethods: (t) => {
  Ti(t, (e, n) => {
    if (Ne(t) && ["arguments", "caller", "callee"].indexOf(n) !== -1) return !1;
    const r = t[n];
    Ne(r) && (e.enumerable = !1, "writable" in e ? e.writable = !1 : e.set || (e.set = () => {
      throw Error("Can not rewrite read-only method '" + n + "'");
    }));
  });
}, toObjectSet: (t, e) => {
  const n = {}, r = (s) => {
    s.forEach((i) => {
      n[i] = !0;
    });
  };
  return Wt(t) ? r(t) : r(String(t).split(e)), n;
}, toCamelCase: (t) => t.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(e, n, r) {
  return n.toUpperCase() + r;
}), noop: () => {
}, toFiniteNumber: (t, e) => t != null && Number.isFinite(t = +t) ? t : e, findKey: Oi, global: kt, isContextDefined: Ei, isSpecCompliantForm: function(t) {
  return !!(t && Ne(t.append) && t[va] === "FormData" && t[Yn]);
}, toJSONObject: (t) => {
  const e = new Array(10), n = (r, s) => {
    if (hn(r)) {
      if (e.indexOf(r) >= 0) return;
      if (Rn(r)) return r;
      if (!("toJSON" in r)) {
        e[s] = r;
        const i = Wt(r) ? [] : {};
        return xn(r, (o, a) => {
          const u = n(o, s + 1);
          !Xt(u) && (i[a] = u);
        }), e[s] = void 0, i;
      }
    }
    return r;
  };
  return n(t, 0);
}, isAsyncFn: fl, isThenable: (t) => t && (hn(t) || Ne(t)) && Ne(t.then) && Ne(t.catch), setImmediate: ya, asap: hl, isIterable: (t) => t != null && Ne(t[Yn]) };
function Qt(t, e, n, r, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), n && (this.config = n), r && (this.request = r), s && (this.response = s, this.status = s.status ? s.status : null);
}
y.inherits(Qt, Error, { toJSON: function() {
  return { message: this.message, name: this.name, description: this.description, number: this.number, fileName: this.fileName, lineNumber: this.lineNumber, columnNumber: this.columnNumber, stack: this.stack, config: y.toJSONObject(this.config), code: this.code, status: this.status };
} });
const Pi = Qt.prototype, Ai = {};
["ERR_BAD_OPTION_VALUE", "ERR_BAD_OPTION", "ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK", "ERR_FR_TOO_MANY_REDIRECTS", "ERR_DEPRECATED", "ERR_BAD_RESPONSE", "ERR_BAD_REQUEST", "ERR_CANCELED", "ERR_NOT_SUPPORT", "ERR_INVALID_URL"].forEach((t) => {
  Ai[t] = { value: t };
}), Object.defineProperties(Qt, Ai), Object.defineProperty(Pi, "isAxiosError", { value: !0 }), Qt.from = (t, e, n, r, s, i) => {
  const o = Object.create(Pi);
  y.toFlatObject(t, o, function(c) {
    return c !== Error.prototype;
  }, (c) => c !== "isAxiosError");
  const a = t && t.message ? t.message : "Error", u = e == null && t ? t.code : e;
  return Qt.call(o, a, u, n, r, s), t && o.cause == null && Object.defineProperty(o, "cause", { value: t, configurable: !0 }), o.name = t && t.name || "Error", i && Object.assign(o, i), o;
};
const Y = Qt;
function Yr(t) {
  return y.isPlainObject(t) || y.isArray(t);
}
function ba(t) {
  return y.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function Ii(t, e, n) {
  return t ? t.concat(e).map(function(r, s) {
    return r = ba(r), !n && s ? "[" + r + "]" : r;
  }).join(n ? "." : "") : e;
}
const pl = y.toFlatObject(y, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
}), wr = function(t, e, n) {
  if (!y.isObject(t)) throw new TypeError("target must be an object");
  e = e || new FormData();
  const r = (n = y.toFlatObject(n, { metaTokens: !0, dots: !1, indexes: !1 }, !1, function(f, p) {
    return !y.isUndefined(p[f]);
  })).metaTokens, s = n.visitor || c, i = n.dots, o = n.indexes, a = (n.Blob || typeof Blob < "u" && Blob) && y.isSpecCompliantForm(e);
  if (!y.isFunction(s)) throw new TypeError("visitor must be a function");
  function u(f) {
    if (f === null) return "";
    if (y.isDate(f)) return f.toISOString();
    if (y.isBoolean(f)) return f.toString();
    if (!a && y.isBlob(f)) throw new Y("Blob is not supported. Use a Buffer instead.");
    return y.isArrayBuffer(f) || y.isTypedArray(f) ? a && typeof Blob == "function" ? new Blob([f]) : Buffer.from(f) : f;
  }
  function c(f, p, v) {
    let h = f;
    if (f && !v && typeof f == "object") {
      if (y.endsWith(p, "{}")) p = r ? p : p.slice(0, -2), f = JSON.stringify(f);
      else if (y.isArray(f) && function(R) {
        return y.isArray(R) && !R.some(Yr);
      }(f) || (y.isFileList(f) || y.endsWith(p, "[]")) && (h = y.toArray(f))) return p = ba(p), h.forEach(function(R, J) {
        !y.isUndefined(R) && R !== null && e.append(o === !0 ? Ii([p], J, i) : o === null ? p : p + "[]", u(R));
      }), !1;
    }
    return !!Yr(f) || (e.append(Ii(v, p, i), u(f)), !1);
  }
  const l = [], d = Object.assign(pl, { defaultVisitor: c, convertValue: u, isVisitable: Yr });
  if (!y.isObject(t)) throw new TypeError("data must be an object");
  return function f(p, v) {
    if (!y.isUndefined(p)) {
      if (l.indexOf(p) !== -1) throw Error("Circular reference detected in " + v.join("."));
      l.push(p), y.forEach(p, function(h, R) {
        (!(y.isUndefined(h) || h === null) && s.call(e, h, y.isString(R) ? R.trim() : R, v, d)) === !0 && f(h, v ? v.concat(R) : [R]);
      }), l.pop();
    }
  }(t), e;
};
function Li(t) {
  const e = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+", "%00": "\0" };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(n) {
    return e[n];
  });
}
function wa(t, e) {
  this._pairs = [], t && wr(t, this, e);
}
const Ui = wa.prototype;
Ui.append = function(t, e) {
  this._pairs.push([t, e]);
}, Ui.toString = function(t) {
  const e = t ? function(n) {
    return t.call(this, n, Li);
  } : Li;
  return this._pairs.map(function(n) {
    return e(n[0]) + "=" + e(n[1]);
  }, "").join("&");
};
const xa = wa;
function ml(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Sa(t, e, n) {
  if (!e) return t;
  const r = n && n.encode || ml;
  y.isFunction(n) && (n = { serialize: n });
  const s = n && n.serialize;
  let i;
  if (i = s ? s(e, n) : y.isURLSearchParams(e) ? e.toString() : new xa(e, n).toString(r), i) {
    const o = t.indexOf("#");
    o !== -1 && (t = t.slice(0, o)), t += (t.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return t;
}
const Ni = class {
  constructor() {
    this.handlers = [];
  }
  use(e, n, r) {
    return this.handlers.push({ fulfilled: e, rejected: n, synchronous: !!r && r.synchronous, runWhen: r ? r.runWhen : null }), this.handlers.length - 1;
  }
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  clear() {
    this.handlers && (this.handlers = []);
  }
  forEach(e) {
    y.forEach(this.handlers, function(n) {
      n !== null && e(n);
    });
  }
}, Ra = { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 }, gl = { isBrowser: !0, classes: { URLSearchParams: typeof URLSearchParams < "u" ? URLSearchParams : xa, FormData: typeof FormData < "u" ? FormData : null, Blob: typeof Blob < "u" ? Blob : null }, protocols: ["http", "https", "file", "blob", "url", "data"] }, Bs = typeof window < "u" && typeof document < "u", vs = typeof navigator == "object" && navigator || void 0, vl = Bs && (!vs || ["ReactNative", "NativeScript", "NS"].indexOf(vs.product) < 0), yl = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function", bl = Bs && window.location.href || "http://localhost", ke = { ...gs, ...gl }, _a = function(t) {
  function e(n, r, s, i) {
    let o = n[i++];
    if (o === "__proto__") return !0;
    const a = Number.isFinite(+o), u = i >= n.length;
    return o = !o && y.isArray(s) ? s.length : o, u ? (y.hasOwnProp(s, o) ? s[o] = [s[o], r] : s[o] = r, !a) : (s[o] && y.isObject(s[o]) || (s[o] = []), e(n, r, s[o], i) && y.isArray(s[o]) && (s[o] = function(c) {
      const l = {}, d = Object.keys(c);
      let f;
      const p = d.length;
      let v;
      for (f = 0; f < p; f++) v = d[f], l[v] = c[v];
      return l;
    }(s[o])), !a);
  }
  if (y.isFormData(t) && y.isFunction(t.entries)) {
    const n = {};
    return y.forEachEntry(t, (r, s) => {
      e(function(i) {
        return y.matchAll(/\w+|\[(\w*)]/g, i).map((o) => o[0] === "[]" ? "" : o[1] || o[0]);
      }(r), s, n, 0);
    }), n;
  }
  return null;
}, Ms = { transitional: Ra, adapter: ["xhr", "http", "fetch"], transformRequest: [function(t, e) {
  const n = e.getContentType() || "", r = n.indexOf("application/json") > -1, s = y.isObject(t);
  if (s && y.isHTMLForm(t) && (t = new FormData(t)), y.isFormData(t)) return r ? JSON.stringify(_a(t)) : t;
  if (y.isArrayBuffer(t) || y.isBuffer(t) || y.isStream(t) || y.isFile(t) || y.isBlob(t) || y.isReadableStream(t)) return t;
  if (y.isArrayBufferView(t)) return t.buffer;
  if (y.isURLSearchParams(t)) return e.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
  let i;
  if (s) {
    if (n.indexOf("application/x-www-form-urlencoded") > -1) return function(o, a) {
      return wr(o, new ke.classes.URLSearchParams(), { visitor: function(u, c, l, d) {
        return ke.isNode && y.isBuffer(u) ? (this.append(c, u.toString("base64")), !1) : d.defaultVisitor.apply(this, arguments);
      }, ...a });
    }(t, this.formSerializer).toString();
    if ((i = y.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
      const o = this.env && this.env.FormData;
      return wr(i ? { "files[]": t } : t, o && new o(), this.formSerializer);
    }
  }
  return s || r ? (e.setContentType("application/json", !1), function(o) {
    if (y.isString(o)) try {
      return (0, JSON.parse)(o), y.trim(o);
    } catch (a) {
      if (a.name !== "SyntaxError") throw a;
    }
    return (0, JSON.stringify)(o);
  }(t)) : t;
}], transformResponse: [function(t) {
  const e = this.transitional || Ms.transitional, n = e && e.forcedJSONParsing, r = this.responseType === "json";
  if (y.isResponse(t) || y.isReadableStream(t)) return t;
  if (t && y.isString(t) && (n && !this.responseType || r)) {
    const s = !(e && e.silentJSONParsing) && r;
    try {
      return JSON.parse(t, this.parseReviver);
    } catch (i) {
      if (s)
        throw i.name === "SyntaxError" ? Y.from(i, Y.ERR_BAD_RESPONSE, this, null, this.response) : i;
    }
  }
  return t;
}], timeout: 0, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN", maxContentLength: -1, maxBodyLength: -1, env: { FormData: ke.classes.FormData, Blob: ke.classes.Blob }, validateStatus: function(t) {
  return t >= 200 && t < 300;
}, headers: { common: { Accept: "application/json, text/plain, */*", "Content-Type": void 0 } } };
y.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  Ms.headers[t] = {};
});
const zs = Ms, wl = y.toObjectSet(["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"]), Di = Symbol("internals");
function pn(t) {
  return t && String(t).trim().toLowerCase();
}
function Xn(t) {
  return t === !1 || t == null ? t : y.isArray(t) ? t.map(Xn) : String(t);
}
function Xr(t, e, n, r, s) {
  return y.isFunction(r) ? r.call(this, e, n) : (s && (e = n), y.isString(e) ? y.isString(r) ? e.indexOf(r) !== -1 : y.isRegExp(r) ? r.test(e) : void 0 : void 0);
}
let Qn = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, n, r) {
    const s = this;
    function i(a, u, c) {
      const l = pn(u);
      if (!l) throw new Error("header name must be a non-empty string");
      const d = y.findKey(s, l);
      (!d || s[d] === void 0 || c === !0 || c === void 0 && s[d] !== !1) && (s[d || u] = Xn(a));
    }
    const o = (a, u) => y.forEach(a, (c, l) => i(c, l, u));
    if (y.isPlainObject(e) || e instanceof this.constructor) o(e, n);
    else if (y.isString(e) && (e = e.trim()) && !/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim())) o(((a) => {
      const u = {};
      let c, l, d;
      return a && a.split(`
`).forEach(function(f) {
        d = f.indexOf(":"), c = f.substring(0, d).trim().toLowerCase(), l = f.substring(d + 1).trim(), !c || u[c] && wl[c] || (c === "set-cookie" ? u[c] ? u[c].push(l) : u[c] = [l] : u[c] = u[c] ? u[c] + ", " + l : l);
      }), u;
    })(e), n);
    else if (y.isObject(e) && y.isIterable(e)) {
      let a, u, c = {};
      for (const l of e) {
        if (!y.isArray(l)) throw TypeError("Object iterator must return a key-value pair");
        c[u = l[0]] = (a = c[u]) ? y.isArray(a) ? [...a, l[1]] : [a, l[1]] : l[1];
      }
      o(c, n);
    } else e != null && i(n, e, r);
    return this;
  }
  get(e, n) {
    if (e = pn(e)) {
      const r = y.findKey(this, e);
      if (r) {
        const s = this[r];
        if (!n) return s;
        if (n === !0) return function(i) {
          const o = /* @__PURE__ */ Object.create(null), a = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
          let u;
          for (; u = a.exec(i); ) o[u[1]] = u[2];
          return o;
        }(s);
        if (y.isFunction(n)) return n.call(this, s, r);
        if (y.isRegExp(n)) return n.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, n) {
    if (e = pn(e)) {
      const r = y.findKey(this, e);
      return !(!r || this[r] === void 0 || n && !Xr(0, this[r], r, n));
    }
    return !1;
  }
  delete(e, n) {
    const r = this;
    let s = !1;
    function i(o) {
      if (o = pn(o)) {
        const a = y.findKey(r, o);
        !a || n && !Xr(0, r[a], a, n) || (delete r[a], s = !0);
      }
    }
    return y.isArray(e) ? e.forEach(i) : i(e), s;
  }
  clear(e) {
    const n = Object.keys(this);
    let r = n.length, s = !1;
    for (; r--; ) {
      const i = n[r];
      e && !Xr(0, this[i], i, e, !0) || (delete this[i], s = !0);
    }
    return s;
  }
  normalize(e) {
    const n = this, r = {};
    return y.forEach(this, (s, i) => {
      const o = y.findKey(r, i);
      if (o) return n[o] = Xn(s), void delete n[i];
      const a = e ? function(u) {
        return u.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (c, l, d) => l.toUpperCase() + d);
      }(i) : String(i).trim();
      a !== i && delete n[i], n[a] = Xn(s), r[a] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const n = /* @__PURE__ */ Object.create(null);
    return y.forEach(this, (r, s) => {
      r != null && r !== !1 && (n[s] = e && y.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, n]) => e + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...n) {
    const r = new this(e);
    return n.forEach((s) => r.set(s)), r;
  }
  static accessor(e) {
    const n = (this[Di] = this[Di] = { accessors: {} }).accessors, r = this.prototype;
    function s(i) {
      const o = pn(i);
      n[o] || (function(a, u) {
        const c = y.toCamelCase(" " + u);
        ["get", "set", "has"].forEach((l) => {
          Object.defineProperty(a, l + c, { value: function(d, f, p) {
            return this[l].call(this, u, d, f, p);
          }, configurable: !0 });
        });
      }(r, i), n[o] = !0);
    }
    return y.isArray(e) ? e.forEach(s) : s(e), this;
  }
};
Qn.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]), y.reduceDescriptors(Qn.prototype, ({ value: t }, e) => {
  let n = e[0].toUpperCase() + e.slice(1);
  return { get: () => t, set(r) {
    this[n] = r;
  } };
}), y.freezeMethods(Qn);
const tt = Qn;
function Qr(t, e) {
  const n = this || zs, r = e || n, s = tt.from(r.headers);
  let i = r.data;
  return y.forEach(t, function(o) {
    i = o.call(n, i, s.normalize(), e ? e.status : void 0);
  }), s.normalize(), i;
}
function Oa(t) {
  return !(!t || !t.__CANCEL__);
}
function Ea(t, e, n) {
  Y.call(this, t ?? "canceled", Y.ERR_CANCELED, e, n), this.name = "CanceledError";
}
y.inherits(Ea, Y, { __CANCEL__: !0 });
const Un = Ea;
function ja(t, e, n) {
  const r = n.config.validateStatus;
  n.status && r && !r(n.status) ? e(new Y("Request failed with status code " + n.status, [Y.ERR_BAD_REQUEST, Y.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4], n.config, n.request, n)) : t(n);
}
const xr = (t, e, n = 3) => {
  let r = 0;
  const s = function(i, o) {
    i = i || 10;
    const a = new Array(i), u = new Array(i);
    let c, l = 0, d = 0;
    return o = o !== void 0 ? o : 1e3, function(f) {
      const p = Date.now(), v = u[d];
      c || (c = p), a[l] = f, u[l] = p;
      let h = d, R = 0;
      for (; h !== l; ) R += a[h++], h %= i;
      if (l = (l + 1) % i, l === d && (d = (d + 1) % i), p - c < o) return;
      const J = v && p - v;
      return J ? Math.round(1e3 * R / J) : void 0;
    };
  }(50, 250);
  return function(i, o) {
    let a, u, c = 0, l = 1e3 / o;
    const d = (f, p = Date.now()) => {
      c = p, a = null, u && (clearTimeout(u), u = null), i(...f);
    };
    return [(...f) => {
      const p = Date.now(), v = p - c;
      v >= l ? d(f, p) : (a = f, u || (u = setTimeout(() => {
        u = null, d(a);
      }, l - v)));
    }, () => a && d(a)];
  }((i) => {
    const o = i.loaded, a = i.lengthComputable ? i.total : void 0, u = o - r, c = s(u);
    r = o, t({ loaded: o, total: a, progress: a ? o / a : void 0, bytes: u, rate: c || void 0, estimated: c && a && o <= a ? (a - o) / c : void 0, event: i, lengthComputable: a != null, [e ? "download" : "upload"]: !0 });
  }, n);
}, $i = (t, e) => {
  const n = t != null;
  return [(r) => e[0]({ lengthComputable: n, total: t, loaded: r }), e[1]];
}, Fi = (t) => (...e) => y.asap(() => t(...e)), xl = ke.hasStandardBrowserEnv ? /* @__PURE__ */ ((t, e) => (n) => (n = new URL(n, ke.origin), t.protocol === n.protocol && t.host === n.host && (e || t.port === n.port)))(new URL(ke.origin), ke.navigator && /(msie|trident)/i.test(ke.navigator.userAgent)) : () => !0, Sl = ke.hasStandardBrowserEnv ? { write(t, e, n, r, s, i, o) {
  if (typeof document > "u") return;
  const a = [`${t}=${encodeURIComponent(e)}`];
  y.isNumber(n) && a.push(`expires=${new Date(n).toUTCString()}`), y.isString(r) && a.push(`path=${r}`), y.isString(s) && a.push(`domain=${s}`), i === !0 && a.push("secure"), y.isString(o) && a.push(`SameSite=${o}`), document.cookie = a.join("; ");
}, read(t) {
  if (typeof document > "u") return null;
  const e = document.cookie.match(new RegExp("(?:^|; )" + t + "=([^;]*)"));
  return e ? decodeURIComponent(e[1]) : null;
}, remove(t) {
  this.write(t, "", Date.now() - 864e5, "/");
} } : { write() {
}, read: () => null, remove() {
} };
function Ta(t, e, n) {
  let r = !/^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
  return t && (r || n == 0) ? function(s, i) {
    return i ? s.replace(/\/?\/$/, "") + "/" + i.replace(/^\/+/, "") : s;
  }(t, e) : e;
}
const Bi = (t) => t instanceof tt ? { ...t } : t;
function Ft(t, e) {
  e = e || {};
  const n = {};
  function r(c, l, d, f) {
    return y.isPlainObject(c) && y.isPlainObject(l) ? y.merge.call({ caseless: f }, c, l) : y.isPlainObject(l) ? y.merge({}, l) : y.isArray(l) ? l.slice() : l;
  }
  function s(c, l, d, f) {
    return y.isUndefined(l) ? y.isUndefined(c) ? void 0 : r(void 0, c, 0, f) : r(c, l, 0, f);
  }
  function i(c, l) {
    if (!y.isUndefined(l)) return r(void 0, l);
  }
  function o(c, l) {
    return y.isUndefined(l) ? y.isUndefined(c) ? void 0 : r(void 0, c) : r(void 0, l);
  }
  function a(c, l, d) {
    return d in e ? r(c, l) : d in t ? r(void 0, c) : void 0;
  }
  const u = { url: i, method: i, data: i, baseURL: o, transformRequest: o, transformResponse: o, paramsSerializer: o, timeout: o, timeoutMessage: o, withCredentials: o, withXSRFToken: o, adapter: o, responseType: o, xsrfCookieName: o, xsrfHeaderName: o, onUploadProgress: o, onDownloadProgress: o, decompress: o, maxContentLength: o, maxBodyLength: o, beforeRedirect: o, transport: o, httpAgent: o, httpsAgent: o, cancelToken: o, socketPath: o, responseEncoding: o, validateStatus: a, headers: (c, l, d) => s(Bi(c), Bi(l), 0, !0) };
  return y.forEach(Object.keys({ ...t, ...e }), function(c) {
    const l = u[c] || s, d = l(t[c], e[c], c);
    y.isUndefined(d) && l !== a || (n[c] = d);
  }), n;
}
const Ca = (t) => {
  const e = Ft({}, t);
  let { data: n, withXSRFToken: r, xsrfHeaderName: s, xsrfCookieName: i, headers: o, auth: a } = e;
  if (e.headers = o = tt.from(o), e.url = Sa(Ta(e.baseURL, e.url, e.allowAbsoluteUrls), t.params, t.paramsSerializer), a && o.set("Authorization", "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))), y.isFormData(n)) {
    if (ke.hasStandardBrowserEnv || ke.hasStandardBrowserWebWorkerEnv) o.setContentType(void 0);
    else if (y.isFunction(n.getHeaders)) {
      const u = n.getHeaders(), c = ["content-type", "content-length"];
      Object.entries(u).forEach(([l, d]) => {
        c.includes(l.toLowerCase()) && o.set(l, d);
      });
    }
  }
  if (ke.hasStandardBrowserEnv && (r && y.isFunction(r) && (r = r(e)), r || r !== !1 && xl(e.url))) {
    const u = s && i && Sl.read(i);
    u && o.set(s, u);
  }
  return e;
}, Rl = typeof XMLHttpRequest < "u" && function(t) {
  return new Promise(function(e, n) {
    const r = Ca(t);
    let s = r.data;
    const i = tt.from(r.headers).normalize();
    let o, a, u, c, l, { responseType: d, onUploadProgress: f, onDownloadProgress: p } = r;
    function v() {
      c && c(), l && l(), r.cancelToken && r.cancelToken.unsubscribe(o), r.signal && r.signal.removeEventListener("abort", o);
    }
    let h = new XMLHttpRequest();
    function R() {
      if (!h) return;
      const j = tt.from("getAllResponseHeaders" in h && h.getAllResponseHeaders());
      ja(function(W) {
        e(W), v();
      }, function(W) {
        n(W), v();
      }, { data: d && d !== "text" && d !== "json" ? h.response : h.responseText, status: h.status, statusText: h.statusText, headers: j, config: t, request: h }), h = null;
    }
    h.open(r.method.toUpperCase(), r.url, !0), h.timeout = r.timeout, "onloadend" in h ? h.onloadend = R : h.onreadystatechange = function() {
      h && h.readyState === 4 && (h.status !== 0 || h.responseURL && h.responseURL.indexOf("file:") === 0) && setTimeout(R);
    }, h.onabort = function() {
      h && (n(new Y("Request aborted", Y.ECONNABORTED, t, h)), h = null);
    }, h.onerror = function(j) {
      const W = j && j.message ? j.message : "Network Error", L = new Y(W, Y.ERR_NETWORK, t, h);
      L.event = j || null, n(L), h = null;
    }, h.ontimeout = function() {
      let j = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const W = r.transitional || Ra;
      r.timeoutErrorMessage && (j = r.timeoutErrorMessage), n(new Y(j, W.clarifyTimeoutError ? Y.ETIMEDOUT : Y.ECONNABORTED, t, h)), h = null;
    }, s === void 0 && i.setContentType(null), "setRequestHeader" in h && y.forEach(i.toJSON(), function(j, W) {
      h.setRequestHeader(W, j);
    }), y.isUndefined(r.withCredentials) || (h.withCredentials = !!r.withCredentials), d && d !== "json" && (h.responseType = r.responseType), p && ([u, l] = xr(p, !0), h.addEventListener("progress", u)), f && h.upload && ([a, c] = xr(f), h.upload.addEventListener("progress", a), h.upload.addEventListener("loadend", c)), (r.cancelToken || r.signal) && (o = (j) => {
      h && (n(!j || j.type ? new Un(null, t, h) : j), h.abort(), h = null);
    }, r.cancelToken && r.cancelToken.subscribe(o), r.signal && (r.signal.aborted ? o() : r.signal.addEventListener("abort", o)));
    const J = function(j) {
      const W = /^([-+\w]{1,25})(:?\/\/|:)/.exec(j);
      return W && W[1] || "";
    }(r.url);
    J && ke.protocols.indexOf(J) === -1 ? n(new Y("Unsupported protocol " + J + ":", Y.ERR_BAD_REQUEST, t)) : h.send(s || null);
  });
}, _l = (t, e) => {
  const { length: n } = t = t ? t.filter(Boolean) : [];
  if (e || n) {
    let r, s = new AbortController();
    const i = function(c) {
      if (!r) {
        r = !0, a();
        const l = c instanceof Error ? c : this.reason;
        s.abort(l instanceof Y ? l : new Un(l instanceof Error ? l.message : l));
      }
    };
    let o = e && setTimeout(() => {
      o = null, i(new Y(`timeout ${e} of ms exceeded`, Y.ETIMEDOUT));
    }, e);
    const a = () => {
      t && (o && clearTimeout(o), o = null, t.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(i) : c.removeEventListener("abort", i);
      }), t = null);
    };
    t.forEach((c) => c.addEventListener("abort", i));
    const { signal: u } = s;
    return u.unsubscribe = () => y.asap(a), u;
  }
}, Ol = function* (t, e) {
  let n = t.byteLength;
  if (n < e) return void (yield t);
  let r, s = 0;
  for (; s < n; ) r = s + e, yield t.slice(s, r), s = r;
}, Mi = (t, e, n, r) => {
  const s = async function* (u, c) {
    for await (const l of async function* (d) {
      if (d[Symbol.asyncIterator]) return void (yield* d);
      const f = d.getReader();
      try {
        for (; ; ) {
          const { done: p, value: v } = await f.read();
          if (p) break;
          yield v;
        }
      } finally {
        await f.cancel();
      }
    }(u)) yield* Ol(l, c);
  }(t, e);
  let i, o = 0, a = (u) => {
    i || (i = !0, r && r(u));
  };
  return new ReadableStream({ async pull(u) {
    try {
      const { done: c, value: l } = await s.next();
      if (c) return a(), void u.close();
      let d = l.byteLength;
      if (n) {
        let f = o += d;
        n(f);
      }
      u.enqueue(new Uint8Array(l));
    } catch (c) {
      throw a(c), c;
    }
  }, cancel: (u) => (a(u), s.return()) }, { highWaterMark: 2 });
}, { isFunction: Mn } = y, El = (({ Request: t, Response: e }) => ({ Request: t, Response: e }))(y.global), { ReadableStream: zi, TextEncoder: qi } = y.global, Zi = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, jl = (t) => {
  t = y.merge.call({ skipUndefined: !0 }, El, t);
  const { fetch: e, Request: n, Response: r } = t, s = e ? Mn(e) : typeof fetch == "function", i = Mn(n), o = Mn(r);
  if (!s) return !1;
  const a = s && Mn(zi), u = s && (typeof qi == "function" ? (c = new qi(), (p) => c.encode(p)) : async (p) => new Uint8Array(await new n(p).arrayBuffer()));
  var c;
  const l = i && a && Zi(() => {
    let p = !1;
    const v = new n(ke.origin, { body: new zi(), method: "POST", get duplex() {
      return p = !0, "half";
    } }).headers.has("Content-Type");
    return p && !v;
  }), d = o && a && Zi(() => y.isReadableStream(new r("").body)), f = { stream: d && ((p) => p.body) };
  return s && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((p) => {
    !f[p] && (f[p] = (v, h) => {
      let R = v && v[p];
      if (R) return R.call(v);
      throw new Y(`Response type '${p}' is not supported`, Y.ERR_NOT_SUPPORT, h);
    });
  }), async (p) => {
    let { url: v, method: h, data: R, signal: J, cancelToken: j, timeout: W, onDownloadProgress: L, onUploadProgress: ne, responseType: G, headers: Oe, withCredentials: me = "same-origin", fetchOptions: Me } = Ca(p), Ye = e || fetch;
    G = G ? (G + "").toLowerCase() : "text";
    let le = _l([J, j && j.toAbortSignal()], W), Ee = null;
    const ce = le && le.unsubscribe && (() => {
      le.unsubscribe();
    });
    let se;
    try {
      if (ne && l && h !== "get" && h !== "head" && (se = await (async (he, pe) => {
        const je = y.toFiniteNumber(he.getContentLength());
        return je ?? (async (V) => V == null ? 0 : y.isBlob(V) ? V.size : y.isSpecCompliantForm(V) ? (await new n(ke.origin, { method: "POST", body: V }).arrayBuffer()).byteLength : y.isArrayBufferView(V) || y.isArrayBuffer(V) ? V.byteLength : (y.isURLSearchParams(V) && (V += ""), y.isString(V) ? (await u(V)).byteLength : void 0))(pe);
      })(Oe, R)) !== 0) {
        let he, pe = new n(v, { method: "POST", body: R, duplex: "half" });
        if (y.isFormData(R) && (he = pe.headers.get("content-type")) && Oe.setContentType(he), pe.body) {
          const [je, V] = $i(se, xr(Fi(ne)));
          R = Mi(pe.body, 65536, je, V);
        }
      }
      y.isString(me) || (me = me ? "include" : "omit");
      const oe = i && "credentials" in n.prototype, qe = { ...Me, signal: le, method: h.toUpperCase(), headers: Oe.normalize().toJSON(), body: R, duplex: "half", credentials: oe ? me : void 0 };
      Ee = i && new n(v, qe);
      let ve = await (i ? Ye(Ee, Me) : Ye(v, qe));
      const it = d && (G === "stream" || G === "response");
      if (d && (L || it && ce)) {
        const he = {};
        ["status", "statusText", "headers"].forEach((de) => {
          he[de] = ve[de];
        });
        const pe = y.toFiniteNumber(ve.headers.get("content-length")), [je, V] = L && $i(pe, xr(Fi(L), !0)) || [];
        ve = new r(Mi(ve.body, 65536, je, () => {
          V && V(), ce && ce();
        }), he);
      }
      G = G || "text";
      let pt = await f[y.findKey(f, G) || "text"](ve, p);
      return !it && ce && ce(), await new Promise((he, pe) => {
        ja(he, pe, { data: pt, headers: tt.from(ve.headers), status: ve.status, statusText: ve.statusText, config: p, request: Ee });
      });
    } catch (oe) {
      throw ce && ce(), oe && oe.name === "TypeError" && /Load failed|fetch/i.test(oe.message) ? Object.assign(new Y("Network Error", Y.ERR_NETWORK, p, Ee), { cause: oe.cause || oe }) : Y.from(oe, oe && oe.code, p, Ee);
    }
  };
}, Tl = /* @__PURE__ */ new Map(), Hi = (t) => {
  let e = t && t.env || {};
  const { fetch: n, Request: r, Response: s } = e, i = [r, s, n];
  let o, a, u = i.length, c = Tl;
  for (; u--; ) o = i[u], a = c.get(o), a === void 0 && c.set(o, a = u ? /* @__PURE__ */ new Map() : jl(e)), c = a;
  return a;
}, ka = (Hi(), { http: null, xhr: Rl, fetch: { get: Hi } });
y.forEach(ka, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const Wi = (t) => `- ${t}`, Cl = (t) => y.isFunction(t) || t === null || t === !1, Pa = function(t, e) {
  t = y.isArray(t) ? t : [t];
  const { length: n } = t;
  let r, s;
  const i = {};
  for (let o = 0; o < n; o++) {
    let a;
    if (r = t[o], s = r, !Cl(r) && (s = ka[(a = String(r)).toLowerCase()], s === void 0)) throw new Y(`Unknown adapter '${a}'`);
    if (s && (y.isFunction(s) || (s = s.get(e)))) break;
    i[a || "#" + o] = s;
  }
  if (!s) {
    const o = Object.entries(i).map(([u, c]) => `adapter ${u} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build"));
    let a = n ? o.length > 1 ? `since :
` + o.map(Wi).join(`
`) : " " + Wi(o[0]) : "as no adapter specified";
    throw new Y("There is no suitable adapter to dispatch the request " + a, "ERR_NOT_SUPPORT");
  }
  return s;
};
function es(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted) throw new Un(null, t);
}
function Ji(t) {
  return es(t), t.headers = tt.from(t.headers), t.data = Qr.call(t, t.transformRequest), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), Pa(t.adapter || zs.adapter, t)(t).then(function(e) {
    return es(t), e.data = Qr.call(t, t.transformResponse, e), e.headers = tt.from(e.headers), e;
  }, function(e) {
    return Oa(e) || (es(t), e && e.response && (e.response.data = Qr.call(t, t.transformResponse, e.response), e.response.headers = tt.from(e.response.headers))), Promise.reject(e);
  });
}
const Aa = "1.13.2", Sr = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  Sr[t] = function(n) {
    return typeof n === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const Vi = {};
Sr.transitional = function(t, e, n) {
  function r(s, i) {
    return "[Axios v" + Aa + "] Transitional option '" + s + "'" + i + (n ? ". " + n : "");
  }
  return (s, i, o) => {
    if (t === !1) throw new Y(r(i, " has been removed" + (e ? " in " + e : "")), Y.ERR_DEPRECATED);
    return e && !Vi[i] && (Vi[i] = !0, console.warn(r(i, " has been deprecated since v" + e + " and will be removed in the near future"))), !t || t(s, i, o);
  };
}, Sr.spelling = function(t) {
  return (e, n) => (console.warn(`${n} is likely a misspelling of ${t}`), !0);
};
const er = { assertOptions: function(t, e, n) {
  if (typeof t != "object") throw new Y("options must be an object", Y.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(t);
  let s = r.length;
  for (; s-- > 0; ) {
    const i = r[s], o = e[i];
    if (o) {
      const a = t[i], u = a === void 0 || o(a, i, t);
      if (u !== !0) throw new Y("option " + i + " must be " + u, Y.ERR_BAD_OPTION_VALUE);
    } else if (n !== !0) throw new Y("Unknown option " + i, Y.ERR_BAD_OPTION);
  }
}, validators: Sr }, ot = er.validators;
let tr = class {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = { request: new Ni(), response: new Ni() };
  }
  async request(e, n) {
    try {
      return await this._request(e, n);
    } catch (r) {
      if (r instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(e, n) {
    typeof e == "string" ? (n = n || {}).url = e : n = e || {}, n = Ft(this.defaults, n);
    const { transitional: r, paramsSerializer: s, headers: i } = n;
    r !== void 0 && er.assertOptions(r, { silentJSONParsing: ot.transitional(ot.boolean), forcedJSONParsing: ot.transitional(ot.boolean), clarifyTimeoutError: ot.transitional(ot.boolean) }, !1), s != null && (y.isFunction(s) ? n.paramsSerializer = { serialize: s } : er.assertOptions(s, { encode: ot.function, serialize: ot.function }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), er.assertOptions(n, { baseUrl: ot.spelling("baseURL"), withXsrfToken: ot.spelling("withXSRFToken") }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = i && y.merge(i.common, i[n.method]);
    i && y.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (v) => {
      delete i[v];
    }), n.headers = tt.concat(o, i);
    const a = [];
    let u = !0;
    this.interceptors.request.forEach(function(v) {
      typeof v.runWhen == "function" && v.runWhen(n) === !1 || (u = u && v.synchronous, a.unshift(v.fulfilled, v.rejected));
    });
    const c = [];
    let l;
    this.interceptors.response.forEach(function(v) {
      c.push(v.fulfilled, v.rejected);
    });
    let d, f = 0;
    if (!u) {
      const v = [Ji.bind(this), void 0];
      for (v.unshift(...a), v.push(...c), d = v.length, l = Promise.resolve(n); f < d; ) l = l.then(v[f++], v[f++]);
      return l;
    }
    d = a.length;
    let p = n;
    for (; f < d; ) {
      const v = a[f++], h = a[f++];
      try {
        p = v(p);
      } catch (R) {
        h.call(this, R);
        break;
      }
    }
    try {
      l = Ji.call(this, p);
    } catch (v) {
      return Promise.reject(v);
    }
    for (f = 0, d = c.length; f < d; ) l = l.then(c[f++], c[f++]);
    return l;
  }
  getUri(e) {
    return Sa(Ta((e = Ft(this.defaults, e)).baseURL, e.url, e.allowAbsoluteUrls), e.params, e.paramsSerializer);
  }
};
y.forEach(["delete", "get", "head", "options"], function(t) {
  tr.prototype[t] = function(e, n) {
    return this.request(Ft(n || {}, { method: t, url: e, data: (n || {}).data }));
  };
}), y.forEach(["post", "put", "patch"], function(t) {
  function e(n) {
    return function(r, s, i) {
      return this.request(Ft(i || {}, { method: t, headers: n ? { "Content-Type": "multipart/form-data" } : {}, url: r, data: s }));
    };
  }
  tr.prototype[t] = e(), tr.prototype[t + "Form"] = e(!0);
});
const nr = tr;
let kl = class Ia {
  constructor(e) {
    if (typeof e != "function") throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(s) {
      n = s;
    });
    const r = this;
    this.promise.then((s) => {
      if (!r._listeners) return;
      let i = r._listeners.length;
      for (; i-- > 0; ) r._listeners[i](s);
      r._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const o = new Promise((a) => {
        r.subscribe(a), i = a;
      }).then(s);
      return o.cancel = function() {
        r.unsubscribe(i);
      }, o;
    }, e(function(s, i, o) {
      r.reason || (r.reason = new Un(s, i, o), n(r.reason));
    });
  }
  throwIfRequested() {
    if (this.reason) throw this.reason;
  }
  subscribe(e) {
    this.reason ? e(this.reason) : this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  unsubscribe(e) {
    if (!this._listeners) return;
    const n = this._listeners.indexOf(e);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), n = (r) => {
      e.abort(r);
    };
    return this.subscribe(n), e.signal.unsubscribe = () => this.unsubscribe(n), e.signal;
  }
  static source() {
    let e;
    return { token: new Ia(function(n) {
      e = n;
    }), cancel: e };
  }
};
const Pl = kl, ys = { Continue: 100, SwitchingProtocols: 101, Processing: 102, EarlyHints: 103, Ok: 200, Created: 201, Accepted: 202, NonAuthoritativeInformation: 203, NoContent: 204, ResetContent: 205, PartialContent: 206, MultiStatus: 207, AlreadyReported: 208, ImUsed: 226, MultipleChoices: 300, MovedPermanently: 301, Found: 302, SeeOther: 303, NotModified: 304, UseProxy: 305, Unused: 306, TemporaryRedirect: 307, PermanentRedirect: 308, BadRequest: 400, Unauthorized: 401, PaymentRequired: 402, Forbidden: 403, NotFound: 404, MethodNotAllowed: 405, NotAcceptable: 406, ProxyAuthenticationRequired: 407, RequestTimeout: 408, Conflict: 409, Gone: 410, LengthRequired: 411, PreconditionFailed: 412, PayloadTooLarge: 413, UriTooLong: 414, UnsupportedMediaType: 415, RangeNotSatisfiable: 416, ExpectationFailed: 417, ImATeapot: 418, MisdirectedRequest: 421, UnprocessableEntity: 422, Locked: 423, FailedDependency: 424, TooEarly: 425, UpgradeRequired: 426, PreconditionRequired: 428, TooManyRequests: 429, RequestHeaderFieldsTooLarge: 431, UnavailableForLegalReasons: 451, InternalServerError: 500, NotImplemented: 501, BadGateway: 502, ServiceUnavailable: 503, GatewayTimeout: 504, HttpVersionNotSupported: 505, VariantAlsoNegotiates: 506, InsufficientStorage: 507, LoopDetected: 508, NotExtended: 510, NetworkAuthenticationRequired: 511, WebServerIsDown: 521, ConnectionTimedOut: 522, OriginIsUnreachable: 523, TimeoutOccurred: 524, SslHandshakeFailed: 525, InvalidSslCertificate: 526 };
Object.entries(ys).forEach(([t, e]) => {
  ys[e] = t;
});
const Al = ys, Se = function t(e) {
  const n = new nr(e), r = ga(nr.prototype.request, n);
  return y.extend(r, nr.prototype, n, { allOwnKeys: !0 }), y.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(s) {
    return t(Ft(e, s));
  }, r;
}(zs);
Se.Axios = nr, Se.CanceledError = Un, Se.CancelToken = Pl, Se.isCancel = Oa, Se.VERSION = Aa, Se.toFormData = wr, Se.AxiosError = Y, Se.Cancel = Se.CanceledError, Se.all = function(t) {
  return Promise.all(t);
}, Se.spread = function(t) {
  return function(e) {
    return t.apply(null, e);
  };
}, Se.isAxiosError = function(t) {
  return y.isObject(t) && t.isAxiosError === !0;
}, Se.mergeConfig = Ft, Se.AxiosHeaders = tt, Se.formToJSON = (t) => _a(y.isHTMLForm(t) ? new FormData(t) : t), Se.getAdapter = Pa, Se.HttpStatusCode = Al, Se.default = Se;
const _t = Se;
function La(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function bs(t, e, n) {
  return bs = qs() ? Reflect.construct : function(r, s, i) {
    var o = [null];
    o.push.apply(o, s);
    var a = new (Function.bind.apply(r, o))();
    return i && Cn(a, i.prototype), a;
  }, bs.apply(null, arguments);
}
function rr(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function Tn(t) {
  return Tn = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, Tn(t);
}
function Cn(t, e) {
  return Cn = Object.setPrototypeOf || function(n, r) {
    return n.__proto__ = r, n;
  }, Cn(t, e);
}
function ws(t) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return ws = function(n) {
    if (n === null || (r = n, Function.toString.call(r).indexOf("[native code]") === -1)) return n;
    var r;
    if (typeof n != "function") throw new TypeError("Super expression must either be null or a function");
    if (e !== void 0) {
      if (e.has(n)) return e.get(n);
      e.set(n, s);
    }
    function s() {
      return bs(n, arguments, Tn(this).constructor);
    }
    return s.prototype = Object.create(n.prototype, { constructor: { value: s, enumerable: !1, writable: !0, configurable: !0 } }), Cn(s, n);
  }, ws(t);
}
function qs() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (qs = function() {
    return !!t;
  })();
}
var Ot = "http://localhost".replace(/\/+$/, ""), Zs = function t(e) {
  var n, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Ot, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _t;
  La(this, t), rr(this, "basePath", void 0), rr(this, "axios", void 0), rr(this, "configuration", void 0), this.basePath = r, this.axios = s, e && (this.configuration = e, this.basePath = (n = e.basePath) !== null && n !== void 0 ? n : r);
}, Il = function() {
  function t(e, n) {
    var r;
    return La(this, t), rr(r = function(s, i, o) {
      return i = Tn(i), function(a, u) {
        return !u || ((c = u) && typeof Symbol < "u" && c.constructor === Symbol ? "symbol" : typeof c) != "object" && typeof u != "function" ? function(l) {
          if (l === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return l;
        }(a) : u;
        var c;
      }(s, qs() ? Reflect.construct(i, o || [], Tn(s).constructor) : i.apply(s, o));
    }(this, t, [n]), "field", void 0), r.field = e, r.name = "RequiredError", r;
  }
  return function(e, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(n && n.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), n && Cn(e, n);
  }(t, ws(Error)), t;
}(), Pt = {};
function Ki(t, e, n, r, s, i, o) {
  try {
    var a = t[i](o), u = a.value;
  } catch (c) {
    return void n(c);
  }
  a.done ? e(u) : Promise.resolve(u).then(r, s);
}
function Ll(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var At = "https://example.com", xs = function(t, e, n) {
  if (n == null) throw new Il(e, "Required parameter ".concat(e, " was null or undefined when calling ").concat(t, "."));
}, Kt = function(t, e) {
  return (n = function() {
    var r, s;
    return function(i, o) {
      var a, u, c, l = { label: 0, sent: function() {
        if (1 & c[0]) throw c[1];
        return c[1];
      }, trys: [], ops: [] }, d = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
      return d.next = f(0), d.throw = f(1), d.return = f(2), typeof Symbol == "function" && (d[Symbol.iterator] = function() {
        return this;
      }), d;
      function f(p) {
        return function(v) {
          return function(h) {
            if (a) throw new TypeError("Generator is already executing.");
            for (; d && (d = 0, h[0] && (l = 0)), l; ) try {
              if (a = 1, u && (c = 2 & h[0] ? u.return : h[0] ? u.throw || ((c = u.return) && c.call(u), 0) : u.next) && !(c = c.call(u, h[1])).done) return c;
              switch (u = 0, c && (h = [2 & h[0], c.value]), h[0]) {
                case 0:
                case 1:
                  c = h;
                  break;
                case 4:
                  return l.label++, { value: h[1], done: !1 };
                case 5:
                  l.label++, u = h[1], h = [0];
                  continue;
                case 7:
                  h = l.ops.pop(), l.trys.pop();
                  continue;
                default:
                  if (!((c = (c = l.trys).length > 0 && c[c.length - 1]) || h[0] !== 6 && h[0] !== 2)) {
                    l = 0;
                    continue;
                  }
                  if (h[0] === 3 && (!c || h[1] > c[0] && h[1] < c[3])) {
                    l.label = h[1];
                    break;
                  }
                  if (h[0] === 6 && l.label < c[1]) {
                    l.label = c[1], c = h;
                    break;
                  }
                  if (c && l.label < c[2]) {
                    l.label = c[2], l.ops.push(h);
                    break;
                  }
                  c[2] && l.ops.pop(), l.trys.pop();
                  continue;
              }
              h = o.call(i, l);
            } catch (R) {
              h = [6, R], u = 0;
            } finally {
              a = c = 0;
            }
            if (5 & h[0]) throw h[1];
            return { value: h[0] ? h[1] : void 0, done: !0 };
          }([p, v]);
        };
      }
    }(this, function(i) {
      switch (i.label) {
        case 0:
          return e && e.accessToken ? typeof e.accessToken != "function" ? [3, 2] : [4, e.accessToken()] : [3, 5];
        case 1:
          return s = i.sent(), [3, 4];
        case 2:
          return [4, e.accessToken];
        case 3:
          s = i.sent(), i.label = 4;
        case 4:
          r = s, t.Authorization = "Bearer " + r, i.label = 5;
        case 5:
          return [2];
      }
    });
  }, function() {
    var r = this, s = arguments;
    return new Promise(function(i, o) {
      var a = n.apply(r, s);
      function u(l) {
        Ki(a, i, o, u, c, "next", l);
      }
      function c(l) {
        Ki(a, i, o, u, c, "throw", l);
      }
      u(void 0);
    });
  })();
  var n;
};
function Ss(t, e) {
  var n, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  e != null && ((e === void 0 ? "undefined" : (n = e) && typeof Symbol < "u" && n.constructor === Symbol ? "symbol" : typeof n) == "object" ? Array.isArray(e) ? e.forEach(function(s) {
    return Ss(t, s, r);
  }) : Object.keys(e).forEach(function(s) {
    return Ss(t, e[s], "".concat(r).concat(r !== "" ? "." : "").concat(s));
  }) : t.has(r) ? t.append(r, e) : t.set(r, e));
}
var It = function(t) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++) n[r - 1] = arguments[r];
  var s = new URLSearchParams(t.search);
  Ss(s, n), t.search = s.toString();
}, Lt = function(t) {
  return t.pathname + t.search + t.hash;
}, Ut = function(t, e, n, r) {
  return function() {
    var s, i, o, a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : e, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : n, c = (i = function(l) {
      for (var d = 1; d < arguments.length; d++) {
        var f = arguments[d] != null ? arguments[d] : {}, p = Object.keys(f);
        typeof Object.getOwnPropertySymbols == "function" && (p = p.concat(Object.getOwnPropertySymbols(f).filter(function(v) {
          return Object.getOwnPropertyDescriptor(f, v).enumerable;
        }))), p.forEach(function(v) {
          Ll(l, v, f[v]);
        });
      }
      return l;
    }({}, t.options), o = (o = { url: (a.defaults.baseURL ? "" : (s = r == null ? void 0 : r.basePath) !== null && s !== void 0 ? s : u) + t.url }) != null ? o : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(o)) : function(l) {
      var d = Object.keys(l);
      if (Object.getOwnPropertySymbols) {
        var f = Object.getOwnPropertySymbols(l);
        d.push.apply(d, f);
      }
      return d;
    }(Object(o)).forEach(function(l) {
      Object.defineProperty(i, l, Object.getOwnPropertyDescriptor(o, l));
    }), i);
    return a.request(c);
  };
};
function Gi(t, e, n, r, s, i, o) {
  try {
    var a = t[i](o), u = a.value;
  } catch (c) {
    return void n(c);
  }
  a.done ? e(u) : Promise.resolve(u).then(r, s);
}
function Fe(t) {
  return function() {
    var e = this, n = arguments;
    return new Promise(function(r, s) {
      var i = t.apply(e, n);
      function o(u) {
        Gi(i, r, s, o, a, "next", u);
      }
      function a(u) {
        Gi(i, r, s, o, a, "throw", u);
      }
      o(void 0);
    });
  };
}
function Hs(t, e, n) {
  return e = Rr(e), function(r, s) {
    return !s || ((i = s) && typeof Symbol < "u" && i.constructor === Symbol ? "symbol" : typeof i) != "object" && typeof s != "function" ? function(o) {
      if (o === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return o;
    }(r) : s;
    var i;
  }(t, Ua() ? Reflect.construct(e, n || [], Rr(t).constructor) : e.apply(t, n));
}
function Ws(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function Ul(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function Js(t, e, n) {
  return e && Ul(t.prototype, e), t;
}
function Nl(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function Rr(t) {
  return Rr = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, Rr(t);
}
function Vs(t, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Rs(t, e);
}
function $e(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(s) {
      return Object.getOwnPropertyDescriptor(n, s).enumerable;
    }))), r.forEach(function(s) {
      Nl(t, s, n[s]);
    });
  }
  return t;
}
function Rs(t, e) {
  return Rs = Object.setPrototypeOf || function(n, r) {
    return n.__proto__ = r, n;
  }, Rs(t, e);
}
function Ua() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Ua = function() {
    return !!t;
  })();
}
function Be(t, e) {
  var n, r, s, i = { label: 0, sent: function() {
    if (1 & s[0]) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = a(0), o.throw = a(1), o.return = a(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(c) {
      return function(l) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; o && (o = 0, l[0] && (i = 0)), i; ) try {
          if (n = 1, r && (s = 2 & l[0] ? r.return : l[0] ? r.throw || ((s = r.return) && s.call(r), 0) : r.next) && !(s = s.call(r, l[1])).done) return s;
          switch (r = 0, s && (l = [2 & l[0], s.value]), l[0]) {
            case 0:
            case 1:
              s = l;
              break;
            case 4:
              return i.label++, { value: l[1], done: !1 };
            case 5:
              i.label++, r = l[1], l = [0];
              continue;
            case 7:
              l = i.ops.pop(), i.trys.pop();
              continue;
            default:
              if (!((s = (s = i.trys).length > 0 && s[s.length - 1]) || l[0] !== 6 && l[0] !== 2)) {
                i = 0;
                continue;
              }
              if (l[0] === 3 && (!s || l[1] > s[0] && l[1] < s[3])) {
                i.label = l[1];
                break;
              }
              if (l[0] === 6 && i.label < s[1]) {
                i.label = s[1], s = l;
                break;
              }
              if (s && i.label < s[2]) {
                i.label = s[2], i.ops.push(l);
                break;
              }
              s[2] && i.ops.pop(), i.trys.pop();
              continue;
          }
          l = e.call(t, i);
        } catch (d) {
          l = [6, d], r = 0;
        } finally {
          n = s = 0;
        }
        if (5 & l[0]) throw l[1];
        return { value: l[0] ? l[1] : void 0, done: !0 };
      }([u, c]);
    };
  }
}
var Dl = function(t) {
  return { getHealth: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return Fe(function() {
      var n, r, s, i, o;
      return Be(this, function(a) {
        return n = new URL("/health", At), t && (r = t.baseOptions), s = $e({ method: "GET" }, r, e), i = {}, It(n, {}), o = r && r.headers ? r.headers : {}, s.headers = $e({}, i, o, e.headers), [2, { url: Lt(n), options: s }];
      });
    })();
  } };
}, $l = function(t) {
  var e = Dl(t);
  return { getHealth: function(n) {
    return Fe(function() {
      var r, s, i, o, a, u;
      return Be(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, e.getHealth(n)];
          case 1:
            return i = c.sent(), a = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, u = (s = Pt["HealthApi.getHealth"]) === null || s === void 0 || (r = s[a]) === null || r === void 0 ? void 0 : r.url, [2, function(l, d) {
              return Ut(i, _t, Ot, t)(l, u || d);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ws(this, e), Hs(this, e, arguments);
  }
  return Vs(e, t), Js(e, [{ key: "getHealth", value: function(n) {
    var r = this;
    return $l(this.configuration).getHealth(n).then(function(s) {
      return s(r.axios, r.basePath);
    });
  } }]), e;
})(Zs);
var Fl = function(t) {
  return { createReportRun: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return Fe(function() {
      var s, i, o, a, u, c, l;
      return Be(this, function(d) {
        switch (d.label) {
          case 0:
            return xs("createReportRun", "id", e), s = "/reports/{id}/runs".replace("{id}", encodeURIComponent(String(e))), i = new URL(s, At), t && (o = t.baseOptions), a = $e({ method: "POST" }, o, r), c = {}, [4, Kt(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", It(i, c), l = o && o.headers ? o.headers : {}, a.headers = $e({}, u, l, r.headers), a.data = function(f, p, v) {
              var h = typeof f != "string";
              return (h && v && v.isJsonMime ? v.isJsonMime(p.headers["Content-Type"]) : h) ? JSON.stringify(f !== void 0 ? f : {}) : f || "";
            }(n, a, t), [2, { url: Lt(i), options: a }];
        }
      });
    })();
  }, listReports: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return Fe(function() {
      var r, s, i, o, a, u;
      return Be(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/reports", At), t && (s = t.baseOptions), i = $e({ method: "GET" }, s, n), a = {}, [4, Kt(o = {}, t)];
          case 1:
            return c.sent(), e !== void 0 && (a.domain = e), It(r, a), u = s && s.headers ? s.headers : {}, i.headers = $e({}, o, u, n.headers), [2, { url: Lt(r), options: i }];
        }
      });
    })();
  } };
}, Yi = function(t) {
  var e = Fl(t);
  return { createReportRun: function(n, r, s) {
    return Fe(function() {
      var i, o, a, u, c, l;
      return Be(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.createReportRun(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = Pt["ReportsApi.createReportRun"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, p) {
              return Ut(a, _t, Ot, t)(f, l || p);
            }];
        }
      });
    })();
  }, listReports: function(n, r) {
    return Fe(function() {
      var s, i, o, a, u, c;
      return Be(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.listReports(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = Pt["ReportsApi.listReports"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return Ut(o, _t, Ot, t)(d, c || f);
            }];
        }
      });
    })();
  } };
}, Bl = function(t) {
  function e() {
    return Ws(this, e), Hs(this, e, arguments);
  }
  return Vs(e, t), Js(e, [{ key: "createReportRun", value: function(n, r, s) {
    var i = this;
    return Yi(this.configuration).createReportRun(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "listReports", value: function(n, r) {
    var s = this;
    return Yi(this.configuration).listReports(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }]), e;
}(Zs), Ml = function(t) {
  return { clearRuns: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return Fe(function() {
      var r, s, i, o, a, u;
      return Be(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/runs", At), t && (s = t.baseOptions), i = $e({ method: "DELETE" }, s, n), a = {}, [4, Kt(o = {}, t)];
          case 1:
            return c.sent(), e !== void 0 && (a.reportId = e), It(r, a), u = s && s.headers ? s.headers : {}, i.headers = $e({}, o, u, n.headers), [2, { url: Lt(r), options: i }];
        }
      });
    })();
  }, deleteRun: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return Fe(function() {
      var r, s, i, o, a, u, c;
      return Be(this, function(l) {
        switch (l.label) {
          case 0:
            return xs("deleteRun", "id", e), r = "/runs/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, At), t && (i = t.baseOptions), o = $e({ method: "DELETE" }, i, n), u = {}, [4, Kt(a = {}, t)];
          case 1:
            return l.sent(), It(s, u), c = i && i.headers ? i.headers : {}, o.headers = $e({}, a, c, n.headers), [2, { url: Lt(s), options: o }];
        }
      });
    })();
  }, getRun: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return Fe(function() {
      var r, s, i, o, a, u, c;
      return Be(this, function(l) {
        switch (l.label) {
          case 0:
            return xs("getRun", "id", e), r = "/runs/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, At), t && (i = t.baseOptions), o = $e({ method: "GET" }, i, n), u = {}, [4, Kt(a = {}, t)];
          case 1:
            return l.sent(), It(s, u), c = i && i.headers ? i.headers : {}, o.headers = $e({}, a, c, n.headers), [2, { url: Lt(s), options: o }];
        }
      });
    })();
  }, listRuns: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return Fe(function() {
      var r, s, i, o, a, u;
      return Be(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/runs", At), t && (s = t.baseOptions), i = $e({ method: "GET" }, s, n), a = {}, [4, Kt(o = {}, t)];
          case 1:
            return c.sent(), e !== void 0 && (a.reportId = e), It(r, a), u = s && s.headers ? s.headers : {}, i.headers = $e({}, o, u, n.headers), [2, { url: Lt(r), options: i }];
        }
      });
    })();
  } };
}, zn = function(t) {
  var e = Ml(t);
  return { clearRuns: function(n, r) {
    return Fe(function() {
      var s, i, o, a, u, c;
      return Be(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.clearRuns(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = Pt["RunsApi.clearRuns"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return Ut(o, _t, Ot, t)(d, c || f);
            }];
        }
      });
    })();
  }, deleteRun: function(n, r) {
    return Fe(function() {
      var s, i, o, a, u, c;
      return Be(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.deleteRun(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = Pt["RunsApi.deleteRun"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return Ut(o, _t, Ot, t)(d, c || f);
            }];
        }
      });
    })();
  }, getRun: function(n, r) {
    return Fe(function() {
      var s, i, o, a, u, c;
      return Be(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getRun(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = Pt["RunsApi.getRun"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return Ut(o, _t, Ot, t)(d, c || f);
            }];
        }
      });
    })();
  }, listRuns: function(n, r) {
    return Fe(function() {
      var s, i, o, a, u, c;
      return Be(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.listRuns(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = Pt["RunsApi.listRuns"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return Ut(o, _t, Ot, t)(d, c || f);
            }];
        }
      });
    })();
  } };
}, zl = function(t) {
  function e() {
    return Ws(this, e), Hs(this, e, arguments);
  }
  return Vs(e, t), Js(e, [{ key: "clearRuns", value: function(n, r) {
    var s = this;
    return zn(this.configuration).clearRuns(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "deleteRun", value: function(n, r) {
    var s = this;
    return zn(this.configuration).deleteRun(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getRun", value: function(n, r) {
    var s = this;
    return zn(this.configuration).getRun(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listRuns", value: function(n, r) {
    var s = this;
    return zn(this.configuration).listRuns(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }]), e;
}(Zs);
function ql(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function vt(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function Xi(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(s) {
      return Object.getOwnPropertyDescriptor(n, s).enumerable;
    }))), r.forEach(function(s) {
      vt(t, s, n[s]);
    });
  }
  return t;
}
var Zl = function() {
  function t() {
    var r, s, i, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (function(a, u) {
      if (!(a instanceof u)) throw new TypeError("Cannot call a class as a function");
    })(this, t), vt(this, "apiKey", void 0), vt(this, "username", void 0), vt(this, "password", void 0), vt(this, "accessToken", void 0), vt(this, "basePath", void 0), vt(this, "serverIndex", void 0), vt(this, "baseOptions", void 0), vt(this, "formDataCtor", void 0), this.apiKey = o.apiKey, this.username = o.username, this.password = o.password, this.accessToken = o.accessToken, this.basePath = o.basePath, this.serverIndex = o.serverIndex, this.baseOptions = (s = Xi({}, o.baseOptions), i = (i = { headers: Xi({}, (r = o.baseOptions) === null || r === void 0 ? void 0 : r.headers) }) != null ? i : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(i)) : function(a) {
      var u = Object.keys(a);
      if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(a);
        u.push.apply(u, c);
      }
      return u;
    }(Object(i)).forEach(function(a) {
      Object.defineProperty(s, a, Object.getOwnPropertyDescriptor(i, a));
    }), s), this.formDataCtor = o.formDataCtor;
  }
  var e, n;
  return e = t, (n = [{ key: "isJsonMime", value: function(r) {
    var s = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return r !== null && (s.test(r) || r.toLowerCase() === "application/json-patch+json");
  } }]) && ql(e.prototype, n), t;
}();
function Hl() {
  var r;
  const t = zt(), { activeOrgId: e } = la(), n = (r = t.user) == null ? void 0 : r.access_token;
  return Dt(
    (s) => ({
      basePath: s,
      accessToken: n,
      baseOptions: e ? { headers: { "X-Org-Id": e } } : void 0
    }),
    [n, e]
  );
}
function Wl(t) {
  const e = Hl();
  return On(() => {
    const n = new Zl(e(t));
    return {
      reports: new Bl(n),
      runs: new zl(n)
    };
  }, [e, t]);
}
function en(t) {
  var n;
  const e = t == null ? void 0 : t.data;
  if (!e || e.status !== "success") {
    const r = ((n = e == null ? void 0 : e.data) == null ? void 0 : n.message) || (e == null ? void 0 : e.code) || "Request failed";
    throw new Error(r);
  }
  return e.data;
}
const Jl = {
  empty: "No reports available.",
  error: "Failed to load reports"
}, Vl = (t) => (t == null ? void 0 : t.name) ?? "";
function Kl({
  api: t,
  domain: e,
  onSelect: n,
  selectedId: r,
  // #579 — when set, auto-select this def once (deep-link from another page).
  autoSelectId: s,
  labels: i = {},
  resolveReportName: o = Vl
}) {
  const a = { ...Jl, ...i }, [u, c] = z([]), [l, d] = z(!0), [f, p] = z(null), v = $t(!1);
  return ye(() => {
    if (v.current || !s || u.length === 0) return;
    const h = u.find((R) => R.id === s);
    h && (v.current = !0, n == null || n(h));
  }, [u, s, n]), ye(() => {
    let h = !1;
    return d(!0), p(null), t.reports.listReports(e).then((R) => {
      h || c(en(R) || []);
    }).catch((R) => {
      h || p(R.message || a.error);
    }).finally(() => {
      h || d(!1);
    }), () => {
      h = !0;
    };
  }, [t, e, a.error]), l ? /* @__PURE__ */ m.jsx(ue, { sx: { display: "flex", justifyContent: "center", p: 3 }, children: /* @__PURE__ */ m.jsx(Ln, { "data-testid": "report-list-loading" }) }) : f ? /* @__PURE__ */ m.jsx(jn, { severity: "error", children: f }) : u.length === 0 ? /* @__PURE__ */ m.jsx(ze, { color: "text.secondary", sx: { p: 2 }, children: a.empty }) : /* @__PURE__ */ m.jsx(zu, { "data-testid": "report-list", children: u.map((h) => /* @__PURE__ */ m.jsx(
    qu,
    {
      selected: h.id === r,
      onClick: () => n == null ? void 0 : n(h),
      children: /* @__PURE__ */ m.jsx(
        Zu,
        {
          primary: o(h),
          primaryTypographyProps: { color: "text.primary" }
        }
      )
    },
    h.id
  )) });
}
function Gl(t) {
  return t.default !== void 0 ? t.default : t.type === "boolean" ? !1 : "";
}
const mn = (t) => t !== "" && t !== void 0 && t !== null, Yl = {
  submit: "Run report",
  required: "Required"
}, Xl = (t, e, n) => (n == null ? void 0 : n.title) || e;
function Ql({
  def: t,
  onSubmit: e,
  submitting: n = !1,
  labels: r = {},
  // #551 — `context` supplies values for fields the surface knows (e.g. showId
  // from the active show); those fields are auto-filled + hidden, not typed.
  // `fieldRenderers` overrides how a specific field renders (e.g. day/ring as
  // dropdowns, classId/rideId as a lookup) — keyed by the param name; each gets
  // { value, onChange, label, required, error, disabled }.
  context: s = {},
  fieldRenderers: i = {},
  resolveParamLabel: o = Xl
}) {
  var j, W;
  const a = { ...Yl, ...r }, u = ((j = t == null ? void 0 : t.paramsSchema) == null ? void 0 : j.properties) || {}, c = ((W = t == null ? void 0 : t.paramsSchema) == null ? void 0 : W.required) || [], l = Object.entries(u).filter(([L]) => !mn(s[L])), [d, f] = z(() => {
    const L = {};
    for (const [ne, G] of Object.entries(u))
      mn(s[ne]) || (L[ne] = Gl(G));
    return L;
  }), [p, v] = z(!1), h = (L, ne) => f((G) => ({ ...G, [L]: ne })), R = c.filter((L) => mn(s[L]) ? !1 : !mn(d[L])), J = (L) => {
    if (L.preventDefault(), v(!0), R.length > 0) return;
    const ne = {};
    for (const [G, Oe] of Object.entries(u)) {
      if (mn(s[G])) {
        ne[G] = s[G];
        continue;
      }
      const me = d[G];
      me === "" && !c.includes(G) || (ne[G] = Oe.type === "number" || Oe.type === "integer" ? Number(me) : me);
    }
    e(ne);
  };
  return /* @__PURE__ */ m.jsx(ue, { component: "form", onSubmit: J, noValidate: !0, children: /* @__PURE__ */ m.jsxs(rn, { spacing: 2, children: [
    l.map(([L, ne]) => {
      const G = o(t, L, ne), Oe = c.includes(L), me = p && Oe && R.includes(L), Me = i[L];
      if (Me)
        return /* @__PURE__ */ m.jsx(Au, { children: Me({
          value: d[L],
          onChange: (le) => h(L, le),
          label: G,
          required: Oe,
          error: me,
          disabled: n
        }) }, L);
      if (ne.type === "boolean")
        return /* @__PURE__ */ m.jsx(
          Qo,
          {
            control: /* @__PURE__ */ m.jsx(
              ea,
              {
                color: "default",
                checked: !!d[L],
                onChange: (le) => h(L, le.target.checked)
              }
            ),
            label: G
          },
          L
        );
      if (Array.isArray(ne.enum))
        return /* @__PURE__ */ m.jsx(
          En,
          {
            select: !0,
            label: G,
            required: Oe,
            error: me,
            helperText: me ? a.required : ne.description,
            value: d[L] ?? "",
            onChange: (le) => h(L, le.target.value),
            fullWidth: !0,
            children: ne.enum.map((le) => /* @__PURE__ */ m.jsx(Hu, { value: le, children: String(le) }, String(le)))
          },
          L
        );
      const Ye = ne.type === "number" || ne.type === "integer";
      return /* @__PURE__ */ m.jsx(
        En,
        {
          label: G,
          type: Ye ? "number" : "text",
          required: Oe,
          error: me,
          helperText: me ? a.required : ne.description,
          value: d[L] ?? "",
          onChange: (le) => h(L, le.target.value),
          fullWidth: !0
        },
        L
      );
    }),
    /* @__PURE__ */ m.jsx(ue, { children: /* @__PURE__ */ m.jsx(Ie, { type: "submit", variant: "contained", loading: n, children: a.submit }) })
  ] }) });
}
const ed = /* @__PURE__ */ new Set(["PENDING", "RUNNING"]), td = {
  COMPLETE: "success",
  FAILED: "error",
  RUNNING: "info",
  PENDING: "warning"
};
function nd(t) {
  if (!t) return "";
  const e = new Date(t);
  return isNaN(e.getTime()) ? t : e.toLocaleString();
}
const rd = {
  empty: "No runs yet.",
  error: "Failed to load runs",
  colReport: "Report",
  colRequested: "Requested",
  colStatus: "Status",
  colActions: "Actions",
  view: "View",
  delete: "Delete"
}, sd = (t) => t;
function id({
  api: t,
  onView: e,
  onDelete: n,
  refreshKey: r = 0,
  labels: s = {},
  resolveReportName: i = sd
}) {
  const o = { ...rd, ...s }, [a, u] = z([]), [c, l] = z(!0), [d, f] = z(null), p = $t(null), v = Dt(async () => {
    try {
      const h = await t.runs.listRuns();
      u(en(h) || []), f(null);
    } catch (h) {
      f(h.message || o.error);
    } finally {
      l(!1);
    }
  }, [t, o.error]);
  return ye(() => {
    v();
  }, [v, r]), ye(() => {
    if (!a.some((R) => ed.has(R.status))) {
      p.current && clearInterval(p.current), p.current = null;
      return;
    }
    return p.current || (p.current = setInterval(v, 4e3)), () => {
      p.current && (clearInterval(p.current), p.current = null);
    };
  }, [a, v]), c ? /* @__PURE__ */ m.jsx(ue, { sx: { display: "flex", justifyContent: "center", p: 3 }, children: /* @__PURE__ */ m.jsx(Ln, { "data-testid": "run-history-loading" }) }) : d ? /* @__PURE__ */ m.jsx(jn, { severity: "error", children: d }) : a.length === 0 ? /* @__PURE__ */ m.jsx(ze, { color: "text.secondary", sx: { p: 2 }, children: o.empty }) : /* @__PURE__ */ m.jsxs(Wu, { size: "small", "data-testid": "run-history", children: [
    /* @__PURE__ */ m.jsx(Ju, { children: /* @__PURE__ */ m.jsxs(bi, { children: [
      /* @__PURE__ */ m.jsx(xt, { children: o.colReport }),
      /* @__PURE__ */ m.jsx(xt, { children: o.colRequested }),
      /* @__PURE__ */ m.jsx(xt, { children: o.colStatus }),
      /* @__PURE__ */ m.jsx(xt, { align: "right", children: o.colActions })
    ] }) }),
    /* @__PURE__ */ m.jsx(Vu, { children: a.map((h) => /* @__PURE__ */ m.jsxs(bi, { "data-testid": `run-row-${h.id}`, children: [
      /* @__PURE__ */ m.jsx(xt, { sx: { color: "text.primary" }, children: i(h.reportId) }),
      /* @__PURE__ */ m.jsx(xt, { sx: { color: "text.primary" }, children: nd(h.createdAt) }),
      /* @__PURE__ */ m.jsx(xt, { children: /* @__PURE__ */ m.jsx(
        Xo,
        {
          size: "small",
          label: h.status,
          color: td[h.status] || "default"
        }
      ) }),
      /* @__PURE__ */ m.jsxs(xt, { align: "right", children: [
        /* @__PURE__ */ m.jsx(
          Ie,
          {
            size: "small",
            variant: "outlined",
            color: "inherit",
            disabled: h.status !== "COMPLETE",
            onClick: () => e == null ? void 0 : e(h),
            children: o.view
          }
        ),
        n && /* @__PURE__ */ m.jsx(
          pr,
          {
            size: "small",
            color: "inherit",
            "aria-label": o.delete,
            title: o.delete,
            sx: { ml: 1 },
            onClick: () => n(h),
            children: /* @__PURE__ */ m.jsx(pc, { fontSize: "small" })
          }
        )
      ] })
    ] }, h.id)) })
  ] });
}
const od = {
  failed: "This run failed to render.",
  notReady: "Report is not ready yet.",
  error: "Failed to load report",
  openPdf: "Open PDF",
  openHtml: "Open HTML in new tab",
  preview: "Report preview"
};
function ad({ api: t, runId: e, height: n = 600, labels: r = {} }) {
  const s = { ...od, ...r }, [i, o] = z(null), [a, u] = z(!0), [c, l] = z(null);
  return ye(() => {
    if (!e) return;
    let d = !1;
    return u(!0), l(null), t.runs.getRun(e).then((f) => {
      if (d) return;
      const p = en(f);
      if (p.status !== "COMPLETE" || !p.artifactUrls) {
        l(p.status === "FAILED" ? s.failed : s.notReady);
        return;
      }
      o(p.artifactUrls);
    }).catch((f) => {
      d || l(f.message || s.error);
    }).finally(() => {
      d || u(!1);
    }), () => {
      d = !0;
    };
  }, [t, e, s.error, s.failed, s.notReady]), e ? a ? /* @__PURE__ */ m.jsx(ue, { sx: { display: "flex", justifyContent: "center", p: 3 }, children: /* @__PURE__ */ m.jsx(Ln, { "data-testid": "report-viewer-loading" }) }) : c ? /* @__PURE__ */ m.jsx(jn, { severity: "error", children: c }) : i ? /* @__PURE__ */ m.jsxs(rn, { spacing: 1, "data-testid": "report-viewer", children: [
    /* @__PURE__ */ m.jsxs(rn, { direction: "row", spacing: 1, children: [
      i.pdf && /* @__PURE__ */ m.jsx(Ie, { variant: "outlined", href: i.pdf, target: "_blank", rel: "noopener", children: s.openPdf }),
      i.html && /* @__PURE__ */ m.jsx(Ie, { variant: "text", href: i.html, target: "_blank", rel: "noopener", children: s.openHtml })
    ] }),
    i.html && /* @__PURE__ */ m.jsx(
      ue,
      {
        component: "iframe",
        "data-testid": "report-viewer-frame",
        title: s.preview,
        src: i.html,
        sx: { width: "100%", height: n, border: 1, borderColor: "divider", borderRadius: 1, bgcolor: "#fff" }
      }
    )
  ] }) : null : null;
}
const ud = {
  title: "Reports",
  availableReports: "Available reports",
  runHistory: "Run history",
  reportDialogTitle: "Report",
  reportStarted: "Report started — open Run history to view it when ready.",
  failedToStart: "Failed to start report",
  // #609 — run-progress modal
  runningTitle: "Running report…",
  runningMessage: "Your report is being generated. It will download automatically when it's ready — or close this and find it in Run history.",
  runningDoneTitle: "Report ready",
  runningDoneMessage: "Your report has downloaded. It's also in Run history.",
  runningFailedTitle: "Report failed",
  download: "Download",
  close: "Close",
  // #606 — clear old runs
  clearHistory: "Clear history",
  clearConfirm: "Delete all report runs for this organization? This removes the generated files too and can't be undone.",
  delete: "Delete",
  // ReportList
  noReports: "No reports available.",
  failedToLoadReports: "Failed to load reports",
  // ReportParamsForm
  runReport: "Run report",
  required: "Required",
  // RunHistory
  noRuns: "No runs yet.",
  failedToLoadRuns: "Failed to load runs",
  colReport: "Report",
  colRequested: "Requested",
  colStatus: "Status",
  colActions: "Actions",
  view: "View",
  // ReportViewer
  runFailed: "This run failed to render.",
  runNotReady: "Report is not ready yet.",
  failedToLoadReport: "Failed to load report",
  openPdf: "Open PDF",
  openHtml: "Open HTML in new tab",
  reportPreview: "Report preview"
}, cd = (t) => (t == null ? void 0 : t.name) ?? (t == null ? void 0 : t.id) ?? "", ld = (t, e, n) => (n == null ? void 0 : n.title) || e;
function Qi(t) {
  const e = document.createElement("a");
  e.href = t, e.target = "_blank", e.rel = "noopener", e.download = "", document.body.appendChild(e), e.click(), e.remove();
}
function ap({
  basePath: t,
  domain: e,
  // Back-compat: an explicit `title` still wins; otherwise labels.title is used.
  title: n,
  // #602 — translated chrome strings from the mounting app (see DEFAULT_LABELS).
  labels: r = {},
  // #551 — a surface can supply context values (e.g. showId from the active
  // show) and custom field renderers (day/ring dropdowns, class/ride lookups)
  // forwarded to the params form. `paramsFieldRenderers` may be a plain map or
  // a function of the selected def (so renderers can depend on the def).
  paramsContext: s = {},
  paramsFieldRenderers: i = {},
  // #579 — a surface can deep-link to a specific report (e.g. from a ride page);
  // the matching def is auto-selected once the list loads.
  initialSelectedId: o,
  // #649 — see defaultResolveReportName/defaultResolveParamLabel above.
  resolveReportName: a = cd,
  resolveParamLabel: u = ld
}) {
  var je, V;
  const c = { ...ud, ...r }, l = Wl(t), [d, f] = z(null), [p, v] = z(!1), [h, R] = z(null), [J, j] = z(0), [W, L] = z(""), [ne, G] = z(null), [Oe, me] = z({});
  ye(() => {
    let de = !1;
    return l.reports.listReports(e).then((Te) => {
      if (de) return;
      const Xe = {};
      for (const mt of en(Te) || []) Xe[mt.id] = mt;
      me(Xe);
    }).catch(() => {
    }), () => {
      de = !0;
    };
  }, [l, e]);
  const Me = (de) => {
    var Te;
    return a({ id: de, name: (Te = Oe[de]) == null ? void 0 : Te.name });
  }, [Ye, le] = z(!1), [Ee, ce] = z(null), [se, oe] = z(null), qe = $t(!1), ve = async (de) => {
    if (d) {
      v(!0), R(null);
      try {
        const Te = en(await l.reports.createReportRun(d.id, { params: de }));
        j((Xe) => Xe + 1), f(null), qe.current = !1, oe(Te), ce(Te.id);
      } catch (Te) {
        R(Te.message || c.failedToStart);
      } finally {
        v(!1);
      }
    }
  };
  ye(() => {
    if (!Ee) return;
    let de = !1, Te;
    const Xe = async () => {
      var mt, Tt;
      try {
        const Qe = en(await l.runs.getRun(Ee));
        if (de) return;
        if (oe(Qe), Qe.status === "COMPLETE") {
          j((Fr) => Fr + 1);
          const gt = ((mt = Qe.artifactUrls) == null ? void 0 : mt.pdf) || ((Tt = Qe.artifactUrls) == null ? void 0 : Tt.html);
          gt && !qe.current && (qe.current = !0, Qi(gt));
          return;
        }
        if (Qe.status === "FAILED") {
          j((gt) => gt + 1);
          return;
        }
        Te = setTimeout(Xe, 3e3);
      } catch {
        de || oe((Qe) => ({ ...Qe || {}, status: "FAILED" }));
      }
    };
    return Te = setTimeout(Xe, 1200), () => {
      de = !0, clearTimeout(Te);
    };
  }, [Ee, l]);
  const [it, pt] = z(!1), he = async () => {
    if (!(typeof window < "u" && !window.confirm(c.clearConfirm))) {
      pt(!0);
      try {
        await l.runs.clearRuns(), j((de) => de + 1);
      } finally {
        pt(!1);
      }
    }
  }, pe = async (de) => {
    await l.runs.deleteRun(de.id), j((Te) => Te + 1);
  };
  return /* @__PURE__ */ m.jsxs(ue, { children: [
    /* @__PURE__ */ m.jsx(ze, { variant: "h5", sx: { mb: 2, color: "text.primary" }, children: n ?? c.title }),
    /* @__PURE__ */ m.jsxs(ue, { sx: { display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 2, alignItems: "flex-start" }, children: [
      /* @__PURE__ */ m.jsx(ue, { sx: { width: { xs: "100%", md: 340 }, flexShrink: 0 }, children: /* @__PURE__ */ m.jsx(fr, { variant: "outlined", children: /* @__PURE__ */ m.jsxs(hr, { children: [
        /* @__PURE__ */ m.jsx(ze, { variant: "subtitle1", sx: { color: "text.primary" }, children: c.availableReports }),
        /* @__PURE__ */ m.jsx(
          Kl,
          {
            api: l,
            domain: e,
            selectedId: d == null ? void 0 : d.id,
            autoSelectId: o,
            onSelect: f,
            labels: { empty: c.noReports, error: c.failedToLoadReports },
            resolveReportName: a
          }
        ),
        /* @__PURE__ */ m.jsx(
          Ie,
          {
            fullWidth: !0,
            variant: "text",
            sx: { mt: 1, justifyContent: "flex-start" },
            onClick: () => le(!0),
            children: c.runHistory
          }
        )
      ] }) }) }),
      /* @__PURE__ */ m.jsx(ue, { sx: { flex: 1, minWidth: 0, width: "100%" }, children: d && /* @__PURE__ */ m.jsx(fr, { variant: "outlined", sx: { mb: 2 }, children: /* @__PURE__ */ m.jsxs(hr, { children: [
        /* @__PURE__ */ m.jsx(ze, { variant: "subtitle1", sx: { color: "text.primary" }, children: a(d) }),
        /* @__PURE__ */ m.jsx(Ku, { sx: { my: 1 } }),
        h && /* @__PURE__ */ m.jsx(jn, { severity: "error", sx: { mb: 2 }, children: h }),
        /* @__PURE__ */ m.jsx(
          Ql,
          {
            def: d,
            onSubmit: ve,
            submitting: p,
            labels: { submit: c.runReport, required: c.required },
            context: s,
            fieldRenderers: typeof i == "function" ? i(d) : i,
            resolveParamLabel: u
          }
        )
      ] }) }) })
    ] }),
    /* @__PURE__ */ m.jsxs(Vn, { open: Ye, onClose: () => le(!1), maxWidth: "md", fullWidth: !0, children: [
      /* @__PURE__ */ m.jsx(Wr, { children: c.runHistory }),
      /* @__PURE__ */ m.jsx(Kn, { children: /* @__PURE__ */ m.jsx(
        id,
        {
          api: l,
          refreshKey: J,
          onView: (de) => G(de.id),
          onDelete: pe,
          labels: {
            empty: c.noRuns,
            error: c.failedToLoadRuns,
            colReport: c.colReport,
            colRequested: c.colRequested,
            colStatus: c.colStatus,
            colActions: c.colActions,
            view: c.view,
            delete: c.delete
          },
          resolveReportName: Me
        }
      ) }),
      /* @__PURE__ */ m.jsxs(fs, { children: [
        /* @__PURE__ */ m.jsx(Ie, { color: "error", onClick: he, disabled: it, children: c.clearHistory }),
        /* @__PURE__ */ m.jsx(Ie, { color: "inherit", onClick: () => le(!1), children: c.close })
      ] })
    ] }),
    /* @__PURE__ */ m.jsxs(Vn, { open: !!ne, onClose: () => G(null), maxWidth: "lg", fullWidth: !0, children: [
      /* @__PURE__ */ m.jsx(Wr, { children: c.reportDialogTitle }),
      /* @__PURE__ */ m.jsx(Kn, { children: /* @__PURE__ */ m.jsx(
        ad,
        {
          api: l,
          runId: ne,
          labels: {
            failed: c.runFailed,
            notReady: c.runNotReady,
            error: c.failedToLoadReport,
            openPdf: c.openPdf,
            openHtml: c.openHtml,
            preview: c.reportPreview
          }
        }
      ) })
    ] }),
    /* @__PURE__ */ m.jsxs(Vn, { open: !!Ee, onClose: () => ce(null), maxWidth: "xs", fullWidth: !0, children: [
      /* @__PURE__ */ m.jsx(Wr, { children: (se == null ? void 0 : se.status) === "COMPLETE" ? c.runningDoneTitle : (se == null ? void 0 : se.status) === "FAILED" ? c.runningFailedTitle : c.runningTitle }),
      /* @__PURE__ */ m.jsx(Kn, { children: (se == null ? void 0 : se.status) === "FAILED" ? /* @__PURE__ */ m.jsx(jn, { severity: "error", children: c.runFailed }) : (se == null ? void 0 : se.status) === "COMPLETE" ? /* @__PURE__ */ m.jsx(ze, { sx: { color: "text.primary" }, children: c.runningDoneMessage }) : /* @__PURE__ */ m.jsxs(ue, { sx: { display: "flex", alignItems: "center", gap: 2, py: 1 }, children: [
        /* @__PURE__ */ m.jsx(Ln, { size: 26, color: "inherit" }),
        /* @__PURE__ */ m.jsx(ze, { sx: { color: "text.primary" }, children: c.runningMessage })
      ] }) }),
      /* @__PURE__ */ m.jsxs(fs, { children: [
        (se == null ? void 0 : se.status) === "COMPLETE" && (((je = se.artifactUrls) == null ? void 0 : je.pdf) || ((V = se.artifactUrls) == null ? void 0 : V.html)) && // #609 — brand primary is darkGrey (invisible as a text button on
        // dark); a contained button + inherit-colored Close stay legible
        // in both light and dark.
        /* @__PURE__ */ m.jsx(
          Ie,
          {
            variant: "contained",
            onClick: () => Qi(se.artifactUrls.pdf || se.artifactUrls.html),
            children: c.download
          }
        ),
        /* @__PURE__ */ m.jsx(Ie, { color: "inherit", onClick: () => ce(null), children: c.close })
      ] })
    ] }),
    /* @__PURE__ */ m.jsx(
      Gu,
      {
        open: !!W,
        autoHideDuration: 5e3,
        onClose: () => L(""),
        message: W
      }
    )
  ] });
}
var _r = { d: (t, e) => {
  for (var n in e) _r.o(e, n) && !_r.o(t, n) && Object.defineProperty(t, n, { enumerable: !0, get: e[n] });
}, o: (t, e) => Object.prototype.hasOwnProperty.call(t, e), r: (t) => {
  typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
} }, _s = {};
_r.r(_s), _r.d(_s, { hasBrowserEnv: () => Xs, hasStandardBrowserEnv: () => af, hasStandardBrowserWebWorkerEnv: () => uf, navigator: () => As, origin: () => cf });
var Na = ["C", "E", "M", "B", "H"], qn = { PENDING: "PENDING", IN_PROGRESS: "IN_PROGRESS", COMPLETED: "COMPLETED", SCRATCHED: "SCRATCHED" }, Da = { BLOOD: "BLOOD", LAMENESS: "LAMENESS" }, eo = { POINTS: "POINTS", PERCENT_SENIOR: "PERCENT_SENIOR", PERCENT_YOUTH: "PERCENT_YOUTH" }, $a = 10, Ht = { PENDING: qn.PENDING, IN_PROGRESS: qn.IN_PROGRESS, CONFIRMED: "CONFIRMED", COMPLETED: qn.COMPLETED, FINAL: "FINAL", SCRATCHED: qn.SCRATCHED }, ie, to;
(function(t) {
  t.assertEqual = (e) => {
  }, t.assertIs = function(e) {
  }, t.assertNever = function(e) {
    throw new Error();
  }, t.arrayToEnum = (e) => {
    const n = {};
    for (const r of e) n[r] = r;
    return n;
  }, t.getValidEnumValues = (e) => {
    const n = t.objectKeys(e).filter((s) => typeof e[e[s]] != "number"), r = {};
    for (const s of n) r[s] = e[s];
    return t.objectValues(r);
  }, t.objectValues = (e) => t.objectKeys(e).map(function(n) {
    return e[n];
  }), t.objectKeys = typeof Object.keys == "function" ? (e) => Object.keys(e) : (e) => {
    const n = [];
    for (const r in e) Object.prototype.hasOwnProperty.call(e, r) && n.push(r);
    return n;
  }, t.find = (e, n) => {
    for (const r of e) if (n(r)) return r;
  }, t.isInteger = typeof Number.isInteger == "function" ? (e) => Number.isInteger(e) : (e) => typeof e == "number" && Number.isFinite(e) && Math.floor(e) === e, t.joinValues = function(e, n = " | ") {
    return e.map((r) => typeof r == "string" ? `'${r}'` : r).join(n);
  }, t.jsonStringifyReplacer = (e, n) => typeof n == "bigint" ? n.toString() : n;
})(ie || (ie = {})), function(t) {
  t.mergeShapes = (e, n) => ({ ...e, ...n });
}(to || (to = {}));
const k = ie.arrayToEnum(["string", "nan", "number", "integer", "float", "boolean", "date", "bigint", "symbol", "function", "undefined", "null", "array", "object", "unknown", "promise", "void", "never", "map", "set"]), Rt = (t) => {
  switch (typeof t) {
    case "undefined":
      return k.undefined;
    case "string":
      return k.string;
    case "number":
      return Number.isNaN(t) ? k.nan : k.number;
    case "boolean":
      return k.boolean;
    case "function":
      return k.function;
    case "bigint":
      return k.bigint;
    case "symbol":
      return k.symbol;
    case "object":
      return Array.isArray(t) ? k.array : t === null ? k.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? k.promise : typeof Map < "u" && t instanceof Map ? k.map : typeof Set < "u" && t instanceof Set ? k.set : typeof Date < "u" && t instanceof Date ? k.date : k.object;
    default:
      return k.unknown;
  }
}, E = ie.arrayToEnum(["invalid_type", "invalid_literal", "custom", "invalid_union", "invalid_union_discriminator", "invalid_enum_value", "unrecognized_keys", "invalid_arguments", "invalid_return_type", "invalid_date", "invalid_string", "too_small", "too_big", "invalid_intersection_types", "not_multiple_of", "not_finite"]);
class wt extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const n = e || function(i) {
      return i.message;
    }, r = { _errors: [] }, s = (i) => {
      for (const o of i.issues) if (o.code === "invalid_union") o.unionErrors.map(s);
      else if (o.code === "invalid_return_type") s(o.returnTypeError);
      else if (o.code === "invalid_arguments") s(o.argumentsError);
      else if (o.path.length === 0) r._errors.push(n(o));
      else {
        let a = r, u = 0;
        for (; u < o.path.length; ) {
          const c = o.path[u];
          u === o.path.length - 1 ? (a[c] = a[c] || { _errors: [] }, a[c]._errors.push(n(o))) : a[c] = a[c] || { _errors: [] }, a = a[c], u++;
        }
      }
    };
    return s(this), r;
  }
  static assert(e) {
    if (!(e instanceof wt)) throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, ie.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (n) => n.message) {
    const n = {}, r = [];
    for (const s of this.issues) if (s.path.length > 0) {
      const i = s.path[0];
      n[i] = n[i] || [], n[i].push(e(s));
    } else r.push(e(s));
    return { formErrors: r, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
wt.create = (t) => new wt(t);
const Os = (t, e) => {
  let n;
  switch (t.code) {
    case E.invalid_type:
      n = t.received === k.undefined ? "Required" : `Expected ${t.expected}, received ${t.received}`;
      break;
    case E.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(t.expected, ie.jsonStringifyReplacer)}`;
      break;
    case E.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${ie.joinValues(t.keys, ", ")}`;
      break;
    case E.invalid_union:
      n = "Invalid input";
      break;
    case E.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${ie.joinValues(t.options)}`;
      break;
    case E.invalid_enum_value:
      n = `Invalid enum value. Expected ${ie.joinValues(t.options)}, received '${t.received}'`;
      break;
    case E.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case E.invalid_return_type:
      n = "Invalid function return type";
      break;
    case E.invalid_date:
      n = "Invalid date";
      break;
    case E.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (n = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? n = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? n = `Invalid input: must end with "${t.validation.endsWith}"` : ie.assertNever(t.validation) : n = t.validation !== "regex" ? `Invalid ${t.validation}` : "Invalid";
      break;
    case E.too_small:
      n = t.type === "array" ? `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" || t.type === "bigint" ? `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : "Invalid input";
      break;
    case E.too_big:
      n = t.type === "array" ? `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : "Invalid input";
      break;
    case E.custom:
      n = "Invalid input";
      break;
    case E.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case E.not_multiple_of:
      n = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case E.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = e.defaultError, ie.assertNever(t);
  }
  return { message: n };
};
let dd = Os;
var P;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(P || (P = {}));
function T(t, e) {
  const n = dd, r = ((s) => {
    const { data: i, path: o, errorMaps: a, issueData: u } = s, c = [...o, ...u.path || []], l = { ...u, path: c };
    if (u.message !== void 0) return { ...u, path: c, message: u.message };
    let d = "";
    const f = a.filter((p) => !!p).slice().reverse();
    for (const p of f) d = p(l, { data: i, defaultError: d }).message;
    return { ...u, path: c, message: d };
  })({ issueData: e, data: t.data, path: t.path, errorMaps: [t.common.contextualErrorMap, t.schemaErrorMap, n, n === Os ? void 0 : Os].filter((s) => !!s) });
  t.common.issues.push(r);
}
class Le {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, n) {
    const r = [];
    for (const s of n) {
      if (s.status === "aborted") return H;
      s.status === "dirty" && e.dirty(), r.push(s.value);
    }
    return { status: e.value, value: r };
  }
  static async mergeObjectAsync(e, n) {
    const r = [];
    for (const s of n) {
      const i = await s.key, o = await s.value;
      r.push({ key: i, value: o });
    }
    return Le.mergeObjectSync(e, r);
  }
  static mergeObjectSync(e, n) {
    const r = {};
    for (const s of n) {
      const { key: i, value: o } = s;
      if (i.status === "aborted" || o.status === "aborted") return H;
      i.status === "dirty" && e.dirty(), o.status === "dirty" && e.dirty(), i.value === "__proto__" || o.value === void 0 && !s.alwaysSet || (r[i.value] = o.value);
    }
    return { status: e.value, value: r };
  }
}
const H = Object.freeze({ status: "aborted" }), Es = (t) => ({ status: "dirty", value: t }), He = (t) => ({ status: "valid", value: t }), no = (t) => t.status === "aborted", ro = (t) => t.status === "dirty", sn = (t) => t.status === "valid", Or = (t) => typeof Promise < "u" && t instanceof Promise;
class ht {
  constructor(e, n, r, s) {
    this._cachedPath = [], this.parent = e, this.data = n, this._path = r, this._key = s;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const so = (t, e) => {
  if (sn(e)) return { success: !0, data: e.value };
  if (!t.common.issues.length) throw new Error("Validation failed but no issues detected.");
  return { success: !1, get error() {
    if (this._error) return this._error;
    const n = new wt(t.common.issues);
    return this._error = n, this._error;
  } };
};
function K(t) {
  if (!t) return {};
  const { errorMap: e, invalid_type_error: n, required_error: r, description: s } = t;
  if (e && (n || r)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: s } : { errorMap: (i, o) => {
    const { message: a } = t;
    return i.code === "invalid_enum_value" ? { message: a ?? o.defaultError } : o.data === void 0 ? { message: a ?? r ?? o.defaultError } : i.code !== "invalid_type" ? { message: o.defaultError } : { message: a ?? n ?? o.defaultError };
  }, description: s };
}
class te {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return Rt(e.data);
  }
  _getOrReturnCtx(e, n) {
    return n || { common: e.parent.common, data: e.data, parsedType: Rt(e.data), schemaErrorMap: this._def.errorMap, path: e.path, parent: e.parent };
  }
  _processInputParams(e) {
    return { status: new Le(), ctx: { common: e.parent.common, data: e.data, parsedType: Rt(e.data), schemaErrorMap: this._def.errorMap, path: e.path, parent: e.parent } };
  }
  _parseSync(e) {
    const n = this._parse(e);
    if (Or(n)) throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(e) {
    const n = this._parse(e);
    return Promise.resolve(n);
  }
  parse(e, n) {
    const r = this.safeParse(e, n);
    if (r.success) return r.data;
    throw r.error;
  }
  safeParse(e, n) {
    const r = { common: { issues: [], async: (n == null ? void 0 : n.async) ?? !1, contextualErrorMap: n == null ? void 0 : n.errorMap }, path: (n == null ? void 0 : n.path) || [], schemaErrorMap: this._def.errorMap, parent: null, data: e, parsedType: Rt(e) }, s = this._parseSync({ data: e, path: r.path, parent: r });
    return so(r, s);
  }
  "~validate"(e) {
    var r, s;
    const n = { common: { issues: [], async: !!this["~standard"].async }, path: [], schemaErrorMap: this._def.errorMap, parent: null, data: e, parsedType: Rt(e) };
    if (!this["~standard"].async) try {
      const i = this._parseSync({ data: e, path: [], parent: n });
      return sn(i) ? { value: i.value } : { issues: n.common.issues };
    } catch (i) {
      (s = (r = i == null ? void 0 : i.message) == null ? void 0 : r.toLowerCase()) != null && s.includes("encountered") && (this["~standard"].async = !0), n.common = { issues: [], async: !0 };
    }
    return this._parseAsync({ data: e, path: [], parent: n }).then((i) => sn(i) ? { value: i.value } : { issues: n.common.issues });
  }
  async parseAsync(e, n) {
    const r = await this.safeParseAsync(e, n);
    if (r.success) return r.data;
    throw r.error;
  }
  async safeParseAsync(e, n) {
    const r = { common: { issues: [], contextualErrorMap: n == null ? void 0 : n.errorMap, async: !0 }, path: (n == null ? void 0 : n.path) || [], schemaErrorMap: this._def.errorMap, parent: null, data: e, parsedType: Rt(e) }, s = this._parse({ data: e, path: r.path, parent: r }), i = await (Or(s) ? s : Promise.resolve(s));
    return so(r, i);
  }
  refine(e, n) {
    const r = (s) => typeof n == "string" || n === void 0 ? { message: n } : typeof n == "function" ? n(s) : n;
    return this._refinement((s, i) => {
      const o = e(s), a = () => i.addIssue({ code: E.custom, ...r(s) });
      return typeof Promise < "u" && o instanceof Promise ? o.then((u) => !!u || (a(), !1)) : !!o || (a(), !1);
    });
  }
  refinement(e, n) {
    return this._refinement((r, s) => !!e(r) || (s.addIssue(typeof n == "function" ? n(r, s) : n), !1));
  }
  _refinement(e) {
    return new Gt({ schema: this, typeName: Z.ZodEffects, effect: { type: "refinement", refinement: e } });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = { version: 1, vendor: "zod", validate: (n) => this["~validate"](n) };
  }
  optional() {
    return jt.create(this, this._def);
  }
  nullable() {
    return un.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return lt.create(this);
  }
  promise() {
    return Cr.create(this, this._def);
  }
  or(e) {
    return jr.create([this, e], this._def);
  }
  and(e) {
    return Tr.create(this, e, this._def);
  }
  transform(e) {
    return new Gt({ ...K(this._def), schema: this, typeName: Z.ZodEffects, effect: { type: "transform", transform: e } });
  }
  default(e) {
    const n = typeof e == "function" ? e : () => e;
    return new Cs({ ...K(this._def), innerType: this, defaultValue: n, typeName: Z.ZodDefault });
  }
  brand() {
    return new Pd({ typeName: Z.ZodBranded, type: this, ...K(this._def) });
  }
  catch(e) {
    const n = typeof e == "function" ? e : () => e;
    return new ks({ ...K(this._def), innerType: this, catchValue: n, typeName: Z.ZodCatch });
  }
  describe(e) {
    return new this.constructor({ ...this._def, description: e });
  }
  pipe(e) {
    return Gs.create(this, e);
  }
  readonly() {
    return Ps.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const fd = /^c[^\s-]{8,}$/i, hd = /^[0-9a-z]+$/, pd = /^[0-9A-HJKMNP-TV-Z]{26}$/i, md = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, gd = /^[a-z0-9_-]{21}$/i, vd = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, yd = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, bd = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
let ts;
const wd = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, xd = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Sd = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Rd = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, _d = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Od = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Fa = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Ed = new RegExp(`^${Fa}$`);
function Ba(t) {
  let e = "[0-5]\\d";
  return t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`), `([01]\\d|2[0-3]):[0-5]\\d(:${e})${t.precision ? "+" : "?"}`;
}
function jd(t) {
  let e = `${Fa}T${Ba(t)}`;
  const n = [];
  return n.push(t.local ? "Z?" : "Z"), t.offset && n.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${n.join("|")})`, new RegExp(`^${e}$`);
}
function Td(t, e) {
  if (!vd.test(t)) return !1;
  try {
    const [n] = t.split(".");
    if (!n) return !1;
    const r = n.replace(/-/g, "+").replace(/_/g, "/").padEnd(n.length + (4 - n.length % 4) % 4, "="), s = JSON.parse(atob(r));
    return !(typeof s != "object" || s === null || "typ" in s && (s == null ? void 0 : s.typ) !== "JWT" || !s.alg || e && s.alg !== e);
  } catch {
    return !1;
  }
}
function Cd(t, e) {
  return !(e !== "v4" && e || !xd.test(t)) || !(e !== "v6" && e || !Rd.test(t));
}
class bt extends te {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== k.string) {
      const o = this._getOrReturnCtx(e);
      return T(o, { code: E.invalid_type, expected: k.string, received: o.parsedType }), H;
    }
    const n = new Le();
    let r;
    for (const o of this._def.checks) if (o.kind === "min") e.data.length < o.value && (r = this._getOrReturnCtx(e, r), T(r, { code: E.too_small, minimum: o.value, type: "string", inclusive: !0, exact: !1, message: o.message }), n.dirty());
    else if (o.kind === "max") e.data.length > o.value && (r = this._getOrReturnCtx(e, r), T(r, { code: E.too_big, maximum: o.value, type: "string", inclusive: !0, exact: !1, message: o.message }), n.dirty());
    else if (o.kind === "length") {
      const a = e.data.length > o.value, u = e.data.length < o.value;
      (a || u) && (r = this._getOrReturnCtx(e, r), a ? T(r, { code: E.too_big, maximum: o.value, type: "string", inclusive: !0, exact: !0, message: o.message }) : u && T(r, { code: E.too_small, minimum: o.value, type: "string", inclusive: !0, exact: !0, message: o.message }), n.dirty());
    } else if (o.kind === "email") bd.test(e.data) || (r = this._getOrReturnCtx(e, r), T(r, { validation: "email", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "emoji") ts || (ts = new RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u")), ts.test(e.data) || (r = this._getOrReturnCtx(e, r), T(r, { validation: "emoji", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "uuid") md.test(e.data) || (r = this._getOrReturnCtx(e, r), T(r, { validation: "uuid", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "nanoid") gd.test(e.data) || (r = this._getOrReturnCtx(e, r), T(r, { validation: "nanoid", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "cuid") fd.test(e.data) || (r = this._getOrReturnCtx(e, r), T(r, { validation: "cuid", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "cuid2") hd.test(e.data) || (r = this._getOrReturnCtx(e, r), T(r, { validation: "cuid2", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "ulid") pd.test(e.data) || (r = this._getOrReturnCtx(e, r), T(r, { validation: "ulid", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "url") try {
      new URL(e.data);
    } catch {
      r = this._getOrReturnCtx(e, r), T(r, { validation: "url", code: E.invalid_string, message: o.message }), n.dirty();
    }
    else o.kind === "regex" ? (o.regex.lastIndex = 0, o.regex.test(e.data) || (r = this._getOrReturnCtx(e, r), T(r, { validation: "regex", code: E.invalid_string, message: o.message }), n.dirty())) : o.kind === "trim" ? e.data = e.data.trim() : o.kind === "includes" ? e.data.includes(o.value, o.position) || (r = this._getOrReturnCtx(e, r), T(r, { code: E.invalid_string, validation: { includes: o.value, position: o.position }, message: o.message }), n.dirty()) : o.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : o.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : o.kind === "startsWith" ? e.data.startsWith(o.value) || (r = this._getOrReturnCtx(e, r), T(r, { code: E.invalid_string, validation: { startsWith: o.value }, message: o.message }), n.dirty()) : o.kind === "endsWith" ? e.data.endsWith(o.value) || (r = this._getOrReturnCtx(e, r), T(r, { code: E.invalid_string, validation: { endsWith: o.value }, message: o.message }), n.dirty()) : o.kind === "datetime" ? jd(o).test(e.data) || (r = this._getOrReturnCtx(e, r), T(r, { code: E.invalid_string, validation: "datetime", message: o.message }), n.dirty()) : o.kind === "date" ? Ed.test(e.data) || (r = this._getOrReturnCtx(e, r), T(r, { code: E.invalid_string, validation: "date", message: o.message }), n.dirty()) : o.kind === "time" ? new RegExp(`^${Ba(o)}$`).test(e.data) || (r = this._getOrReturnCtx(e, r), T(r, { code: E.invalid_string, validation: "time", message: o.message }), n.dirty()) : o.kind === "duration" ? yd.test(e.data) || (r = this._getOrReturnCtx(e, r), T(r, { validation: "duration", code: E.invalid_string, message: o.message }), n.dirty()) : o.kind === "ip" ? (s = e.data, ((i = o.version) !== "v4" && i || !wd.test(s)) && (i !== "v6" && i || !Sd.test(s)) && (r = this._getOrReturnCtx(e, r), T(r, { validation: "ip", code: E.invalid_string, message: o.message }), n.dirty())) : o.kind === "jwt" ? Td(e.data, o.alg) || (r = this._getOrReturnCtx(e, r), T(r, { validation: "jwt", code: E.invalid_string, message: o.message }), n.dirty()) : o.kind === "cidr" ? Cd(e.data, o.version) || (r = this._getOrReturnCtx(e, r), T(r, { validation: "cidr", code: E.invalid_string, message: o.message }), n.dirty()) : o.kind === "base64" ? _d.test(e.data) || (r = this._getOrReturnCtx(e, r), T(r, { validation: "base64", code: E.invalid_string, message: o.message }), n.dirty()) : o.kind === "base64url" ? Od.test(e.data) || (r = this._getOrReturnCtx(e, r), T(r, { validation: "base64url", code: E.invalid_string, message: o.message }), n.dirty()) : ie.assertNever(o);
    var s, i;
    return { status: n.value, value: e.data };
  }
  _regex(e, n, r) {
    return this.refinement((s) => e.test(s), { validation: n, code: E.invalid_string, ...P.errToObj(r) });
  }
  _addCheck(e) {
    return new bt({ ...this._def, checks: [...this._def.checks, e] });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...P.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...P.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...P.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...P.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...P.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...P.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...P.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...P.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...P.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({ kind: "base64url", ...P.errToObj(e) });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...P.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...P.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...P.errToObj(e) });
  }
  datetime(e) {
    return typeof e == "string" ? this._addCheck({ kind: "datetime", precision: null, offset: !1, local: !1, message: e }) : this._addCheck({ kind: "datetime", precision: (e == null ? void 0 : e.precision) === void 0 ? null : e == null ? void 0 : e.precision, offset: (e == null ? void 0 : e.offset) ?? !1, local: (e == null ? void 0 : e.local) ?? !1, ...P.errToObj(e == null ? void 0 : e.message) });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({ kind: "time", precision: null, message: e }) : this._addCheck({ kind: "time", precision: (e == null ? void 0 : e.precision) === void 0 ? null : e == null ? void 0 : e.precision, ...P.errToObj(e == null ? void 0 : e.message) });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...P.errToObj(e) });
  }
  regex(e, n) {
    return this._addCheck({ kind: "regex", regex: e, ...P.errToObj(n) });
  }
  includes(e, n) {
    return this._addCheck({ kind: "includes", value: e, position: n == null ? void 0 : n.position, ...P.errToObj(n == null ? void 0 : n.message) });
  }
  startsWith(e, n) {
    return this._addCheck({ kind: "startsWith", value: e, ...P.errToObj(n) });
  }
  endsWith(e, n) {
    return this._addCheck({ kind: "endsWith", value: e, ...P.errToObj(n) });
  }
  min(e, n) {
    return this._addCheck({ kind: "min", value: e, ...P.errToObj(n) });
  }
  max(e, n) {
    return this._addCheck({ kind: "max", value: e, ...P.errToObj(n) });
  }
  length(e, n) {
    return this._addCheck({ kind: "length", value: e, ...P.errToObj(n) });
  }
  nonempty(e) {
    return this.min(1, P.errToObj(e));
  }
  trim() {
    return new bt({ ...this._def, checks: [...this._def.checks, { kind: "trim" }] });
  }
  toLowerCase() {
    return new bt({ ...this._def, checks: [...this._def.checks, { kind: "toLowerCase" }] });
  }
  toUpperCase() {
    return new bt({ ...this._def, checks: [...this._def.checks, { kind: "toUpperCase" }] });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const n of this._def.checks) n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const n of this._def.checks) n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
function kd(t, e) {
  const n = (t.toString().split(".")[1] || "").length, r = (e.toString().split(".")[1] || "").length, s = n > r ? n : r;
  return Number.parseInt(t.toFixed(s).replace(".", "")) % Number.parseInt(e.toFixed(s).replace(".", "")) / 10 ** s;
}
bt.create = (t) => new bt({ checks: [], typeName: Z.ZodString, coerce: (t == null ? void 0 : t.coerce) ?? !1, ...K(t) });
class on extends te {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== k.number) {
      const s = this._getOrReturnCtx(e);
      return T(s, { code: E.invalid_type, expected: k.number, received: s.parsedType }), H;
    }
    let n;
    const r = new Le();
    for (const s of this._def.checks) s.kind === "int" ? ie.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), T(n, { code: E.invalid_type, expected: "integer", received: "float", message: s.message }), r.dirty()) : s.kind === "min" ? (s.inclusive ? e.data < s.value : e.data <= s.value) && (n = this._getOrReturnCtx(e, n), T(n, { code: E.too_small, minimum: s.value, type: "number", inclusive: s.inclusive, exact: !1, message: s.message }), r.dirty()) : s.kind === "max" ? (s.inclusive ? e.data > s.value : e.data >= s.value) && (n = this._getOrReturnCtx(e, n), T(n, { code: E.too_big, maximum: s.value, type: "number", inclusive: s.inclusive, exact: !1, message: s.message }), r.dirty()) : s.kind === "multipleOf" ? kd(e.data, s.value) !== 0 && (n = this._getOrReturnCtx(e, n), T(n, { code: E.not_multiple_of, multipleOf: s.value, message: s.message }), r.dirty()) : s.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), T(n, { code: E.not_finite, message: s.message }), r.dirty()) : ie.assertNever(s);
    return { status: r.value, value: e.data };
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, P.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, P.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, P.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, P.toString(n));
  }
  setLimit(e, n, r, s) {
    return new on({ ...this._def, checks: [...this._def.checks, { kind: e, value: n, inclusive: r, message: P.toString(s) }] });
  }
  _addCheck(e) {
    return new on({ ...this._def, checks: [...this._def.checks, e] });
  }
  int(e) {
    return this._addCheck({ kind: "int", message: P.toString(e) });
  }
  positive(e) {
    return this._addCheck({ kind: "min", value: 0, inclusive: !1, message: P.toString(e) });
  }
  negative(e) {
    return this._addCheck({ kind: "max", value: 0, inclusive: !1, message: P.toString(e) });
  }
  nonpositive(e) {
    return this._addCheck({ kind: "max", value: 0, inclusive: !0, message: P.toString(e) });
  }
  nonnegative(e) {
    return this._addCheck({ kind: "min", value: 0, inclusive: !0, message: P.toString(e) });
  }
  multipleOf(e, n) {
    return this._addCheck({ kind: "multipleOf", value: e, message: P.toString(n) });
  }
  finite(e) {
    return this._addCheck({ kind: "finite", message: P.toString(e) });
  }
  safe(e) {
    return this._addCheck({ kind: "min", inclusive: !0, value: Number.MIN_SAFE_INTEGER, message: P.toString(e) })._addCheck({ kind: "max", inclusive: !0, value: Number.MAX_SAFE_INTEGER, message: P.toString(e) });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks) n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks) n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && ie.isInteger(e.value));
  }
  get isFinite() {
    let e = null, n = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf") return !0;
      r.kind === "min" ? (n === null || r.value > n) && (n = r.value) : r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    }
    return Number.isFinite(n) && Number.isFinite(e);
  }
}
on.create = (t) => new on({ checks: [], typeName: Z.ZodNumber, coerce: (t == null ? void 0 : t.coerce) || !1, ...K(t) });
class kn extends te {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce) try {
      e.data = BigInt(e.data);
    } catch {
      return this._getInvalidInput(e);
    }
    if (this._getType(e) !== k.bigint) return this._getInvalidInput(e);
    let n;
    const r = new Le();
    for (const s of this._def.checks) s.kind === "min" ? (s.inclusive ? e.data < s.value : e.data <= s.value) && (n = this._getOrReturnCtx(e, n), T(n, { code: E.too_small, type: "bigint", minimum: s.value, inclusive: s.inclusive, message: s.message }), r.dirty()) : s.kind === "max" ? (s.inclusive ? e.data > s.value : e.data >= s.value) && (n = this._getOrReturnCtx(e, n), T(n, { code: E.too_big, type: "bigint", maximum: s.value, inclusive: s.inclusive, message: s.message }), r.dirty()) : s.kind === "multipleOf" ? e.data % s.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), T(n, { code: E.not_multiple_of, multipleOf: s.value, message: s.message }), r.dirty()) : ie.assertNever(s);
    return { status: r.value, value: e.data };
  }
  _getInvalidInput(e) {
    const n = this._getOrReturnCtx(e);
    return T(n, { code: E.invalid_type, expected: k.bigint, received: n.parsedType }), H;
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, P.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, P.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, P.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, P.toString(n));
  }
  setLimit(e, n, r, s) {
    return new kn({ ...this._def, checks: [...this._def.checks, { kind: e, value: n, inclusive: r, message: P.toString(s) }] });
  }
  _addCheck(e) {
    return new kn({ ...this._def, checks: [...this._def.checks, e] });
  }
  positive(e) {
    return this._addCheck({ kind: "min", value: BigInt(0), inclusive: !1, message: P.toString(e) });
  }
  negative(e) {
    return this._addCheck({ kind: "max", value: BigInt(0), inclusive: !1, message: P.toString(e) });
  }
  nonpositive(e) {
    return this._addCheck({ kind: "max", value: BigInt(0), inclusive: !0, message: P.toString(e) });
  }
  nonnegative(e) {
    return this._addCheck({ kind: "min", value: BigInt(0), inclusive: !0, message: P.toString(e) });
  }
  multipleOf(e, n) {
    return this._addCheck({ kind: "multipleOf", value: e, message: P.toString(n) });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks) n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks) n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
kn.create = (t) => new kn({ checks: [], typeName: Z.ZodBigInt, coerce: (t == null ? void 0 : t.coerce) ?? !1, ...K(t) });
class js extends te {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== k.boolean) {
      const n = this._getOrReturnCtx(e);
      return T(n, { code: E.invalid_type, expected: k.boolean, received: n.parsedType }), H;
    }
    return He(e.data);
  }
}
js.create = (t) => new js({ typeName: Z.ZodBoolean, coerce: (t == null ? void 0 : t.coerce) || !1, ...K(t) });
class Er extends te {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== k.date) {
      const s = this._getOrReturnCtx(e);
      return T(s, { code: E.invalid_type, expected: k.date, received: s.parsedType }), H;
    }
    if (Number.isNaN(e.data.getTime())) return T(this._getOrReturnCtx(e), { code: E.invalid_date }), H;
    const n = new Le();
    let r;
    for (const s of this._def.checks) s.kind === "min" ? e.data.getTime() < s.value && (r = this._getOrReturnCtx(e, r), T(r, { code: E.too_small, message: s.message, inclusive: !0, exact: !1, minimum: s.value, type: "date" }), n.dirty()) : s.kind === "max" ? e.data.getTime() > s.value && (r = this._getOrReturnCtx(e, r), T(r, { code: E.too_big, message: s.message, inclusive: !0, exact: !1, maximum: s.value, type: "date" }), n.dirty()) : ie.assertNever(s);
    return { status: n.value, value: new Date(e.data.getTime()) };
  }
  _addCheck(e) {
    return new Er({ ...this._def, checks: [...this._def.checks, e] });
  }
  min(e, n) {
    return this._addCheck({ kind: "min", value: e.getTime(), message: P.toString(n) });
  }
  max(e, n) {
    return this._addCheck({ kind: "max", value: e.getTime(), message: P.toString(n) });
  }
  get minDate() {
    let e = null;
    for (const n of this._def.checks) n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const n of this._def.checks) n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
}
Er.create = (t) => new Er({ checks: [], coerce: (t == null ? void 0 : t.coerce) || !1, typeName: Z.ZodDate, ...K(t) });
class io extends te {
  _parse(e) {
    if (this._getType(e) !== k.symbol) {
      const n = this._getOrReturnCtx(e);
      return T(n, { code: E.invalid_type, expected: k.symbol, received: n.parsedType }), H;
    }
    return He(e.data);
  }
}
io.create = (t) => new io({ typeName: Z.ZodSymbol, ...K(t) });
class oo extends te {
  _parse(e) {
    if (this._getType(e) !== k.undefined) {
      const n = this._getOrReturnCtx(e);
      return T(n, { code: E.invalid_type, expected: k.undefined, received: n.parsedType }), H;
    }
    return He(e.data);
  }
}
oo.create = (t) => new oo({ typeName: Z.ZodUndefined, ...K(t) });
class ao extends te {
  _parse(e) {
    if (this._getType(e) !== k.null) {
      const n = this._getOrReturnCtx(e);
      return T(n, { code: E.invalid_type, expected: k.null, received: n.parsedType }), H;
    }
    return He(e.data);
  }
}
ao.create = (t) => new ao({ typeName: Z.ZodNull, ...K(t) });
class uo extends te {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return He(e.data);
  }
}
uo.create = (t) => new uo({ typeName: Z.ZodAny, ...K(t) });
class co extends te {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return He(e.data);
  }
}
co.create = (t) => new co({ typeName: Z.ZodUnknown, ...K(t) });
class Et extends te {
  _parse(e) {
    const n = this._getOrReturnCtx(e);
    return T(n, { code: E.invalid_type, expected: k.never, received: n.parsedType }), H;
  }
}
Et.create = (t) => new Et({ typeName: Z.ZodNever, ...K(t) });
class lo extends te {
  _parse(e) {
    if (this._getType(e) !== k.undefined) {
      const n = this._getOrReturnCtx(e);
      return T(n, { code: E.invalid_type, expected: k.void, received: n.parsedType }), H;
    }
    return He(e.data);
  }
}
lo.create = (t) => new lo({ typeName: Z.ZodVoid, ...K(t) });
class lt extends te {
  _parse(e) {
    const { ctx: n, status: r } = this._processInputParams(e), s = this._def;
    if (n.parsedType !== k.array) return T(n, { code: E.invalid_type, expected: k.array, received: n.parsedType }), H;
    if (s.exactLength !== null) {
      const o = n.data.length > s.exactLength.value, a = n.data.length < s.exactLength.value;
      (o || a) && (T(n, { code: o ? E.too_big : E.too_small, minimum: a ? s.exactLength.value : void 0, maximum: o ? s.exactLength.value : void 0, type: "array", inclusive: !0, exact: !0, message: s.exactLength.message }), r.dirty());
    }
    if (s.minLength !== null && n.data.length < s.minLength.value && (T(n, { code: E.too_small, minimum: s.minLength.value, type: "array", inclusive: !0, exact: !1, message: s.minLength.message }), r.dirty()), s.maxLength !== null && n.data.length > s.maxLength.value && (T(n, { code: E.too_big, maximum: s.maxLength.value, type: "array", inclusive: !0, exact: !1, message: s.maxLength.message }), r.dirty()), n.common.async) return Promise.all([...n.data].map((o, a) => s.type._parseAsync(new ht(n, o, n.path, a)))).then((o) => Le.mergeArray(r, o));
    const i = [...n.data].map((o, a) => s.type._parseSync(new ht(n, o, n.path, a)));
    return Le.mergeArray(r, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, n) {
    return new lt({ ...this._def, minLength: { value: e, message: P.toString(n) } });
  }
  max(e, n) {
    return new lt({ ...this._def, maxLength: { value: e, message: P.toString(n) } });
  }
  length(e, n) {
    return new lt({ ...this._def, exactLength: { value: e, message: P.toString(n) } });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
function Jt(t) {
  if (t instanceof _e) {
    const e = {};
    for (const n in t.shape) {
      const r = t.shape[n];
      e[n] = jt.create(Jt(r));
    }
    return new _e({ ...t._def, shape: () => e });
  }
  return t instanceof lt ? new lt({ ...t._def, type: Jt(t.element) }) : t instanceof jt ? jt.create(Jt(t.unwrap())) : t instanceof un ? un.create(Jt(t.unwrap())) : t instanceof Bt ? Bt.create(t.items.map((e) => Jt(e))) : t;
}
lt.create = (t, e) => new lt({ type: t, minLength: null, maxLength: null, exactLength: null, typeName: Z.ZodArray, ...K(e) });
class _e extends te {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null) return this._cached;
    const e = this._def.shape(), n = ie.objectKeys(e);
    return this._cached = { shape: e, keys: n }, this._cached;
  }
  _parse(e) {
    if (this._getType(e) !== k.object) {
      const u = this._getOrReturnCtx(e);
      return T(u, { code: E.invalid_type, expected: k.object, received: u.parsedType }), H;
    }
    const { status: n, ctx: r } = this._processInputParams(e), { shape: s, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof Et && this._def.unknownKeys === "strip")) for (const u in r.data) i.includes(u) || o.push(u);
    const a = [];
    for (const u of i) {
      const c = s[u], l = r.data[u];
      a.push({ key: { status: "valid", value: u }, value: c._parse(new ht(r, l, r.path, u)), alwaysSet: u in r.data });
    }
    if (this._def.catchall instanceof Et) {
      const u = this._def.unknownKeys;
      if (u === "passthrough") for (const c of o) a.push({ key: { status: "valid", value: c }, value: { status: "valid", value: r.data[c] } });
      else if (u === "strict") o.length > 0 && (T(r, { code: E.unrecognized_keys, keys: o }), n.dirty());
      else if (u !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const c of o) {
        const l = r.data[c];
        a.push({ key: { status: "valid", value: c }, value: u._parse(new ht(r, l, r.path, c)), alwaysSet: c in r.data });
      }
    }
    return r.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const c of a) {
        const l = await c.key, d = await c.value;
        u.push({ key: l, value: d, alwaysSet: c.alwaysSet });
      }
      return u;
    }).then((u) => Le.mergeObjectSync(n, u)) : Le.mergeObjectSync(n, a);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return P.errToObj, new _e({ ...this._def, unknownKeys: "strict", ...e !== void 0 ? { errorMap: (n, r) => {
      var i, o;
      const s = ((o = (i = this._def).errorMap) == null ? void 0 : o.call(i, n, r).message) ?? r.defaultError;
      return n.code === "unrecognized_keys" ? { message: P.errToObj(e).message ?? s } : { message: s };
    } } : {} });
  }
  strip() {
    return new _e({ ...this._def, unknownKeys: "strip" });
  }
  passthrough() {
    return new _e({ ...this._def, unknownKeys: "passthrough" });
  }
  extend(e) {
    return new _e({ ...this._def, shape: () => ({ ...this._def.shape(), ...e }) });
  }
  merge(e) {
    return new _e({ unknownKeys: e._def.unknownKeys, catchall: e._def.catchall, shape: () => ({ ...this._def.shape(), ...e._def.shape() }), typeName: Z.ZodObject });
  }
  setKey(e, n) {
    return this.augment({ [e]: n });
  }
  catchall(e) {
    return new _e({ ...this._def, catchall: e });
  }
  pick(e) {
    const n = {};
    for (const r of ie.objectKeys(e)) e[r] && this.shape[r] && (n[r] = this.shape[r]);
    return new _e({ ...this._def, shape: () => n });
  }
  omit(e) {
    const n = {};
    for (const r of ie.objectKeys(this.shape)) e[r] || (n[r] = this.shape[r]);
    return new _e({ ...this._def, shape: () => n });
  }
  deepPartial() {
    return Jt(this);
  }
  partial(e) {
    const n = {};
    for (const r of ie.objectKeys(this.shape)) {
      const s = this.shape[r];
      e && !e[r] ? n[r] = s : n[r] = s.optional();
    }
    return new _e({ ...this._def, shape: () => n });
  }
  required(e) {
    const n = {};
    for (const r of ie.objectKeys(this.shape)) if (e && !e[r]) n[r] = this.shape[r];
    else {
      let s = this.shape[r];
      for (; s instanceof jt; ) s = s._def.innerType;
      n[r] = s;
    }
    return new _e({ ...this._def, shape: () => n });
  }
  keyof() {
    return Ma(ie.objectKeys(this.shape));
  }
}
_e.create = (t, e) => new _e({ shape: () => t, unknownKeys: "strip", catchall: Et.create(), typeName: Z.ZodObject, ...K(e) }), _e.strictCreate = (t, e) => new _e({ shape: () => t, unknownKeys: "strict", catchall: Et.create(), typeName: Z.ZodObject, ...K(e) }), _e.lazycreate = (t, e) => new _e({ shape: t, unknownKeys: "strip", catchall: Et.create(), typeName: Z.ZodObject, ...K(e) });
class jr extends te {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = this._def.options;
    if (n.common.async) return Promise.all(r.map(async (s) => {
      const i = { ...n, common: { ...n.common, issues: [] }, parent: null };
      return { result: await s._parseAsync({ data: n.data, path: n.path, parent: i }), ctx: i };
    })).then(function(s) {
      for (const o of s) if (o.result.status === "valid") return o.result;
      for (const o of s) if (o.result.status === "dirty") return n.common.issues.push(...o.ctx.common.issues), o.result;
      const i = s.map((o) => new wt(o.ctx.common.issues));
      return T(n, { code: E.invalid_union, unionErrors: i }), H;
    });
    {
      let s;
      const i = [];
      for (const a of r) {
        const u = { ...n, common: { ...n.common, issues: [] }, parent: null }, c = a._parseSync({ data: n.data, path: n.path, parent: u });
        if (c.status === "valid") return c;
        c.status !== "dirty" || s || (s = { result: c, ctx: u }), u.common.issues.length && i.push(u.common.issues);
      }
      if (s) return n.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((a) => new wt(a));
      return T(n, { code: E.invalid_union, unionErrors: o }), H;
    }
  }
  get options() {
    return this._def.options;
  }
}
function Ts(t, e) {
  const n = Rt(t), r = Rt(e);
  if (t === e) return { valid: !0, data: t };
  if (n === k.object && r === k.object) {
    const s = ie.objectKeys(e), i = ie.objectKeys(t).filter((a) => s.indexOf(a) !== -1), o = { ...t, ...e };
    for (const a of i) {
      const u = Ts(t[a], e[a]);
      if (!u.valid) return { valid: !1 };
      o[a] = u.data;
    }
    return { valid: !0, data: o };
  }
  if (n === k.array && r === k.array) {
    if (t.length !== e.length) return { valid: !1 };
    const s = [];
    for (let i = 0; i < t.length; i++) {
      const o = Ts(t[i], e[i]);
      if (!o.valid) return { valid: !1 };
      s.push(o.data);
    }
    return { valid: !0, data: s };
  }
  return n === k.date && r === k.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
jr.create = (t, e) => new jr({ options: t, typeName: Z.ZodUnion, ...K(e) });
class Tr extends te {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e), s = (i, o) => {
      if (no(i) || no(o)) return H;
      const a = Ts(i.value, o.value);
      return a.valid ? ((ro(i) || ro(o)) && n.dirty(), { status: n.value, value: a.data }) : (T(r, { code: E.invalid_intersection_types }), H);
    };
    return r.common.async ? Promise.all([this._def.left._parseAsync({ data: r.data, path: r.path, parent: r }), this._def.right._parseAsync({ data: r.data, path: r.path, parent: r })]).then(([i, o]) => s(i, o)) : s(this._def.left._parseSync({ data: r.data, path: r.path, parent: r }), this._def.right._parseSync({ data: r.data, path: r.path, parent: r }));
  }
}
Tr.create = (t, e, n) => new Tr({ left: t, right: e, typeName: Z.ZodIntersection, ...K(n) });
class Bt extends te {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== k.array) return T(r, { code: E.invalid_type, expected: k.array, received: r.parsedType }), H;
    if (r.data.length < this._def.items.length) return T(r, { code: E.too_small, minimum: this._def.items.length, inclusive: !0, exact: !1, type: "array" }), H;
    !this._def.rest && r.data.length > this._def.items.length && (T(r, { code: E.too_big, maximum: this._def.items.length, inclusive: !0, exact: !1, type: "array" }), n.dirty());
    const s = [...r.data].map((i, o) => {
      const a = this._def.items[o] || this._def.rest;
      return a ? a._parse(new ht(r, i, r.path, o)) : null;
    }).filter((i) => !!i);
    return r.common.async ? Promise.all(s).then((i) => Le.mergeArray(n, i)) : Le.mergeArray(n, s);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new Bt({ ...this._def, rest: e });
  }
}
Bt.create = (t, e) => {
  if (!Array.isArray(t)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Bt({ items: t, typeName: Z.ZodTuple, rest: null, ...K(e) });
};
class Ks extends te {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== k.object) return T(r, { code: E.invalid_type, expected: k.object, received: r.parsedType }), H;
    const s = [], i = this._def.keyType, o = this._def.valueType;
    for (const a in r.data) s.push({ key: i._parse(new ht(r, a, r.path, a)), value: o._parse(new ht(r, r.data[a], r.path, a)), alwaysSet: a in r.data });
    return r.common.async ? Le.mergeObjectAsync(n, s) : Le.mergeObjectSync(n, s);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, n, r) {
    return new Ks(n instanceof te ? { keyType: e, valueType: n, typeName: Z.ZodRecord, ...K(r) } : { keyType: bt.create(), valueType: e, typeName: Z.ZodRecord, ...K(n) });
  }
}
class fo extends te {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== k.map) return T(r, { code: E.invalid_type, expected: k.map, received: r.parsedType }), H;
    const s = this._def.keyType, i = this._def.valueType, o = [...r.data.entries()].map(([a, u], c) => ({ key: s._parse(new ht(r, a, r.path, [c, "key"])), value: i._parse(new ht(r, u, r.path, [c, "value"])) }));
    if (r.common.async) {
      const a = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const u of o) {
          const c = await u.key, l = await u.value;
          if (c.status === "aborted" || l.status === "aborted") return H;
          c.status !== "dirty" && l.status !== "dirty" || n.dirty(), a.set(c.value, l.value);
        }
        return { status: n.value, value: a };
      });
    }
    {
      const a = /* @__PURE__ */ new Map();
      for (const u of o) {
        const c = u.key, l = u.value;
        if (c.status === "aborted" || l.status === "aborted") return H;
        c.status !== "dirty" && l.status !== "dirty" || n.dirty(), a.set(c.value, l.value);
      }
      return { status: n.value, value: a };
    }
  }
}
fo.create = (t, e, n) => new fo({ valueType: e, keyType: t, typeName: Z.ZodMap, ...K(n) });
class Pn extends te {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== k.set) return T(r, { code: E.invalid_type, expected: k.set, received: r.parsedType }), H;
    const s = this._def;
    s.minSize !== null && r.data.size < s.minSize.value && (T(r, { code: E.too_small, minimum: s.minSize.value, type: "set", inclusive: !0, exact: !1, message: s.minSize.message }), n.dirty()), s.maxSize !== null && r.data.size > s.maxSize.value && (T(r, { code: E.too_big, maximum: s.maxSize.value, type: "set", inclusive: !0, exact: !1, message: s.maxSize.message }), n.dirty());
    const i = this._def.valueType;
    function o(u) {
      const c = /* @__PURE__ */ new Set();
      for (const l of u) {
        if (l.status === "aborted") return H;
        l.status === "dirty" && n.dirty(), c.add(l.value);
      }
      return { status: n.value, value: c };
    }
    const a = [...r.data.values()].map((u, c) => i._parse(new ht(r, u, r.path, c)));
    return r.common.async ? Promise.all(a).then((u) => o(u)) : o(a);
  }
  min(e, n) {
    return new Pn({ ...this._def, minSize: { value: e, message: P.toString(n) } });
  }
  max(e, n) {
    return new Pn({ ...this._def, maxSize: { value: e, message: P.toString(n) } });
  }
  size(e, n) {
    return this.min(e, n).max(e, n);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
Pn.create = (t, e) => new Pn({ valueType: t, minSize: null, maxSize: null, typeName: Z.ZodSet, ...K(e) });
class ho extends te {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
ho.create = (t, e) => new ho({ getter: t, typeName: Z.ZodLazy, ...K(e) });
class po extends te {
  _parse(e) {
    if (e.data !== this._def.value) {
      const n = this._getOrReturnCtx(e);
      return T(n, { received: n.data, code: E.invalid_literal, expected: this._def.value }), H;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
function Ma(t, e) {
  return new an({ values: t, typeName: Z.ZodEnum, ...K(e) });
}
po.create = (t, e) => new po({ value: t, typeName: Z.ZodLiteral, ...K(e) });
class an extends te {
  _parse(e) {
    if (typeof e.data != "string") {
      const n = this._getOrReturnCtx(e), r = this._def.values;
      return T(n, { expected: ie.joinValues(r), received: n.parsedType, code: E.invalid_type }), H;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(e.data)) {
      const n = this._getOrReturnCtx(e), r = this._def.values;
      return T(n, { received: n.data, code: E.invalid_enum_value, options: r }), H;
    }
    return He(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const n of this._def.values) e[n] = n;
    return e;
  }
  get Values() {
    const e = {};
    for (const n of this._def.values) e[n] = n;
    return e;
  }
  get Enum() {
    const e = {};
    for (const n of this._def.values) e[n] = n;
    return e;
  }
  extract(e, n = this._def) {
    return an.create(e, { ...this._def, ...n });
  }
  exclude(e, n = this._def) {
    return an.create(this.options.filter((r) => !e.includes(r)), { ...this._def, ...n });
  }
}
an.create = Ma;
class mo extends te {
  _parse(e) {
    const n = ie.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(e);
    if (r.parsedType !== k.string && r.parsedType !== k.number) {
      const s = ie.objectValues(n);
      return T(r, { expected: ie.joinValues(s), received: r.parsedType, code: E.invalid_type }), H;
    }
    if (this._cache || (this._cache = new Set(ie.getValidEnumValues(this._def.values))), !this._cache.has(e.data)) {
      const s = ie.objectValues(n);
      return T(r, { received: r.data, code: E.invalid_enum_value, options: s }), H;
    }
    return He(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
mo.create = (t, e) => new mo({ values: t, typeName: Z.ZodNativeEnum, ...K(e) });
class Cr extends te {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== k.promise && n.common.async === !1) return T(n, { code: E.invalid_type, expected: k.promise, received: n.parsedType }), H;
    const r = n.parsedType === k.promise ? n.data : Promise.resolve(n.data);
    return He(r.then((s) => this._def.type.parseAsync(s, { path: n.path, errorMap: n.common.contextualErrorMap })));
  }
}
Cr.create = (t, e) => new Cr({ type: t, typeName: Z.ZodPromise, ...K(e) });
class Gt extends te {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Z.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e), s = this._def.effect || null, i = { addIssue: (o) => {
      T(r, o), o.fatal ? n.abort() : n.dirty();
    }, get path() {
      return r.path;
    } };
    if (i.addIssue = i.addIssue.bind(i), s.type === "preprocess") {
      const o = s.transform(r.data, i);
      if (r.common.async) return Promise.resolve(o).then(async (a) => {
        if (n.value === "aborted") return H;
        const u = await this._def.schema._parseAsync({ data: a, path: r.path, parent: r });
        return u.status === "aborted" ? H : u.status === "dirty" || n.value === "dirty" ? Es(u.value) : u;
      });
      {
        if (n.value === "aborted") return H;
        const a = this._def.schema._parseSync({ data: o, path: r.path, parent: r });
        return a.status === "aborted" ? H : a.status === "dirty" || n.value === "dirty" ? Es(a.value) : a;
      }
    }
    if (s.type === "refinement") {
      const o = (a) => {
        const u = s.refinement(a, i);
        if (r.common.async) return Promise.resolve(u);
        if (u instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return a;
      };
      if (r.common.async === !1) {
        const a = this._def.schema._parseSync({ data: r.data, path: r.path, parent: r });
        return a.status === "aborted" ? H : (a.status === "dirty" && n.dirty(), o(a.value), { status: n.value, value: a.value });
      }
      return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((a) => a.status === "aborted" ? H : (a.status === "dirty" && n.dirty(), o(a.value).then(() => ({ status: n.value, value: a.value }))));
    }
    if (s.type === "transform") {
      if (r.common.async === !1) {
        const o = this._def.schema._parseSync({ data: r.data, path: r.path, parent: r });
        if (!sn(o)) return H;
        const a = s.transform(o.value, i);
        if (a instanceof Promise) throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: a };
      }
      return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((o) => sn(o) ? Promise.resolve(s.transform(o.value, i)).then((a) => ({ status: n.value, value: a })) : H);
    }
    ie.assertNever(s);
  }
}
Gt.create = (t, e, n) => new Gt({ schema: t, typeName: Z.ZodEffects, effect: e, ...K(n) }), Gt.createWithPreprocess = (t, e, n) => new Gt({ schema: e, effect: { type: "preprocess", transform: t }, typeName: Z.ZodEffects, ...K(n) });
class jt extends te {
  _parse(e) {
    return this._getType(e) === k.undefined ? He(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
jt.create = (t, e) => new jt({ innerType: t, typeName: Z.ZodOptional, ...K(e) });
class un extends te {
  _parse(e) {
    return this._getType(e) === k.null ? He(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
un.create = (t, e) => new un({ innerType: t, typeName: Z.ZodNullable, ...K(e) });
class Cs extends te {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    let r = n.data;
    return n.parsedType === k.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({ data: r, path: n.path, parent: n });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Cs.create = (t, e) => new Cs({ innerType: t, typeName: Z.ZodDefault, defaultValue: typeof e.default == "function" ? e.default : () => e.default, ...K(e) });
class ks extends te {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = { ...n, common: { ...n.common, issues: [] } }, s = this._def.innerType._parse({ data: r.data, path: r.path, parent: { ...r } });
    return Or(s) ? s.then((i) => ({ status: "valid", value: i.status === "valid" ? i.value : this._def.catchValue({ get error() {
      return new wt(r.common.issues);
    }, input: r.data }) })) : { status: "valid", value: s.status === "valid" ? s.value : this._def.catchValue({ get error() {
      return new wt(r.common.issues);
    }, input: r.data }) };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
ks.create = (t, e) => new ks({ innerType: t, typeName: Z.ZodCatch, catchValue: typeof e.catch == "function" ? e.catch : () => e.catch, ...K(e) });
class go extends te {
  _parse(e) {
    if (this._getType(e) !== k.nan) {
      const n = this._getOrReturnCtx(e);
      return T(n, { code: E.invalid_type, expected: k.nan, received: n.parsedType }), H;
    }
    return { status: "valid", value: e.data };
  }
}
go.create = (t) => new go({ typeName: Z.ZodNaN, ...K(t) });
class Pd extends te {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = n.data;
    return this._def.type._parse({ data: r, path: n.path, parent: n });
  }
  unwrap() {
    return this._def.type;
  }
}
class Gs extends te {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.common.async) return (async () => {
      const s = await this._def.in._parseAsync({ data: r.data, path: r.path, parent: r });
      return s.status === "aborted" ? H : s.status === "dirty" ? (n.dirty(), Es(s.value)) : this._def.out._parseAsync({ data: s.value, path: r.path, parent: r });
    })();
    {
      const s = this._def.in._parseSync({ data: r.data, path: r.path, parent: r });
      return s.status === "aborted" ? H : s.status === "dirty" ? (n.dirty(), { status: "dirty", value: s.value }) : this._def.out._parseSync({ data: s.value, path: r.path, parent: r });
    }
  }
  static create(e, n) {
    return new Gs({ in: e, out: n, typeName: Z.ZodPipeline });
  }
}
class Ps extends te {
  _parse(e) {
    const n = this._def.innerType._parse(e), r = (s) => (sn(s) && (s.value = Object.freeze(s.value)), s);
    return Or(n) ? n.then((s) => r(s)) : r(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
var Z;
Ps.create = (t, e) => new Ps({ innerType: t, typeName: Z.ZodReadonly, ...K(e) }), function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
}(Z || (Z = {}));
const O = bt.create, ee = on.create, cn = js.create, dt = (Et.create, lt.create), ge = _e.create, Zn = jr.create, Ad = (Tr.create, Bt.create, Ks.create), ft = an.create;
Cr.create, jt.create, un.create;
var Id = ee().min(0).max($a).refine(function(t) {
  return Number.isInteger(2 * t);
}, { message: "score must be a multiple of 0.5" }), Ld = ee().min(0).max($a).refine(function(t) {
  return Math.abs(Math.round(10 * t) - 10 * t) < 1e-6;
}, { message: "score must be a multiple of 0.1" }), za = ft(["N", "C"]), Ud = ge({ id: O().optional(), type: za.default("N"), movementNumber: ee().int().positive(), description: O(), directive: O().optional(), location: O().optional(), coefficient: ee().int().min(1).max(10), section: ft(["technical", "artistic", "quality"]).optional() }), Nd = ge({ id: O().optional(), type: za.default("C"), movementNumber: ee().int().positive(), name: O(), directive: O().optional(), coefficient: ee().int().min(1).max(2) });
ge({ id: O(), fvdId: Zn([ee(), O()]).nullable().optional(), source: ft(["catalog", "custom"]).optional(), testCode: O(), organization: O().optional(), level: O().optional(), testNumber: ee().int().optional(), movements: dt(Ud), collectives: dt(Nd), purpose: O().optional(), introduce: O().optional(), errorRule: ge({ first: Zn([ee(), O()]).nullable().optional(), second: Zn([ee(), O()]).nullable().optional(), third: Zn([ee(), O()]).nullable().optional() }).nullable().optional(), collectivesLabel: O().default("Collective Marks") });
var Dd = ge({ movementNumber: ee().int().positive(), score: Ld.optional().nullable(), remarks: O().max(500).optional(), flagged: cn().default(!1), annotatedDirective: O().optional(), annotatedDescription: O().optional(), deductions: dt(ge({ id: O(), reason: O(), points: ee().positive() })).optional() }), $d = ge({ score: Id.optional(), remarks: O().max(500).optional(), flagged: cn().optional(), annotatedName: O().optional(), annotatedDirective: O().optional() }), Fd = Ad(O().regex(/^\d+$/), $d);
ge({ id: O().optional(), rideId: O(), judgeId: O(), testId: O(), movementScores: dt(Dd).default([]), collectives: Fd.default({}), annotatedPurpose: O().optional(), annotatedIntroduce: O().optional(), generalRemarks: O().max(2e3).optional(), entryTimeSeconds: ee().nonnegative().optional(), totalPoints: ee().optional(), maxPoints: ee().optional(), percentage: ee().optional(), technicalPoints: ee().optional(), technicalMaxPoints: ee().optional(), artisticPoints: ee().optional(), artisticMaxPoints: ee().optional(), qualityPoints: ee().optional(), qualityMaxPoints: ee().optional(), judgeSignature: O().optional(), signature: ge({ judgeId: O(), signatureHash: O(), signedAt: O() }).optional(), eliminations: dt(ge({ id: O(), reason: O(), movementNumber: ee().int().positive().nullable().optional(), fromError: cn().optional() })).optional(), errors: dt(ge({ id: O(), label: O(), points: ee().nonnegative().optional(), percent: ee().nonnegative().optional(), movementNumber: ee().int().positive().nullable().optional() })).optional(), marksConfirmedAt: O().optional(), marksConfirmedBy: O().optional(), timeFault: ge({ exceeded: cn(), elapsedSeconds: ee(), limitSeconds: ee(), recordedAt: O() }).optional(), completedAt: O().optional() });
ft(Na);
var vo = ge(Object.fromEntries(Na.map(function(t) {
  return [t, dt(O()).optional()];
})));
ge({ id: O(), showId: O(), testId: O().optional(), className: O(), scheduledTime: O(), ring: O().optional(), judgeAssignments: vo.optional(), judgeIds: dt(O()).optional(), scribeAssignments: vo.optional(), qualityJudging: ge({ topology: ft(["two-judge", "technical-only"]), qualityPosition: ft(["E", "B"]).nullable().optional(), qualityJudge: O().nullable().optional() }).optional(), faultTimeLimitSeconds: ee().int().positive().default(45), errorDeductionScheme: ft(Object.values(eo)).default(eo.POINTS), sectionJudgeAssignments: ge({ technical: O().nullable().optional(), quality: O().nullable().optional() }).optional(), status: O().optional(), order: ee().optional() });
var Bd = ge({ id: O(), type: ft(Object.values(Da)), raisedByScribeId: O().nullable(), raisedAt: O(), acknowledged: ge({ byScribeId: O().nullable(), at: O() }).nullable().optional() });
ge({ type: ft(Object.values(Da)) });
ge({ id: O(), classId: O(), testId: O().optional(), horseId: O(), riderId: O(), rideNumber: ee().int().positive(), scheduledTime: O().optional(), status: O().optional(), percentage: ee().optional(), allSheetsCompletedAt: O().nullable().optional(), adminConfirmedAt: O().nullable().optional(), adminConfirmedBy: O().nullable().optional(), compositePercentage: ee().nullable().optional(), placing: ee().int().positive().nullable().optional(), isManual: cn().optional(), needsReview: cn().optional(), judgeIds: dt(O()).optional(), competitorNumber: O().optional(), horseName: O().optional(), riderName: O().optional(), resolvedIntoRideId: O().nullable().optional(), utilityEvents: dt(Bd).optional() });
ge({ classId: O(), testId: O().optional(), competitorNumber: O().optional(), horseName: O().optional(), riderName: O().optional() });
ge({ id: O(), personType: ft(["RIDER", "JUDGE", "SCRIBE"]), firstName: O(), lastName: O(), usefId: O().optional(), email: O().optional(), unlockCode: O().regex(/^\d{4,6}$/, "unlockCode must be 4–6 digits").optional(), userId: O().optional() });
ge({ id: O(), name: O(), breed: O().optional(), foalYear: ee().int().optional(), usefId: O().optional() });
function qa(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: Md } = Object.prototype, { getPrototypeOf: Ys } = Object, { iterator: sr, toStringTag: Za } = Symbol, kr = (ns = /* @__PURE__ */ Object.create(null), (t) => {
  const e = Md.call(t);
  return ns[e] || (ns[e] = e.slice(8, -1).toLowerCase());
});
var ns;
const st = (t) => (t = t.toLowerCase(), (e) => kr(e) === t), $r = (t) => (e) => typeof e === t, { isArray: Vt } = Array, tn = $r("undefined");
function _n(t) {
  return t !== null && !tn(t) && t.constructor !== null && !tn(t.constructor) && De(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const yo = st("ArrayBuffer"), zd = $r("string"), De = $r("function"), bo = $r("number"), gn = (t) => t !== null && typeof t == "object", Hn = (t) => {
  if (kr(t) !== "object") return !1;
  const e = Ys(t);
  return !(e !== null && e !== Object.prototype && Object.getPrototypeOf(e) !== null || Za in t || sr in t);
}, qd = st("Date"), Zd = st("File"), Hd = st("Blob"), Wd = st("FileList"), Jd = st("URLSearchParams"), [Vd, Kd, Gd, Yd] = ["ReadableStream", "Request", "Response", "Headers"].map(st);
function Sn(t, e, { allOwnKeys: n = !1 } = {}) {
  if (t == null) return;
  let r, s;
  if (typeof t != "object" && (t = [t]), Vt(t)) for (r = 0, s = t.length; r < s; r++) e.call(null, t[r], r, t);
  else {
    if (_n(t)) return;
    const i = n ? Object.getOwnPropertyNames(t) : Object.keys(t), o = i.length;
    let a;
    for (r = 0; r < o; r++) a = i[r], e.call(null, t[a], a, t);
  }
}
function wo(t, e) {
  if (_n(t)) return null;
  e = e.toLowerCase();
  const n = Object.keys(t);
  let r, s = n.length;
  for (; s-- > 0; ) if (r = n[s], e === r.toLowerCase()) return r;
  return null;
}
const Nt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, xo = (t) => !tn(t) && t !== Nt, Xd = (rs = typeof Uint8Array < "u" && Ys(Uint8Array), (t) => rs && t instanceof rs);
var rs;
const Qd = st("HTMLFormElement"), So = (({ hasOwnProperty: t }) => (e, n) => t.call(e, n))(Object.prototype), ef = st("RegExp"), Ro = (t, e) => {
  const n = Object.getOwnPropertyDescriptors(t), r = {};
  Sn(n, (s, i) => {
    let o;
    (o = e(s, i, t)) !== !1 && (r[i] = o || s);
  }), Object.defineProperties(t, r);
}, tf = st("AsyncFunction"), Ha = (_o = typeof setImmediate == "function", Oo = De(Nt.postMessage), _o ? setImmediate : Oo ? (ss = `axios@${Math.random()}`, Wn = [], Nt.addEventListener("message", ({ source: t, data: e }) => {
  t === Nt && e === ss && Wn.length && Wn.shift()();
}, !1), (t) => {
  Wn.push(t), Nt.postMessage(ss, "*");
}) : (t) => setTimeout(t));
var _o, Oo, ss, Wn;
const nf = typeof queueMicrotask < "u" ? queueMicrotask.bind(Nt) : typeof process < "u" && process.nextTick || Ha, b = { isArray: Vt, isArrayBuffer: yo, isBuffer: _n, isFormData: (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || De(t.append) && ((e = kr(t)) === "formdata" || e === "object" && De(t.toString) && t.toString() === "[object FormData]"));
}, isArrayBufferView: function(t) {
  let e;
  return e = typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(t) : t && t.buffer && yo(t.buffer), e;
}, isString: zd, isNumber: bo, isBoolean: (t) => t === !0 || t === !1, isObject: gn, isPlainObject: Hn, isEmptyObject: (t) => {
  if (!gn(t) || _n(t)) return !1;
  try {
    return Object.keys(t).length === 0 && Object.getPrototypeOf(t) === Object.prototype;
  } catch {
    return !1;
  }
}, isReadableStream: Vd, isRequest: Kd, isResponse: Gd, isHeaders: Yd, isUndefined: tn, isDate: qd, isFile: Zd, isBlob: Hd, isRegExp: ef, isFunction: De, isStream: (t) => gn(t) && De(t.pipe), isURLSearchParams: Jd, isTypedArray: Xd, isFileList: Wd, forEach: Sn, merge: function t() {
  const { caseless: e, skipUndefined: n } = xo(this) && this || {}, r = {}, s = (i, o) => {
    const a = e && wo(r, o) || o;
    Hn(r[a]) && Hn(i) ? r[a] = t(r[a], i) : Hn(i) ? r[a] = t({}, i) : Vt(i) ? r[a] = i.slice() : n && tn(i) || (r[a] = i);
  };
  for (let i = 0, o = arguments.length; i < o; i++) arguments[i] && Sn(arguments[i], s);
  return r;
}, extend: (t, e, n, { allOwnKeys: r } = {}) => (Sn(e, (s, i) => {
  n && De(s) ? t[i] = qa(s, n) : t[i] = s;
}, { allOwnKeys: r }), t), trim: (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""), stripBOM: (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), inherits: (t, e, n, r) => {
  t.prototype = Object.create(e.prototype, r), t.prototype.constructor = t, Object.defineProperty(t, "super", { value: e.prototype }), n && Object.assign(t.prototype, n);
}, toFlatObject: (t, e, n, r) => {
  let s, i, o;
  const a = {};
  if (e = e || {}, t == null) return e;
  do {
    for (s = Object.getOwnPropertyNames(t), i = s.length; i-- > 0; ) o = s[i], r && !r(o, t, e) || a[o] || (e[o] = t[o], a[o] = !0);
    t = n !== !1 && Ys(t);
  } while (t && (!n || n(t, e)) && t !== Object.prototype);
  return e;
}, kindOf: kr, kindOfTest: st, endsWith: (t, e, n) => {
  t = String(t), (n === void 0 || n > t.length) && (n = t.length), n -= e.length;
  const r = t.indexOf(e, n);
  return r !== -1 && r === n;
}, toArray: (t) => {
  if (!t) return null;
  if (Vt(t)) return t;
  let e = t.length;
  if (!bo(e)) return null;
  const n = new Array(e);
  for (; e-- > 0; ) n[e] = t[e];
  return n;
}, forEachEntry: (t, e) => {
  const n = (t && t[sr]).call(t);
  let r;
  for (; (r = n.next()) && !r.done; ) {
    const s = r.value;
    e.call(t, s[0], s[1]);
  }
}, matchAll: (t, e) => {
  let n;
  const r = [];
  for (; (n = t.exec(e)) !== null; ) r.push(n);
  return r;
}, isHTMLForm: Qd, hasOwnProperty: So, hasOwnProp: So, reduceDescriptors: Ro, freezeMethods: (t) => {
  Ro(t, (e, n) => {
    if (De(t) && ["arguments", "caller", "callee"].indexOf(n) !== -1) return !1;
    const r = t[n];
    De(r) && (e.enumerable = !1, "writable" in e ? e.writable = !1 : e.set || (e.set = () => {
      throw Error("Can not rewrite read-only method '" + n + "'");
    }));
  });
}, toObjectSet: (t, e) => {
  const n = {}, r = (s) => {
    s.forEach((i) => {
      n[i] = !0;
    });
  };
  return Vt(t) ? r(t) : r(String(t).split(e)), n;
}, toCamelCase: (t) => t.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(e, n, r) {
  return n.toUpperCase() + r;
}), noop: () => {
}, toFiniteNumber: (t, e) => t != null && Number.isFinite(t = +t) ? t : e, findKey: wo, global: Nt, isContextDefined: xo, isSpecCompliantForm: function(t) {
  return !!(t && De(t.append) && t[Za] === "FormData" && t[sr]);
}, toJSONObject: (t) => {
  const e = new Array(10), n = (r, s) => {
    if (gn(r)) {
      if (e.indexOf(r) >= 0) return;
      if (_n(r)) return r;
      if (!("toJSON" in r)) {
        e[s] = r;
        const i = Vt(r) ? [] : {};
        return Sn(r, (o, a) => {
          const u = n(o, s + 1);
          !tn(u) && (i[a] = u);
        }), e[s] = void 0, i;
      }
    }
    return r;
  };
  return n(t, 0);
}, isAsyncFn: tf, isThenable: (t) => t && (gn(t) || De(t)) && De(t.then) && De(t.catch), setImmediate: Ha, asap: nf, isIterable: (t) => t != null && De(t[sr]) };
function nn(t, e, n, r, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), n && (this.config = n), r && (this.request = r), s && (this.response = s, this.status = s.status ? s.status : null);
}
b.inherits(nn, Error, { toJSON: function() {
  return { message: this.message, name: this.name, description: this.description, number: this.number, fileName: this.fileName, lineNumber: this.lineNumber, columnNumber: this.columnNumber, stack: this.stack, config: b.toJSONObject(this.config), code: this.code, status: this.status };
} });
const Eo = nn.prototype, jo = {};
["ERR_BAD_OPTION_VALUE", "ERR_BAD_OPTION", "ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK", "ERR_FR_TOO_MANY_REDIRECTS", "ERR_DEPRECATED", "ERR_BAD_RESPONSE", "ERR_BAD_REQUEST", "ERR_CANCELED", "ERR_NOT_SUPPORT", "ERR_INVALID_URL"].forEach((t) => {
  jo[t] = { value: t };
}), Object.defineProperties(nn, jo), Object.defineProperty(Eo, "isAxiosError", { value: !0 }), nn.from = (t, e, n, r, s, i) => {
  const o = Object.create(Eo);
  b.toFlatObject(t, o, function(c) {
    return c !== Error.prototype;
  }, (c) => c !== "isAxiosError");
  const a = t && t.message ? t.message : "Error", u = e == null && t ? t.code : e;
  return nn.call(o, a, u, n, r, s), t && o.cause == null && Object.defineProperty(o, "cause", { value: t, configurable: !0 }), o.name = t && t.name || "Error", i && Object.assign(o, i), o;
};
const X = nn;
function is(t) {
  return b.isPlainObject(t) || b.isArray(t);
}
function Wa(t) {
  return b.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function To(t, e, n) {
  return t ? t.concat(e).map(function(r, s) {
    return r = Wa(r), !n && s ? "[" + r + "]" : r;
  }).join(n ? "." : "") : e;
}
const rf = b.toFlatObject(b, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
}), Pr = function(t, e, n) {
  if (!b.isObject(t)) throw new TypeError("target must be an object");
  e = e || new FormData();
  const r = (n = b.toFlatObject(n, { metaTokens: !0, dots: !1, indexes: !1 }, !1, function(f, p) {
    return !b.isUndefined(p[f]);
  })).metaTokens, s = n.visitor || c, i = n.dots, o = n.indexes, a = (n.Blob || typeof Blob < "u" && Blob) && b.isSpecCompliantForm(e);
  if (!b.isFunction(s)) throw new TypeError("visitor must be a function");
  function u(f) {
    if (f === null) return "";
    if (b.isDate(f)) return f.toISOString();
    if (b.isBoolean(f)) return f.toString();
    if (!a && b.isBlob(f)) throw new X("Blob is not supported. Use a Buffer instead.");
    return b.isArrayBuffer(f) || b.isTypedArray(f) ? a && typeof Blob == "function" ? new Blob([f]) : Buffer.from(f) : f;
  }
  function c(f, p, v) {
    let h = f;
    if (f && !v && typeof f == "object") {
      if (b.endsWith(p, "{}")) p = r ? p : p.slice(0, -2), f = JSON.stringify(f);
      else if (b.isArray(f) && function(R) {
        return b.isArray(R) && !R.some(is);
      }(f) || (b.isFileList(f) || b.endsWith(p, "[]")) && (h = b.toArray(f))) return p = Wa(p), h.forEach(function(R, J) {
        !b.isUndefined(R) && R !== null && e.append(o === !0 ? To([p], J, i) : o === null ? p : p + "[]", u(R));
      }), !1;
    }
    return !!is(f) || (e.append(To(v, p, i), u(f)), !1);
  }
  const l = [], d = Object.assign(rf, { defaultVisitor: c, convertValue: u, isVisitable: is });
  if (!b.isObject(t)) throw new TypeError("data must be an object");
  return function f(p, v) {
    if (!b.isUndefined(p)) {
      if (l.indexOf(p) !== -1) throw Error("Circular reference detected in " + v.join("."));
      l.push(p), b.forEach(p, function(h, R) {
        (!(b.isUndefined(h) || h === null) && s.call(e, h, b.isString(R) ? R.trim() : R, v, d)) === !0 && f(h, v ? v.concat(R) : [R]);
      }), l.pop();
    }
  }(t), e;
};
function Co(t) {
  const e = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+", "%00": "\0" };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(n) {
    return e[n];
  });
}
function Ja(t, e) {
  this._pairs = [], t && Pr(t, this, e);
}
const ko = Ja.prototype;
ko.append = function(t, e) {
  this._pairs.push([t, e]);
}, ko.toString = function(t) {
  const e = t ? function(n) {
    return t.call(this, n, Co);
  } : Co;
  return this._pairs.map(function(n) {
    return e(n[0]) + "=" + e(n[1]);
  }, "").join("&");
};
const Va = Ja;
function sf(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Ka(t, e, n) {
  if (!e) return t;
  const r = n && n.encode || sf;
  b.isFunction(n) && (n = { serialize: n });
  const s = n && n.serialize;
  let i;
  if (i = s ? s(e, n) : b.isURLSearchParams(e) ? e.toString() : new Va(e, n).toString(r), i) {
    const o = t.indexOf("#");
    o !== -1 && (t = t.slice(0, o)), t += (t.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return t;
}
const Po = class {
  constructor() {
    this.handlers = [];
  }
  use(t, e, n) {
    return this.handlers.push({ fulfilled: t, rejected: e, synchronous: !!n && n.synchronous, runWhen: n ? n.runWhen : null }), this.handlers.length - 1;
  }
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  clear() {
    this.handlers && (this.handlers = []);
  }
  forEach(t) {
    b.forEach(this.handlers, function(e) {
      e !== null && t(e);
    });
  }
}, Ga = { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 }, of = { isBrowser: !0, classes: { URLSearchParams: typeof URLSearchParams < "u" ? URLSearchParams : Va, FormData: typeof FormData < "u" ? FormData : null, Blob: typeof Blob < "u" ? Blob : null }, protocols: ["http", "https", "file", "blob", "url", "data"] }, Xs = typeof window < "u" && typeof document < "u", As = typeof navigator == "object" && navigator || void 0, af = Xs && (!As || ["ReactNative", "NativeScript", "NS"].indexOf(As.product) < 0), uf = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function", cf = Xs && window.location.href || "http://localhost", Pe = { ..._s, ...of }, Ya = function(t) {
  function e(n, r, s, i) {
    let o = n[i++];
    if (o === "__proto__") return !0;
    const a = Number.isFinite(+o), u = i >= n.length;
    return o = !o && b.isArray(s) ? s.length : o, u ? (b.hasOwnProp(s, o) ? s[o] = [s[o], r] : s[o] = r, !a) : (s[o] && b.isObject(s[o]) || (s[o] = []), e(n, r, s[o], i) && b.isArray(s[o]) && (s[o] = function(c) {
      const l = {}, d = Object.keys(c);
      let f;
      const p = d.length;
      let v;
      for (f = 0; f < p; f++) v = d[f], l[v] = c[v];
      return l;
    }(s[o])), !a);
  }
  if (b.isFormData(t) && b.isFunction(t.entries)) {
    const n = {};
    return b.forEachEntry(t, (r, s) => {
      e(function(i) {
        return b.matchAll(/\w+|\[(\w*)]/g, i).map((o) => o[0] === "[]" ? "" : o[1] || o[0]);
      }(r), s, n, 0);
    }), n;
  }
  return null;
}, Qs = { transitional: Ga, adapter: ["xhr", "http", "fetch"], transformRequest: [function(t, e) {
  const n = e.getContentType() || "", r = n.indexOf("application/json") > -1, s = b.isObject(t);
  if (s && b.isHTMLForm(t) && (t = new FormData(t)), b.isFormData(t)) return r ? JSON.stringify(Ya(t)) : t;
  if (b.isArrayBuffer(t) || b.isBuffer(t) || b.isStream(t) || b.isFile(t) || b.isBlob(t) || b.isReadableStream(t)) return t;
  if (b.isArrayBufferView(t)) return t.buffer;
  if (b.isURLSearchParams(t)) return e.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
  let i;
  if (s) {
    if (n.indexOf("application/x-www-form-urlencoded") > -1) return function(o, a) {
      return Pr(o, new Pe.classes.URLSearchParams(), { visitor: function(u, c, l, d) {
        return Pe.isNode && b.isBuffer(u) ? (this.append(c, u.toString("base64")), !1) : d.defaultVisitor.apply(this, arguments);
      }, ...a });
    }(t, this.formSerializer).toString();
    if ((i = b.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
      const o = this.env && this.env.FormData;
      return Pr(i ? { "files[]": t } : t, o && new o(), this.formSerializer);
    }
  }
  return s || r ? (e.setContentType("application/json", !1), function(o) {
    if (b.isString(o)) try {
      return (0, JSON.parse)(o), b.trim(o);
    } catch (a) {
      if (a.name !== "SyntaxError") throw a;
    }
    return (0, JSON.stringify)(o);
  }(t)) : t;
}], transformResponse: [function(t) {
  const e = this.transitional || Qs.transitional, n = e && e.forcedJSONParsing, r = this.responseType === "json";
  if (b.isResponse(t) || b.isReadableStream(t)) return t;
  if (t && b.isString(t) && (n && !this.responseType || r)) {
    const s = !(e && e.silentJSONParsing) && r;
    try {
      return JSON.parse(t, this.parseReviver);
    } catch (i) {
      if (s)
        throw i.name === "SyntaxError" ? X.from(i, X.ERR_BAD_RESPONSE, this, null, this.response) : i;
    }
  }
  return t;
}], timeout: 0, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN", maxContentLength: -1, maxBodyLength: -1, env: { FormData: Pe.classes.FormData, Blob: Pe.classes.Blob }, validateStatus: function(t) {
  return t >= 200 && t < 300;
}, headers: { common: { Accept: "application/json, text/plain, */*", "Content-Type": void 0 } } };
b.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  Qs.headers[t] = {};
});
const ei = Qs, lf = b.toObjectSet(["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"]), Ao = Symbol("internals");
function vn(t) {
  return t && String(t).trim().toLowerCase();
}
function ir(t) {
  return t === !1 || t == null ? t : b.isArray(t) ? t.map(ir) : String(t);
}
function os(t, e, n, r, s) {
  return b.isFunction(r) ? r.call(this, e, n) : (s && (e = n), b.isString(e) ? b.isString(r) ? e.indexOf(r) !== -1 : b.isRegExp(r) ? r.test(e) : void 0 : void 0);
}
class or {
  constructor(e) {
    e && this.set(e);
  }
  set(e, n, r) {
    const s = this;
    function i(a, u, c) {
      const l = vn(u);
      if (!l) throw new Error("header name must be a non-empty string");
      const d = b.findKey(s, l);
      (!d || s[d] === void 0 || c === !0 || c === void 0 && s[d] !== !1) && (s[d || u] = ir(a));
    }
    const o = (a, u) => b.forEach(a, (c, l) => i(c, l, u));
    if (b.isPlainObject(e) || e instanceof this.constructor) o(e, n);
    else if (b.isString(e) && (e = e.trim()) && !/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim())) o(((a) => {
      const u = {};
      let c, l, d;
      return a && a.split(`
`).forEach(function(f) {
        d = f.indexOf(":"), c = f.substring(0, d).trim().toLowerCase(), l = f.substring(d + 1).trim(), !c || u[c] && lf[c] || (c === "set-cookie" ? u[c] ? u[c].push(l) : u[c] = [l] : u[c] = u[c] ? u[c] + ", " + l : l);
      }), u;
    })(e), n);
    else if (b.isObject(e) && b.isIterable(e)) {
      let a, u, c = {};
      for (const l of e) {
        if (!b.isArray(l)) throw TypeError("Object iterator must return a key-value pair");
        c[u = l[0]] = (a = c[u]) ? b.isArray(a) ? [...a, l[1]] : [a, l[1]] : l[1];
      }
      o(c, n);
    } else e != null && i(n, e, r);
    return this;
  }
  get(e, n) {
    if (e = vn(e)) {
      const r = b.findKey(this, e);
      if (r) {
        const s = this[r];
        if (!n) return s;
        if (n === !0) return function(i) {
          const o = /* @__PURE__ */ Object.create(null), a = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
          let u;
          for (; u = a.exec(i); ) o[u[1]] = u[2];
          return o;
        }(s);
        if (b.isFunction(n)) return n.call(this, s, r);
        if (b.isRegExp(n)) return n.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, n) {
    if (e = vn(e)) {
      const r = b.findKey(this, e);
      return !(!r || this[r] === void 0 || n && !os(0, this[r], r, n));
    }
    return !1;
  }
  delete(e, n) {
    const r = this;
    let s = !1;
    function i(o) {
      if (o = vn(o)) {
        const a = b.findKey(r, o);
        !a || n && !os(0, r[a], a, n) || (delete r[a], s = !0);
      }
    }
    return b.isArray(e) ? e.forEach(i) : i(e), s;
  }
  clear(e) {
    const n = Object.keys(this);
    let r = n.length, s = !1;
    for (; r--; ) {
      const i = n[r];
      e && !os(0, this[i], i, e, !0) || (delete this[i], s = !0);
    }
    return s;
  }
  normalize(e) {
    const n = this, r = {};
    return b.forEach(this, (s, i) => {
      const o = b.findKey(r, i);
      if (o) return n[o] = ir(s), void delete n[i];
      const a = e ? function(u) {
        return u.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (c, l, d) => l.toUpperCase() + d);
      }(i) : String(i).trim();
      a !== i && delete n[i], n[a] = ir(s), r[a] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const n = /* @__PURE__ */ Object.create(null);
    return b.forEach(this, (r, s) => {
      r != null && r !== !1 && (n[s] = e && b.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, n]) => e + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...n) {
    const r = new this(e);
    return n.forEach((s) => r.set(s)), r;
  }
  static accessor(e) {
    const n = (this[Ao] = this[Ao] = { accessors: {} }).accessors, r = this.prototype;
    function s(i) {
      const o = vn(i);
      n[o] || (function(a, u) {
        const c = b.toCamelCase(" " + u);
        ["get", "set", "has"].forEach((l) => {
          Object.defineProperty(a, l + c, { value: function(d, f, p) {
            return this[l].call(this, u, d, f, p);
          }, configurable: !0 });
        });
      }(r, i), n[o] = !0);
    }
    return b.isArray(e) ? e.forEach(s) : s(e), this;
  }
}
or.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]), b.reduceDescriptors(or.prototype, ({ value: t }, e) => {
  let n = e[0].toUpperCase() + e.slice(1);
  return { get: () => t, set(r) {
    this[n] = r;
  } };
}), b.freezeMethods(or);
const nt = or;
function as(t, e) {
  const n = this || ei, r = e || n, s = nt.from(r.headers);
  let i = r.data;
  return b.forEach(t, function(o) {
    i = o.call(n, i, s.normalize(), e ? e.status : void 0);
  }), s.normalize(), i;
}
function Xa(t) {
  return !(!t || !t.__CANCEL__);
}
function Qa(t, e, n) {
  X.call(this, t ?? "canceled", X.ERR_CANCELED, e, n), this.name = "CanceledError";
}
b.inherits(Qa, X, { __CANCEL__: !0 });
const Nn = Qa;
function eu(t, e, n) {
  const r = n.config.validateStatus;
  n.status && r && !r(n.status) ? e(new X("Request failed with status code " + n.status, [X.ERR_BAD_REQUEST, X.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4], n.config, n.request, n)) : t(n);
}
const Ar = (t, e, n = 3) => {
  let r = 0;
  const s = function(i, o) {
    i = i || 10;
    const a = new Array(i), u = new Array(i);
    let c, l = 0, d = 0;
    return o = o !== void 0 ? o : 1e3, function(f) {
      const p = Date.now(), v = u[d];
      c || (c = p), a[l] = f, u[l] = p;
      let h = d, R = 0;
      for (; h !== l; ) R += a[h++], h %= i;
      if (l = (l + 1) % i, l === d && (d = (d + 1) % i), p - c < o) return;
      const J = v && p - v;
      return J ? Math.round(1e3 * R / J) : void 0;
    };
  }(50, 250);
  return function(i, o) {
    let a, u, c = 0, l = 1e3 / o;
    const d = (f, p = Date.now()) => {
      c = p, a = null, u && (clearTimeout(u), u = null), i(...f);
    };
    return [(...f) => {
      const p = Date.now(), v = p - c;
      v >= l ? d(f, p) : (a = f, u || (u = setTimeout(() => {
        u = null, d(a);
      }, l - v)));
    }, () => a && d(a)];
  }((i) => {
    const o = i.loaded, a = i.lengthComputable ? i.total : void 0, u = o - r, c = s(u);
    r = o, t({ loaded: o, total: a, progress: a ? o / a : void 0, bytes: u, rate: c || void 0, estimated: c && a && o <= a ? (a - o) / c : void 0, event: i, lengthComputable: a != null, [e ? "download" : "upload"]: !0 });
  }, n);
}, Io = (t, e) => {
  const n = t != null;
  return [(r) => e[0]({ lengthComputable: n, total: t, loaded: r }), e[1]];
}, Lo = (t) => (...e) => b.asap(() => t(...e)), df = Pe.hasStandardBrowserEnv ? /* @__PURE__ */ ((t, e) => (n) => (n = new URL(n, Pe.origin), t.protocol === n.protocol && t.host === n.host && (e || t.port === n.port)))(new URL(Pe.origin), Pe.navigator && /(msie|trident)/i.test(Pe.navigator.userAgent)) : () => !0, ff = Pe.hasStandardBrowserEnv ? { write(t, e, n, r, s, i, o) {
  if (typeof document > "u") return;
  const a = [`${t}=${encodeURIComponent(e)}`];
  b.isNumber(n) && a.push(`expires=${new Date(n).toUTCString()}`), b.isString(r) && a.push(`path=${r}`), b.isString(s) && a.push(`domain=${s}`), i === !0 && a.push("secure"), b.isString(o) && a.push(`SameSite=${o}`), document.cookie = a.join("; ");
}, read(t) {
  if (typeof document > "u") return null;
  const e = document.cookie.match(new RegExp("(?:^|; )" + t + "=([^;]*)"));
  return e ? decodeURIComponent(e[1]) : null;
}, remove(t) {
  this.write(t, "", Date.now() - 864e5, "/");
} } : { write() {
}, read: () => null, remove() {
} };
function tu(t, e, n) {
  let r = !/^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
  return t && (r || n == 0) ? function(s, i) {
    return i ? s.replace(/\/?\/$/, "") + "/" + i.replace(/^\/+/, "") : s;
  }(t, e) : e;
}
const Uo = (t) => t instanceof nt ? { ...t } : t;
function Mt(t, e) {
  e = e || {};
  const n = {};
  function r(c, l, d, f) {
    return b.isPlainObject(c) && b.isPlainObject(l) ? b.merge.call({ caseless: f }, c, l) : b.isPlainObject(l) ? b.merge({}, l) : b.isArray(l) ? l.slice() : l;
  }
  function s(c, l, d, f) {
    return b.isUndefined(l) ? b.isUndefined(c) ? void 0 : r(void 0, c, 0, f) : r(c, l, 0, f);
  }
  function i(c, l) {
    if (!b.isUndefined(l)) return r(void 0, l);
  }
  function o(c, l) {
    return b.isUndefined(l) ? b.isUndefined(c) ? void 0 : r(void 0, c) : r(void 0, l);
  }
  function a(c, l, d) {
    return d in e ? r(c, l) : d in t ? r(void 0, c) : void 0;
  }
  const u = { url: i, method: i, data: i, baseURL: o, transformRequest: o, transformResponse: o, paramsSerializer: o, timeout: o, timeoutMessage: o, withCredentials: o, withXSRFToken: o, adapter: o, responseType: o, xsrfCookieName: o, xsrfHeaderName: o, onUploadProgress: o, onDownloadProgress: o, decompress: o, maxContentLength: o, maxBodyLength: o, beforeRedirect: o, transport: o, httpAgent: o, httpsAgent: o, cancelToken: o, socketPath: o, responseEncoding: o, validateStatus: a, headers: (c, l, d) => s(Uo(c), Uo(l), 0, !0) };
  return b.forEach(Object.keys({ ...t, ...e }), function(c) {
    const l = u[c] || s, d = l(t[c], e[c], c);
    b.isUndefined(d) && l !== a || (n[c] = d);
  }), n;
}
const nu = (t) => {
  const e = Mt({}, t);
  let { data: n, withXSRFToken: r, xsrfHeaderName: s, xsrfCookieName: i, headers: o, auth: a } = e;
  if (e.headers = o = nt.from(o), e.url = Ka(tu(e.baseURL, e.url, e.allowAbsoluteUrls), t.params, t.paramsSerializer), a && o.set("Authorization", "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))), b.isFormData(n)) {
    if (Pe.hasStandardBrowserEnv || Pe.hasStandardBrowserWebWorkerEnv) o.setContentType(void 0);
    else if (b.isFunction(n.getHeaders)) {
      const u = n.getHeaders(), c = ["content-type", "content-length"];
      Object.entries(u).forEach(([l, d]) => {
        c.includes(l.toLowerCase()) && o.set(l, d);
      });
    }
  }
  if (Pe.hasStandardBrowserEnv && (r && b.isFunction(r) && (r = r(e)), r || r !== !1 && df(e.url))) {
    const u = s && i && ff.read(i);
    u && o.set(s, u);
  }
  return e;
}, hf = typeof XMLHttpRequest < "u" && function(t) {
  return new Promise(function(e, n) {
    const r = nu(t);
    let s = r.data;
    const i = nt.from(r.headers).normalize();
    let o, a, u, c, l, { responseType: d, onUploadProgress: f, onDownloadProgress: p } = r;
    function v() {
      c && c(), l && l(), r.cancelToken && r.cancelToken.unsubscribe(o), r.signal && r.signal.removeEventListener("abort", o);
    }
    let h = new XMLHttpRequest();
    function R() {
      if (!h) return;
      const j = nt.from("getAllResponseHeaders" in h && h.getAllResponseHeaders());
      eu(function(W) {
        e(W), v();
      }, function(W) {
        n(W), v();
      }, { data: d && d !== "text" && d !== "json" ? h.response : h.responseText, status: h.status, statusText: h.statusText, headers: j, config: t, request: h }), h = null;
    }
    h.open(r.method.toUpperCase(), r.url, !0), h.timeout = r.timeout, "onloadend" in h ? h.onloadend = R : h.onreadystatechange = function() {
      h && h.readyState === 4 && (h.status !== 0 || h.responseURL && h.responseURL.indexOf("file:") === 0) && setTimeout(R);
    }, h.onabort = function() {
      h && (n(new X("Request aborted", X.ECONNABORTED, t, h)), h = null);
    }, h.onerror = function(j) {
      const W = j && j.message ? j.message : "Network Error", L = new X(W, X.ERR_NETWORK, t, h);
      L.event = j || null, n(L), h = null;
    }, h.ontimeout = function() {
      let j = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const W = r.transitional || Ga;
      r.timeoutErrorMessage && (j = r.timeoutErrorMessage), n(new X(j, W.clarifyTimeoutError ? X.ETIMEDOUT : X.ECONNABORTED, t, h)), h = null;
    }, s === void 0 && i.setContentType(null), "setRequestHeader" in h && b.forEach(i.toJSON(), function(j, W) {
      h.setRequestHeader(W, j);
    }), b.isUndefined(r.withCredentials) || (h.withCredentials = !!r.withCredentials), d && d !== "json" && (h.responseType = r.responseType), p && ([u, l] = Ar(p, !0), h.addEventListener("progress", u)), f && h.upload && ([a, c] = Ar(f), h.upload.addEventListener("progress", a), h.upload.addEventListener("loadend", c)), (r.cancelToken || r.signal) && (o = (j) => {
      h && (n(!j || j.type ? new Nn(null, t, h) : j), h.abort(), h = null);
    }, r.cancelToken && r.cancelToken.subscribe(o), r.signal && (r.signal.aborted ? o() : r.signal.addEventListener("abort", o)));
    const J = function(j) {
      const W = /^([-+\w]{1,25})(:?\/\/|:)/.exec(j);
      return W && W[1] || "";
    }(r.url);
    J && Pe.protocols.indexOf(J) === -1 ? n(new X("Unsupported protocol " + J + ":", X.ERR_BAD_REQUEST, t)) : h.send(s || null);
  });
}, pf = (t, e) => {
  const { length: n } = t = t ? t.filter(Boolean) : [];
  if (e || n) {
    let r, s = new AbortController();
    const i = function(c) {
      if (!r) {
        r = !0, a();
        const l = c instanceof Error ? c : this.reason;
        s.abort(l instanceof X ? l : new Nn(l instanceof Error ? l.message : l));
      }
    };
    let o = e && setTimeout(() => {
      o = null, i(new X(`timeout ${e} of ms exceeded`, X.ETIMEDOUT));
    }, e);
    const a = () => {
      t && (o && clearTimeout(o), o = null, t.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(i) : c.removeEventListener("abort", i);
      }), t = null);
    };
    t.forEach((c) => c.addEventListener("abort", i));
    const { signal: u } = s;
    return u.unsubscribe = () => b.asap(a), u;
  }
}, mf = function* (t, e) {
  let n = t.byteLength;
  if (n < e) return void (yield t);
  let r, s = 0;
  for (; s < n; ) r = s + e, yield t.slice(s, r), s = r;
}, No = (t, e, n, r) => {
  const s = async function* (u, c) {
    for await (const l of async function* (d) {
      if (d[Symbol.asyncIterator]) return void (yield* d);
      const f = d.getReader();
      try {
        for (; ; ) {
          const { done: p, value: v } = await f.read();
          if (p) break;
          yield v;
        }
      } finally {
        await f.cancel();
      }
    }(u)) yield* mf(l, c);
  }(t, e);
  let i, o = 0, a = (u) => {
    i || (i = !0, r && r(u));
  };
  return new ReadableStream({ async pull(u) {
    try {
      const { done: c, value: l } = await s.next();
      if (c) return a(), void u.close();
      let d = l.byteLength;
      if (n) {
        let f = o += d;
        n(f);
      }
      u.enqueue(new Uint8Array(l));
    } catch (c) {
      throw a(c), c;
    }
  }, cancel: (u) => (a(u), s.return()) }, { highWaterMark: 2 });
}, { isFunction: Jn } = b, gf = (({ Request: t, Response: e }) => ({ Request: t, Response: e }))(b.global), { ReadableStream: Do, TextEncoder: $o } = b.global, Fo = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, vf = (t) => {
  t = b.merge.call({ skipUndefined: !0 }, gf, t);
  const { fetch: e, Request: n, Response: r } = t, s = e ? Jn(e) : typeof fetch == "function", i = Jn(n), o = Jn(r);
  if (!s) return !1;
  const a = s && Jn(Do), u = s && (typeof $o == "function" ? (c = new $o(), (p) => c.encode(p)) : async (p) => new Uint8Array(await new n(p).arrayBuffer()));
  var c;
  const l = i && a && Fo(() => {
    let p = !1;
    const v = new n(Pe.origin, { body: new Do(), method: "POST", get duplex() {
      return p = !0, "half";
    } }).headers.has("Content-Type");
    return p && !v;
  }), d = o && a && Fo(() => b.isReadableStream(new r("").body)), f = { stream: d && ((p) => p.body) };
  return s && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((p) => {
    !f[p] && (f[p] = (v, h) => {
      let R = v && v[p];
      if (R) return R.call(v);
      throw new X(`Response type '${p}' is not supported`, X.ERR_NOT_SUPPORT, h);
    });
  }), async (p) => {
    let { url: v, method: h, data: R, signal: J, cancelToken: j, timeout: W, onDownloadProgress: L, onUploadProgress: ne, responseType: G, headers: Oe, withCredentials: me = "same-origin", fetchOptions: Me } = nu(p), Ye = e || fetch;
    G = G ? (G + "").toLowerCase() : "text";
    let le = pf([J, j && j.toAbortSignal()], W), Ee = null;
    const ce = le && le.unsubscribe && (() => {
      le.unsubscribe();
    });
    let se;
    try {
      if (ne && l && h !== "get" && h !== "head" && (se = await (async (he, pe) => {
        const je = b.toFiniteNumber(he.getContentLength());
        return je ?? (async (V) => V == null ? 0 : b.isBlob(V) ? V.size : b.isSpecCompliantForm(V) ? (await new n(Pe.origin, { method: "POST", body: V }).arrayBuffer()).byteLength : b.isArrayBufferView(V) || b.isArrayBuffer(V) ? V.byteLength : (b.isURLSearchParams(V) && (V += ""), b.isString(V) ? (await u(V)).byteLength : void 0))(pe);
      })(Oe, R)) !== 0) {
        let he, pe = new n(v, { method: "POST", body: R, duplex: "half" });
        if (b.isFormData(R) && (he = pe.headers.get("content-type")) && Oe.setContentType(he), pe.body) {
          const [je, V] = Io(se, Ar(Lo(ne)));
          R = No(pe.body, 65536, je, V);
        }
      }
      b.isString(me) || (me = me ? "include" : "omit");
      const oe = i && "credentials" in n.prototype, qe = { ...Me, signal: le, method: h.toUpperCase(), headers: Oe.normalize().toJSON(), body: R, duplex: "half", credentials: oe ? me : void 0 };
      Ee = i && new n(v, qe);
      let ve = await (i ? Ye(Ee, Me) : Ye(v, qe));
      const it = d && (G === "stream" || G === "response");
      if (d && (L || it && ce)) {
        const he = {};
        ["status", "statusText", "headers"].forEach((de) => {
          he[de] = ve[de];
        });
        const pe = b.toFiniteNumber(ve.headers.get("content-length")), [je, V] = L && Io(pe, Ar(Lo(L), !0)) || [];
        ve = new r(No(ve.body, 65536, je, () => {
          V && V(), ce && ce();
        }), he);
      }
      G = G || "text";
      let pt = await f[b.findKey(f, G) || "text"](ve, p);
      return !it && ce && ce(), await new Promise((he, pe) => {
        eu(he, pe, { data: pt, headers: nt.from(ve.headers), status: ve.status, statusText: ve.statusText, config: p, request: Ee });
      });
    } catch (oe) {
      throw ce && ce(), oe && oe.name === "TypeError" && /Load failed|fetch/i.test(oe.message) ? Object.assign(new X("Network Error", X.ERR_NETWORK, p, Ee), { cause: oe.cause || oe }) : X.from(oe, oe && oe.code, p, Ee);
    }
  };
}, yf = /* @__PURE__ */ new Map(), Bo = (t) => {
  let e = t && t.env || {};
  const { fetch: n, Request: r, Response: s } = e, i = [r, s, n];
  let o, a, u = i.length, c = yf;
  for (; u--; ) o = i[u], a = c.get(o), a === void 0 && c.set(o, a = u ? /* @__PURE__ */ new Map() : vf(e)), c = a;
  return a;
}, ru = (Bo(), { http: null, xhr: hf, fetch: { get: Bo } });
b.forEach(ru, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const Mo = (t) => `- ${t}`, bf = (t) => b.isFunction(t) || t === null || t === !1, su = function(t, e) {
  t = b.isArray(t) ? t : [t];
  const { length: n } = t;
  let r, s;
  const i = {};
  for (let o = 0; o < n; o++) {
    let a;
    if (r = t[o], s = r, !bf(r) && (s = ru[(a = String(r)).toLowerCase()], s === void 0)) throw new X(`Unknown adapter '${a}'`);
    if (s && (b.isFunction(s) || (s = s.get(e)))) break;
    i[a || "#" + o] = s;
  }
  if (!s) {
    const o = Object.entries(i).map(([u, c]) => `adapter ${u} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build"));
    let a = n ? o.length > 1 ? `since :
` + o.map(Mo).join(`
`) : " " + Mo(o[0]) : "as no adapter specified";
    throw new X("There is no suitable adapter to dispatch the request " + a, "ERR_NOT_SUPPORT");
  }
  return s;
};
function us(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted) throw new Nn(null, t);
}
function zo(t) {
  return us(t), t.headers = nt.from(t.headers), t.data = as.call(t, t.transformRequest), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), su(t.adapter || ei.adapter, t)(t).then(function(e) {
    return us(t), e.data = as.call(t, t.transformResponse, e), e.headers = nt.from(e.headers), e;
  }, function(e) {
    return Xa(e) || (us(t), e && e.response && (e.response.data = as.call(t, t.transformResponse, e.response), e.response.headers = nt.from(e.response.headers))), Promise.reject(e);
  });
}
const iu = "1.13.2", Ir = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  Ir[t] = function(n) {
    return typeof n === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const qo = {};
Ir.transitional = function(t, e, n) {
  function r(s, i) {
    return "[Axios v" + iu + "] Transitional option '" + s + "'" + i + (n ? ". " + n : "");
  }
  return (s, i, o) => {
    if (t === !1) throw new X(r(i, " has been removed" + (e ? " in " + e : "")), X.ERR_DEPRECATED);
    return e && !qo[i] && (qo[i] = !0, console.warn(r(i, " has been deprecated since v" + e + " and will be removed in the near future"))), !t || t(s, i, o);
  };
}, Ir.spelling = function(t) {
  return (e, n) => (console.warn(`${n} is likely a misspelling of ${t}`), !0);
};
const ar = { assertOptions: function(t, e, n) {
  if (typeof t != "object") throw new X("options must be an object", X.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(t);
  let s = r.length;
  for (; s-- > 0; ) {
    const i = r[s], o = e[i];
    if (o) {
      const a = t[i], u = a === void 0 || o(a, i, t);
      if (u !== !0) throw new X("option " + i + " must be " + u, X.ERR_BAD_OPTION_VALUE);
    } else if (n !== !0) throw new X("Unknown option " + i, X.ERR_BAD_OPTION);
  }
}, validators: Ir }, at = ar.validators;
class ur {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = { request: new Po(), response: new Po() };
  }
  async request(e, n) {
    try {
      return await this._request(e, n);
    } catch (r) {
      if (r instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(e, n) {
    typeof e == "string" ? (n = n || {}).url = e : n = e || {}, n = Mt(this.defaults, n);
    const { transitional: r, paramsSerializer: s, headers: i } = n;
    r !== void 0 && ar.assertOptions(r, { silentJSONParsing: at.transitional(at.boolean), forcedJSONParsing: at.transitional(at.boolean), clarifyTimeoutError: at.transitional(at.boolean) }, !1), s != null && (b.isFunction(s) ? n.paramsSerializer = { serialize: s } : ar.assertOptions(s, { encode: at.function, serialize: at.function }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), ar.assertOptions(n, { baseUrl: at.spelling("baseURL"), withXsrfToken: at.spelling("withXSRFToken") }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = i && b.merge(i.common, i[n.method]);
    i && b.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (v) => {
      delete i[v];
    }), n.headers = nt.concat(o, i);
    const a = [];
    let u = !0;
    this.interceptors.request.forEach(function(v) {
      typeof v.runWhen == "function" && v.runWhen(n) === !1 || (u = u && v.synchronous, a.unshift(v.fulfilled, v.rejected));
    });
    const c = [];
    let l;
    this.interceptors.response.forEach(function(v) {
      c.push(v.fulfilled, v.rejected);
    });
    let d, f = 0;
    if (!u) {
      const v = [zo.bind(this), void 0];
      for (v.unshift(...a), v.push(...c), d = v.length, l = Promise.resolve(n); f < d; ) l = l.then(v[f++], v[f++]);
      return l;
    }
    d = a.length;
    let p = n;
    for (; f < d; ) {
      const v = a[f++], h = a[f++];
      try {
        p = v(p);
      } catch (R) {
        h.call(this, R);
        break;
      }
    }
    try {
      l = zo.call(this, p);
    } catch (v) {
      return Promise.reject(v);
    }
    for (f = 0, d = c.length; f < d; ) l = l.then(c[f++], c[f++]);
    return l;
  }
  getUri(e) {
    return Ka(tu((e = Mt(this.defaults, e)).baseURL, e.url, e.allowAbsoluteUrls), e.params, e.paramsSerializer);
  }
}
b.forEach(["delete", "get", "head", "options"], function(t) {
  ur.prototype[t] = function(e, n) {
    return this.request(Mt(n || {}, { method: t, url: e, data: (n || {}).data }));
  };
}), b.forEach(["post", "put", "patch"], function(t) {
  function e(n) {
    return function(r, s, i) {
      return this.request(Mt(i || {}, { method: t, headers: n ? { "Content-Type": "multipart/form-data" } : {}, url: r, data: s }));
    };
  }
  ur.prototype[t] = e(), ur.prototype[t + "Form"] = e(!0);
});
const cr = ur;
class ti {
  constructor(e) {
    if (typeof e != "function") throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(s) {
      n = s;
    });
    const r = this;
    this.promise.then((s) => {
      if (!r._listeners) return;
      let i = r._listeners.length;
      for (; i-- > 0; ) r._listeners[i](s);
      r._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const o = new Promise((a) => {
        r.subscribe(a), i = a;
      }).then(s);
      return o.cancel = function() {
        r.unsubscribe(i);
      }, o;
    }, e(function(s, i, o) {
      r.reason || (r.reason = new Nn(s, i, o), n(r.reason));
    });
  }
  throwIfRequested() {
    if (this.reason) throw this.reason;
  }
  subscribe(e) {
    this.reason ? e(this.reason) : this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  unsubscribe(e) {
    if (!this._listeners) return;
    const n = this._listeners.indexOf(e);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), n = (r) => {
      e.abort(r);
    };
    return this.subscribe(n), e.signal.unsubscribe = () => this.unsubscribe(n), e.signal;
  }
  static source() {
    let e;
    return { token: new ti(function(n) {
      e = n;
    }), cancel: e };
  }
}
const wf = ti, Is = { Continue: 100, SwitchingProtocols: 101, Processing: 102, EarlyHints: 103, Ok: 200, Created: 201, Accepted: 202, NonAuthoritativeInformation: 203, NoContent: 204, ResetContent: 205, PartialContent: 206, MultiStatus: 207, AlreadyReported: 208, ImUsed: 226, MultipleChoices: 300, MovedPermanently: 301, Found: 302, SeeOther: 303, NotModified: 304, UseProxy: 305, Unused: 306, TemporaryRedirect: 307, PermanentRedirect: 308, BadRequest: 400, Unauthorized: 401, PaymentRequired: 402, Forbidden: 403, NotFound: 404, MethodNotAllowed: 405, NotAcceptable: 406, ProxyAuthenticationRequired: 407, RequestTimeout: 408, Conflict: 409, Gone: 410, LengthRequired: 411, PreconditionFailed: 412, PayloadTooLarge: 413, UriTooLong: 414, UnsupportedMediaType: 415, RangeNotSatisfiable: 416, ExpectationFailed: 417, ImATeapot: 418, MisdirectedRequest: 421, UnprocessableEntity: 422, Locked: 423, FailedDependency: 424, TooEarly: 425, UpgradeRequired: 426, PreconditionRequired: 428, TooManyRequests: 429, RequestHeaderFieldsTooLarge: 431, UnavailableForLegalReasons: 451, InternalServerError: 500, NotImplemented: 501, BadGateway: 502, ServiceUnavailable: 503, GatewayTimeout: 504, HttpVersionNotSupported: 505, VariantAlsoNegotiates: 506, InsufficientStorage: 507, LoopDetected: 508, NotExtended: 510, NetworkAuthenticationRequired: 511, WebServerIsDown: 521, ConnectionTimedOut: 522, OriginIsUnreachable: 523, TimeoutOccurred: 524, SslHandshakeFailed: 525, InvalidSslCertificate: 526 };
Object.entries(Is).forEach(([t, e]) => {
  Is[e] = t;
});
const xf = Is, Re = function t(e) {
  const n = new cr(e), r = qa(cr.prototype.request, n);
  return b.extend(r, cr.prototype, n, { allOwnKeys: !0 }), b.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(s) {
    return t(Mt(e, s));
  }, r;
}(ei);
Re.Axios = cr, Re.CanceledError = Nn, Re.CancelToken = wf, Re.isCancel = Xa, Re.VERSION = iu, Re.toFormData = Pr, Re.AxiosError = X, Re.Cancel = Re.CanceledError, Re.all = function(t) {
  return Promise.all(t);
}, Re.spread = function(t) {
  return function(e) {
    return t.apply(null, e);
  };
}, Re.isAxiosError = function(t) {
  return b.isObject(t) && t.isAxiosError === !0;
}, Re.mergeConfig = Mt, Re.AxiosHeaders = nt, Re.formToJSON = (t) => Ya(b.isHTMLForm(t) ? new FormData(t) : t), Re.getAdapter = su, Re.HttpStatusCode = xf, Re.default = Re;
const A = Re;
function ou(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function Ls(t, e, n) {
  return Ls = ni() ? Reflect.construct : function(r, s, i) {
    var o = [null];
    o.push.apply(o, s);
    var a = new (Function.bind.apply(r, o))();
    return i && In(a, i.prototype), a;
  }, Ls.apply(null, arguments);
}
function lr(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function An(t) {
  return An = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, An(t);
}
function In(t, e) {
  return In = Object.setPrototypeOf || function(n, r) {
    return n.__proto__ = r, n;
  }, In(t, e);
}
function Us(t) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Us = function(n) {
    if (n === null || (r = n, Function.toString.call(r).indexOf("[native code]") === -1)) return n;
    var r;
    if (typeof n != "function") throw new TypeError("Super expression must either be null or a function");
    if (e !== void 0) {
      if (e.has(n)) return e.get(n);
      e.set(n, s);
    }
    function s() {
      return Ls(n, arguments, An(this).constructor);
    }
    return s.prototype = Object.create(n.prototype, { constructor: { value: s, enumerable: !1, writable: !0, configurable: !0 } }), In(s, n);
  }, Us(t);
}
function ni() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ni = function() {
    return !!t;
  })();
}
var I = "http://localhost".replace(/\/+$/, ""), We = function t(e) {
  var n, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : I, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : A;
  ou(this, t), lr(this, "basePath", void 0), lr(this, "axios", void 0), lr(this, "configuration", void 0), this.basePath = r, this.axios = s, e && (this.configuration = e, this.basePath = (n = e.basePath) !== null && n !== void 0 ? n : r);
}, Sf = function() {
  function t(e, n) {
    var r;
    return ou(this, t), lr(r = function(s, i, o) {
      return i = An(i), function(a, u) {
        return !u || ((c = u) && typeof Symbol < "u" && c.constructor === Symbol ? "symbol" : typeof c) != "object" && typeof u != "function" ? function(l) {
          if (l === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return l;
        }(a) : u;
        var c;
      }(s, ni() ? Reflect.construct(i, o || [], An(s).constructor) : i.apply(s, o));
    }(this, t, [n]), "field", void 0), r.field = e, r.name = "RequiredError", r;
  }
  return function(e, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(n && n.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), n && In(e, n);
  }(t, Us(Error)), t;
}(), N = {};
function Zo(t, e, n, r, s, i, o) {
  try {
    var a = t[i](o), u = a.value;
  } catch (c) {
    return void n(c);
  }
  a.done ? e(u) : Promise.resolve(u).then(r, s);
}
function Rf(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var D = "https://example.com", U = function(t, e, n) {
  if (n == null) throw new Sf(e, "Required parameter ".concat(e, " was null or undefined when calling ").concat(t, "."));
}, M = function(t, e) {
  return (n = function() {
    var r, s;
    return function(i, o) {
      var a, u, c, l = { label: 0, sent: function() {
        if (1 & c[0]) throw c[1];
        return c[1];
      }, trys: [], ops: [] }, d = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
      return d.next = f(0), d.throw = f(1), d.return = f(2), typeof Symbol == "function" && (d[Symbol.iterator] = function() {
        return this;
      }), d;
      function f(p) {
        return function(v) {
          return function(h) {
            if (a) throw new TypeError("Generator is already executing.");
            for (; d && (d = 0, h[0] && (l = 0)), l; ) try {
              if (a = 1, u && (c = 2 & h[0] ? u.return : h[0] ? u.throw || ((c = u.return) && c.call(u), 0) : u.next) && !(c = c.call(u, h[1])).done) return c;
              switch (u = 0, c && (h = [2 & h[0], c.value]), h[0]) {
                case 0:
                case 1:
                  c = h;
                  break;
                case 4:
                  return l.label++, { value: h[1], done: !1 };
                case 5:
                  l.label++, u = h[1], h = [0];
                  continue;
                case 7:
                  h = l.ops.pop(), l.trys.pop();
                  continue;
                default:
                  if (!((c = (c = l.trys).length > 0 && c[c.length - 1]) || h[0] !== 6 && h[0] !== 2)) {
                    l = 0;
                    continue;
                  }
                  if (h[0] === 3 && (!c || h[1] > c[0] && h[1] < c[3])) {
                    l.label = h[1];
                    break;
                  }
                  if (h[0] === 6 && l.label < c[1]) {
                    l.label = c[1], c = h;
                    break;
                  }
                  if (c && l.label < c[2]) {
                    l.label = c[2], l.ops.push(h);
                    break;
                  }
                  c[2] && l.ops.pop(), l.trys.pop();
                  continue;
              }
              h = o.call(i, l);
            } catch (R) {
              h = [6, R], u = 0;
            } finally {
              a = c = 0;
            }
            if (5 & h[0]) throw h[1];
            return { value: h[0] ? h[1] : void 0, done: !0 };
          }([p, v]);
        };
      }
    }(this, function(i) {
      switch (i.label) {
        case 0:
          return e && e.accessToken ? typeof e.accessToken != "function" ? [3, 2] : [4, e.accessToken()] : [3, 5];
        case 1:
          return s = i.sent(), [3, 4];
        case 2:
          return [4, e.accessToken];
        case 3:
          s = i.sent(), i.label = 4;
        case 4:
          r = s, t.Authorization = "Bearer " + r, i.label = 5;
        case 5:
          return [2];
      }
    });
  }, function() {
    var r = this, s = arguments;
    return new Promise(function(i, o) {
      var a = n.apply(r, s);
      function u(l) {
        Zo(a, i, o, u, c, "next", l);
      }
      function c(l) {
        Zo(a, i, o, u, c, "throw", l);
      }
      u(void 0);
    });
  })();
  var n;
};
function Ns(t, e) {
  var n, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  e != null && ((e === void 0 ? "undefined" : (n = e) && typeof Symbol < "u" && n.constructor === Symbol ? "symbol" : typeof n) == "object" ? Array.isArray(e) ? e.forEach(function(s) {
    return Ns(t, s, r);
  }) : Object.keys(e).forEach(function(s) {
    return Ns(t, e[s], "".concat(r).concat(r !== "" ? "." : "").concat(s));
  }) : t.has(r) ? t.append(r, e) : t.set(r, e));
}
var $ = function(t) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++) n[r - 1] = arguments[r];
  var s = new URLSearchParams(t.search);
  Ns(s, n), t.search = s.toString();
}, we = function(t, e, n) {
  var r = typeof t != "string";
  return (r && n && n.isJsonMime ? n.isJsonMime(e.headers["Content-Type"]) : r) ? JSON.stringify(t !== void 0 ? t : {}) : t || "";
}, F = function(t) {
  return t.pathname + t.search + t.hash;
}, B = function(t, e, n, r) {
  return function() {
    var s, i, o, a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : e, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : n, c = (i = function(l) {
      for (var d = 1; d < arguments.length; d++) {
        var f = arguments[d] != null ? arguments[d] : {}, p = Object.keys(f);
        typeof Object.getOwnPropertySymbols == "function" && (p = p.concat(Object.getOwnPropertySymbols(f).filter(function(v) {
          return Object.getOwnPropertyDescriptor(f, v).enumerable;
        }))), p.forEach(function(v) {
          Rf(l, v, f[v]);
        });
      }
      return l;
    }({}, t.options), o = (o = { url: (a.defaults.baseURL ? "" : (s = r == null ? void 0 : r.basePath) !== null && s !== void 0 ? s : u) + t.url }) != null ? o : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(o)) : function(l) {
      var d = Object.keys(l);
      if (Object.getOwnPropertySymbols) {
        var f = Object.getOwnPropertySymbols(l);
        d.push.apply(d, f);
      }
      return d;
    }(Object(o)).forEach(function(l) {
      Object.defineProperty(i, l, Object.getOwnPropertyDescriptor(o, l));
    }), i);
    return a.request(c);
  };
};
function Ho(t, e, n, r, s, i, o) {
  try {
    var a = t[i](o), u = a.value;
  } catch (c) {
    return void n(c);
  }
  a.done ? e(u) : Promise.resolve(u).then(r, s);
}
function x(t) {
  return function() {
    var e = this, n = arguments;
    return new Promise(function(r, s) {
      var i = t.apply(e, n);
      function o(u) {
        Ho(i, r, s, o, a, "next", u);
      }
      function a(u) {
        Ho(i, r, s, o, a, "throw", u);
      }
      o(void 0);
    });
  };
}
function Je(t, e, n) {
  return e = Lr(e), function(r, s) {
    return !s || ((i = s) && typeof Symbol < "u" && i.constructor === Symbol ? "symbol" : typeof i) != "object" && typeof s != "function" ? function(o) {
      if (o === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return o;
    }(r) : s;
    var i;
  }(t, au() ? Reflect.construct(e, n || [], Lr(t).constructor) : e.apply(t, n));
}
function Ve(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function _f(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function Ke(t, e, n) {
  return e && _f(t.prototype, e), t;
}
function Of(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function Lr(t) {
  return Lr = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, Lr(t);
}
function Ge(t, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Ds(t, e);
}
function w(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(s) {
      return Object.getOwnPropertyDescriptor(n, s).enumerable;
    }))), r.forEach(function(s) {
      Of(t, s, n[s]);
    });
  }
  return t;
}
function Ds(t, e) {
  return Ds = Object.setPrototypeOf || function(n, r) {
    return n.__proto__ = r, n;
  }, Ds(t, e);
}
function au() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (au = function() {
    return !!t;
  })();
}
function S(t, e) {
  var n, r, s, i = { label: 0, sent: function() {
    if (1 & s[0]) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = a(0), o.throw = a(1), o.return = a(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(c) {
      return function(l) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; o && (o = 0, l[0] && (i = 0)), i; ) try {
          if (n = 1, r && (s = 2 & l[0] ? r.return : l[0] ? r.throw || ((s = r.return) && s.call(r), 0) : r.next) && !(s = s.call(r, l[1])).done) return s;
          switch (r = 0, s && (l = [2 & l[0], s.value]), l[0]) {
            case 0:
            case 1:
              s = l;
              break;
            case 4:
              return i.label++, { value: l[1], done: !1 };
            case 5:
              i.label++, r = l[1], l = [0];
              continue;
            case 7:
              l = i.ops.pop(), i.trys.pop();
              continue;
            default:
              if (!((s = (s = i.trys).length > 0 && s[s.length - 1]) || l[0] !== 6 && l[0] !== 2)) {
                i = 0;
                continue;
              }
              if (l[0] === 3 && (!s || l[1] > s[0] && l[1] < s[3])) {
                i.label = l[1];
                break;
              }
              if (l[0] === 6 && i.label < s[1]) {
                i.label = s[1], s = l;
                break;
              }
              if (s && i.label < s[2]) {
                i.label = s[2], i.ops.push(l);
                break;
              }
              s[2] && i.ops.pop(), i.trys.pop();
              continue;
          }
          l = e.call(t, i);
        } catch (d) {
          l = [6, d], r = 0;
        } finally {
          n = s = 0;
        }
        if (5 & l[0]) throw l[1];
        return { value: l[0] ? l[1] : void 0, done: !0 };
      }([u, c]);
    };
  }
}
var Ef = function(t) {
  return { listBreaks: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return U("listBreaks", "showId", e), s = new URL("/break", D), t && (i = t.baseOptions), o = w({ method: "GET" }, i, r), u = {}, [4, M(a = {}, t)];
          case 1:
            return l.sent(), e !== void 0 && (u.showId = e), n !== void 0 && (u.ring = n), $(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, r.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  } };
}, jf = function(t) {
  var e = Ef(t);
  return { listBreaks: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.listBreaks(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = N["BreaksApi.listBreaks"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, p) {
              return B(a, A, I, t)(f, l || p);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ve(this, e), Je(this, e, arguments);
  }
  return Ge(e, t), Ke(e, [{ key: "listBreaks", value: function(n, r, s) {
    var i = this;
    return jf(this.configuration).listBreaks(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(We);
var Tf = function(t) {
  return { getClass: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return U("getClass", "classId", e), r = "/class/{classId}".replace("{classId}", encodeURIComponent(String(e))), s = new URL(r, D), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, M(a = {}, t)];
          case 1:
            return l.sent(), $(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, listClasses: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return U("listClasses", "showId", e), s = new URL("/class", D), t && (i = t.baseOptions), o = w({ method: "GET" }, i, r), u = {}, [4, M(a = {}, t)];
          case 1:
            return l.sent(), e !== void 0 && (u.showId = e), n !== void 0 && (u.mine = n), $(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, r.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, setClassErrorDeductionScheme: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return U("setClassErrorDeductionScheme", "classId", e), U("setClassErrorDeductionScheme", "setClassErrorDeductionSchemeRequest", n), s = "/class/{classId}/error-deduction-scheme".replace("{classId}", encodeURIComponent(String(e))), i = new URL(s, D), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, M(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", $(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = we(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  }, setClassFaultTimeLimit: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return U("setClassFaultTimeLimit", "classId", e), U("setClassFaultTimeLimit", "setClassFaultTimeLimitRequest", n), s = "/class/{classId}/fault-time-limit".replace("{classId}", encodeURIComponent(String(e))), i = new URL(s, D), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, M(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", $(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = we(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  }, setClassQualityJudging: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return U("setClassQualityJudging", "classId", e), U("setClassQualityJudging", "setClassQualityJudgingRequest", n), s = "/class/{classId}/quality-judging".replace("{classId}", encodeURIComponent(String(e))), i = new URL(s, D), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, M(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", $(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = we(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  }, setClassScribeAssignment: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return U("setClassScribeAssignment", "classId", e), U("setClassScribeAssignment", "setClassScribeAssignmentRequest", n), s = "/class/{classId}/scribe-assignments".replace("{classId}", encodeURIComponent(String(e))), i = new URL(s, D), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, M(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", $(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = we(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  }, setClassSectionJudgeAssignments: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return U("setClassSectionJudgeAssignments", "classId", e), s = "/class/{classId}/section-judge-assignments".replace("{classId}", encodeURIComponent(String(e))), i = new URL(s, D), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, M(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", $(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = we(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  }, setRingScribeAssignments: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return U("setRingScribeAssignments", "ring", e), U("setRingScribeAssignments", "setRingScribeAssignmentsRequest", n), s = "/ring/{ring}/scribe-assignments".replace("{ring}", encodeURIComponent(String(e))), i = new URL(s, D), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, M(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", $(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = we(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  } };
}, St = function(t) {
  var e = Tf(t);
  return { getClass: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getClass(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["ClassesApi.getClass"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, listClasses: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.listClasses(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = N["ClassesApi.listClasses"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, p) {
              return B(a, A, I, t)(f, l || p);
            }];
        }
      });
    })();
  }, setClassErrorDeductionScheme: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setClassErrorDeductionScheme(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = N["ClassesApi.setClassErrorDeductionScheme"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, p) {
              return B(a, A, I, t)(f, l || p);
            }];
        }
      });
    })();
  }, setClassFaultTimeLimit: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setClassFaultTimeLimit(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = N["ClassesApi.setClassFaultTimeLimit"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, p) {
              return B(a, A, I, t)(f, l || p);
            }];
        }
      });
    })();
  }, setClassQualityJudging: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setClassQualityJudging(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = N["ClassesApi.setClassQualityJudging"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, p) {
              return B(a, A, I, t)(f, l || p);
            }];
        }
      });
    })();
  }, setClassScribeAssignment: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setClassScribeAssignment(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = N["ClassesApi.setClassScribeAssignment"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, p) {
              return B(a, A, I, t)(f, l || p);
            }];
        }
      });
    })();
  }, setClassSectionJudgeAssignments: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setClassSectionJudgeAssignments(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = N["ClassesApi.setClassSectionJudgeAssignments"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, p) {
              return B(a, A, I, t)(f, l || p);
            }];
        }
      });
    })();
  }, setRingScribeAssignments: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setRingScribeAssignments(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = N["ClassesApi.setRingScribeAssignments"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, p) {
              return B(a, A, I, t)(f, l || p);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ve(this, e), Je(this, e, arguments);
  }
  return Ge(e, t), Ke(e, [{ key: "getClass", value: function(n, r) {
    var s = this;
    return St(this.configuration).getClass(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listClasses", value: function(n, r, s) {
    var i = this;
    return St(this.configuration).listClasses(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassErrorDeductionScheme", value: function(n, r, s) {
    var i = this;
    return St(this.configuration).setClassErrorDeductionScheme(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassFaultTimeLimit", value: function(n, r, s) {
    var i = this;
    return St(this.configuration).setClassFaultTimeLimit(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassQualityJudging", value: function(n, r, s) {
    var i = this;
    return St(this.configuration).setClassQualityJudging(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassScribeAssignment", value: function(n, r, s) {
    var i = this;
    return St(this.configuration).setClassScribeAssignment(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassSectionJudgeAssignments", value: function(n, r, s) {
    var i = this;
    return St(this.configuration).setClassSectionJudgeAssignments(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setRingScribeAssignments", value: function(n, r, s) {
    var i = this;
    return St(this.configuration).setRingScribeAssignments(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(We);
var Cf = function(t) {
  return { getDaysheetReconcileStatus: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return U("getDaysheetReconcileStatus", "showId", e), r = "/daysheet/{showId}/status".replace("{showId}", encodeURIComponent(String(e))), s = new URL(r, D), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, M(a = {}, t)];
          case 1:
            return l.sent(), $(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, reconcileDaysheet: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return U("reconcileDaysheet", "showId", e), r = "/daysheet/{showId}/reconcile".replace("{showId}", encodeURIComponent(String(e))), s = new URL(r, D), t && (i = t.baseOptions), o = w({ method: "POST" }, i, n), u = {}, [4, M(a = {}, t)];
          case 1:
            return l.sent(), $(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  } };
}, Wo = function(t) {
  var e = Cf(t);
  return { getDaysheetReconcileStatus: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getDaysheetReconcileStatus(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["DaySheetApi.getDaysheetReconcileStatus"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, reconcileDaysheet: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.reconcileDaysheet(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["DaySheetApi.reconcileDaysheet"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ve(this, e), Je(this, e, arguments);
  }
  return Ge(e, t), Ke(e, [{ key: "getDaysheetReconcileStatus", value: function(n, r) {
    var s = this;
    return Wo(this.configuration).getDaysheetReconcileStatus(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "reconcileDaysheet", value: function(n, r) {
    var s = this;
    return Wo(this.configuration).reconcileDaysheet(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }]), e;
})(We);
var kf = function(t) {
  return { getHealth: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return x(function() {
      var n, r, s, i, o;
      return S(this, function(a) {
        return n = new URL("/health", D), t && (r = t.baseOptions), s = w({ method: "GET" }, r, e), i = {}, $(n, {}), o = r && r.headers ? r.headers : {}, s.headers = w({}, i, o, e.headers), [2, { url: F(n), options: s }];
      });
    })();
  } };
}, Pf = function(t) {
  var e = kf(t);
  return { getHealth: function(n) {
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, e.getHealth(n)];
          case 1:
            return i = c.sent(), a = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, u = (s = N["HealthApi.getHealth"]) === null || s === void 0 || (r = s[a]) === null || r === void 0 ? void 0 : r.url, [2, function(l, d) {
              return B(i, A, I, t)(l, u || d);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ve(this, e), Je(this, e, arguments);
  }
  return Ge(e, t), Ke(e, [{ key: "getHealth", value: function(n) {
    var r = this;
    return Pf(this.configuration).getHealth(n).then(function(s) {
      return s(r.axios, r.basePath);
    });
  } }]), e;
})(We);
var Af = function(t) {
  return { getHorse: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return U("getHorse", "id", e), r = "/horse/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, D), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, M(a = {}, t)];
          case 1:
            return l.sent(), $(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, listHorses: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return x(function() {
      var n, r, s, i, o, a;
      return S(this, function(u) {
        switch (u.label) {
          case 0:
            return n = new URL("/horse", D), t && (r = t.baseOptions), s = w({ method: "GET" }, r, e), o = {}, [4, M(i = {}, t)];
          case 1:
            return u.sent(), $(n, o), a = r && r.headers ? r.headers : {}, s.headers = w({}, i, a, e.headers), [2, { url: F(n), options: s }];
        }
      });
    })();
  } };
}, Jo = function(t) {
  var e = Af(t);
  return { getHorse: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getHorse(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["HorsesApi.getHorse"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, listHorses: function(n) {
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, e.listHorses(n)];
          case 1:
            return i = c.sent(), a = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, u = (s = N["HorsesApi.listHorses"]) === null || s === void 0 || (r = s[a]) === null || r === void 0 ? void 0 : r.url, [2, function(l, d) {
              return B(i, A, I, t)(l, u || d);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ve(this, e), Je(this, e, arguments);
  }
  return Ge(e, t), Ke(e, [{ key: "getHorse", value: function(n, r) {
    var s = this;
    return Jo(this.configuration).getHorse(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listHorses", value: function(n) {
    var r = this;
    return Jo(this.configuration).listHorses(n).then(function(s) {
      return s(r.axios, r.basePath);
    });
  } }]), e;
})(We);
var If = function(t) {
  return { deleteJudgeSignature: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return U("deleteJudgeSignature", "id", e), r = "/judge/{id}/signature".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, D), t && (i = t.baseOptions), o = w({ method: "DELETE" }, i, n), u = {}, [4, M(a = {}, t)];
          case 1:
            return l.sent(), $(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, listJudges: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return U("listJudges", "showId", e), r = new URL("/judge", D), t && (s = t.baseOptions), i = w({ method: "GET" }, s, n), a = {}, [4, M(o = {}, t)];
          case 1:
            return c.sent(), e !== void 0 && (a.showId = e), $(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), [2, { url: F(r), options: i }];
        }
      });
    })();
  }, putJudgeSignature: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return U("putJudgeSignature", "id", e), U("putJudgeSignature", "putJudgeSignatureRequest", n), s = "/judge/{id}/signature".replace("{id}", encodeURIComponent(String(e))), i = new URL(s, D), t && (o = t.baseOptions), a = w({ method: "POST" }, o, r), c = {}, [4, M(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", $(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = we(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  } };
}, cs = function(t) {
  var e = If(t);
  return { deleteJudgeSignature: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.deleteJudgeSignature(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["JudgesApi.deleteJudgeSignature"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, listJudges: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.listJudges(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["JudgesApi.listJudges"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, putJudgeSignature: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.putJudgeSignature(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = N["JudgesApi.putJudgeSignature"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, p) {
              return B(a, A, I, t)(f, l || p);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ve(this, e), Je(this, e, arguments);
  }
  return Ge(e, t), Ke(e, [{ key: "deleteJudgeSignature", value: function(n, r) {
    var s = this;
    return cs(this.configuration).deleteJudgeSignature(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listJudges", value: function(n, r) {
    var s = this;
    return cs(this.configuration).listJudges(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "putJudgeSignature", value: function(n, r, s) {
    var i = this;
    return cs(this.configuration).putJudgeSignature(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(We);
var Lf = function(t) {
  return { createPerson: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/people", D), t && (s = t.baseOptions), i = w({ method: "POST" }, s, n), a = {}, [4, M(o = {}, t)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", $(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), i.data = we(e, i, t), [2, { url: F(r), options: i }];
        }
      });
    })();
  }, deletePerson: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return U("deletePerson", "id", e), r = "/people/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, D), t && (i = t.baseOptions), o = w({ method: "DELETE" }, i, n), u = {}, [4, M(a = {}, t)];
          case 1:
            return l.sent(), $(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, getPerson: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return U("getPerson", "id", e), r = "/people/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, D), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, M(a = {}, t)];
          case 1:
            return l.sent(), $(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, listPeople: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/people", D), t && (s = t.baseOptions), i = w({ method: "GET" }, s, n), a = {}, [4, M(o = {}, t)];
          case 1:
            return c.sent(), e !== void 0 && (a.personType = e), $(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), [2, { url: F(r), options: i }];
        }
      });
    })();
  }, updatePerson: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return U("updatePerson", "id", e), s = "/people/{id}".replace("{id}", encodeURIComponent(String(e))), i = new URL(s, D), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, M(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", $(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = we(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  } };
}, yn = function(t) {
  var e = Lf(t);
  return { createPerson: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.createPerson(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["PeopleApi.createPerson"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, deletePerson: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.deletePerson(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["PeopleApi.deletePerson"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, getPerson: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getPerson(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["PeopleApi.getPerson"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, listPeople: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.listPeople(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["PeopleApi.listPeople"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, updatePerson: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.updatePerson(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = N["PeopleApi.updatePerson"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, p) {
              return B(a, A, I, t)(f, l || p);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ve(this, e), Je(this, e, arguments);
  }
  return Ge(e, t), Ke(e, [{ key: "createPerson", value: function(n, r) {
    var s = this;
    return yn(this.configuration).createPerson(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "deletePerson", value: function(n, r) {
    var s = this;
    return yn(this.configuration).deletePerson(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getPerson", value: function(n, r) {
    var s = this;
    return yn(this.configuration).getPerson(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listPeople", value: function(n, r) {
    var s = this;
    return yn(this.configuration).listPeople(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "updatePerson", value: function(n, r, s) {
    var i = this;
    return yn(this.configuration).updatePerson(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(We);
var Uf = function(t) {
  return { getClassResults: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return U("getClassResults", "classId", e), r = "/class/{classId}/results".replace("{classId}", encodeURIComponent(String(e))), s = new URL(r, D), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, M(a = {}, t)];
          case 1:
            return l.sent(), $(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, getRideResult: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return U("getRideResult", "rideId", e), r = "/ride/{rideId}/results".replace("{rideId}", encodeURIComponent(String(e))), s = new URL(r, D), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, M(a = {}, t)];
          case 1:
            return l.sent(), $(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, setRidePlacing: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return U("setRidePlacing", "rideId", e), s = "/ride/{rideId}/placing".replace("{rideId}", encodeURIComponent(String(e))), i = new URL(s, D), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, M(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", $(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = we(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  } };
}, ls = function(t) {
  var e = Uf(t);
  return { getClassResults: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getClassResults(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["ResultsApi.getClassResults"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, getRideResult: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getRideResult(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["ResultsApi.getRideResult"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, setRidePlacing: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setRidePlacing(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = N["ResultsApi.setRidePlacing"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, p) {
              return B(a, A, I, t)(f, l || p);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ve(this, e), Je(this, e, arguments);
  }
  return Ge(e, t), Ke(e, [{ key: "getClassResults", value: function(n, r) {
    var s = this;
    return ls(this.configuration).getClassResults(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getRideResult", value: function(n, r) {
    var s = this;
    return ls(this.configuration).getRideResult(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "setRidePlacing", value: function(n, r, s) {
    var i = this;
    return ls(this.configuration).setRidePlacing(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(We);
var Nf = function(t) {
  return { batchRideStatus: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return U("batchRideStatus", "batchRideStatusRequest", e), r = new URL("/rides/status", D), t && (s = t.baseOptions), i = w({ method: "POST" }, s, n), a = {}, [4, M(o = {}, t)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", $(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), i.data = we(e, i, t), [2, { url: F(r), options: i }];
        }
      });
    })();
  }, createRide: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/ride", D), t && (s = t.baseOptions), i = w({ method: "POST" }, s, n), a = {}, [4, M(o = {}, t)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", $(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), i.data = we(e, i, t), [2, { url: F(r), options: i }];
        }
      });
    })();
  }, createRideUtilityEvent: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return U("createRideUtilityEvent", "rideId", e), U("createRideUtilityEvent", "createRideUtilityEventRequest", n), s = "/ride/{rideId}/utility-events".replace("{rideId}", encodeURIComponent(String(e))), i = new URL(s, D), t && (o = t.baseOptions), a = w({ method: "POST" }, o, r), c = {}, [4, M(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", $(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = we(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  }, deleteRideUtilityEvent: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return U("deleteRideUtilityEvent", "rideId", e), U("deleteRideUtilityEvent", "eventId", n), s = "/ride/{rideId}/utility-events/{eventId}".replace("{rideId}", encodeURIComponent(String(e))).replace("{eventId}", encodeURIComponent(String(n))), i = new URL(s, D), t && (o = t.baseOptions), a = w({ method: "DELETE" }, o, r), c = {}, [4, M(u = {}, t)];
          case 1:
            return d.sent(), $(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), [2, { url: F(i), options: a }];
        }
      });
    })();
  }, finalizeRide: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return U("finalizeRide", "rideId", e), s = "/ride/{rideId}/finalize".replace("{rideId}", encodeURIComponent(String(e))), i = new URL(s, D), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, M(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", $(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = we(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  }, getRide: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return U("getRide", "rideId", e), r = "/ride/{rideId}".replace("{rideId}", encodeURIComponent(String(e))), s = new URL(r, D), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, M(a = {}, t)];
          case 1:
            return l.sent(), $(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, listRideUtilityEvents: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return U("listRideUtilityEvents", "rideId", e), r = "/ride/{rideId}/utility-events".replace("{rideId}", encodeURIComponent(String(e))), s = new URL(r, D), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, M(a = {}, t)];
          case 1:
            return l.sent(), $(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, listRides: function(e, n, r, s, i, o, a) {
    var u = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : {};
    return x(function() {
      var c, l, d, f, p, v;
      return S(this, function(h) {
        switch (h.label) {
          case 0:
            return c = new URL("/ride", D), t && (l = t.baseOptions), d = w({ method: "GET" }, l, u), p = {}, [4, M(f = {}, t)];
          case 1:
            return h.sent(), e !== void 0 && (p.classId = e), n !== void 0 && (p.showId = n), r !== void 0 && (p.day = r), s !== void 0 && (p.ring = s), i !== void 0 && (p.needsReview = i), o !== void 0 && (p.riderId = o), a !== void 0 && (p.horseId = a), $(c, p), v = l && l.headers ? l.headers : {}, d.headers = w({}, f, v, u.headers), [2, { url: F(c), options: d }];
        }
      });
    })();
  }, resolveManualRide: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return U("resolveManualRide", "rideId", e), U("resolveManualRide", "resolveManualRideRequest", n), s = "/ride/{rideId}/resolve".replace("{rideId}", encodeURIComponent(String(e))), i = new URL(s, D), t && (o = t.baseOptions), a = w({ method: "POST" }, o, r), c = {}, [4, M(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", $(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = we(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  }, setRideStatus: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return U("setRideStatus", "rideId", e), U("setRideStatus", "setRideStatusRequest", n), s = "/ride/{rideId}/status".replace("{rideId}", encodeURIComponent(String(e))), i = new URL(s, D), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, M(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", $(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = we(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  } };
}, ut = function(t) {
  var e = Nf(t);
  return { batchRideStatus: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.batchRideStatus(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["RidesApi.batchRideStatus"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, createRide: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.createRide(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["RidesApi.createRide"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, createRideUtilityEvent: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.createRideUtilityEvent(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = N["RidesApi.createRideUtilityEvent"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, p) {
              return B(a, A, I, t)(f, l || p);
            }];
        }
      });
    })();
  }, deleteRideUtilityEvent: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.deleteRideUtilityEvent(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = N["RidesApi.deleteRideUtilityEvent"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, p) {
              return B(a, A, I, t)(f, l || p);
            }];
        }
      });
    })();
  }, finalizeRide: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.finalizeRide(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = N["RidesApi.finalizeRide"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, p) {
              return B(a, A, I, t)(f, l || p);
            }];
        }
      });
    })();
  }, getRide: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getRide(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["RidesApi.getRide"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, listRideUtilityEvents: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.listRideUtilityEvents(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["RidesApi.listRideUtilityEvents"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, listRides: function(n, r, s, i, o, a, u, c) {
    return x(function() {
      var l, d, f, p, v, h;
      return S(this, function(R) {
        switch (R.label) {
          case 0:
            return [4, e.listRides(n, r, s, i, o, a, u, c)];
          case 1:
            return f = R.sent(), v = (p = t == null ? void 0 : t.serverIndex) !== null && p !== void 0 ? p : 0, h = (d = N["RidesApi.listRides"]) === null || d === void 0 || (l = d[v]) === null || l === void 0 ? void 0 : l.url, [2, function(J, j) {
              return B(f, A, I, t)(J, h || j);
            }];
        }
      });
    })();
  }, resolveManualRide: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.resolveManualRide(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = N["RidesApi.resolveManualRide"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, p) {
              return B(a, A, I, t)(f, l || p);
            }];
        }
      });
    })();
  }, setRideStatus: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setRideStatus(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = N["RidesApi.setRideStatus"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, p) {
              return B(a, A, I, t)(f, l || p);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ve(this, e), Je(this, e, arguments);
  }
  return Ge(e, t), Ke(e, [{ key: "batchRideStatus", value: function(n, r) {
    var s = this;
    return ut(this.configuration).batchRideStatus(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "createRide", value: function(n, r) {
    var s = this;
    return ut(this.configuration).createRide(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "createRideUtilityEvent", value: function(n, r, s) {
    var i = this;
    return ut(this.configuration).createRideUtilityEvent(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "deleteRideUtilityEvent", value: function(n, r, s) {
    var i = this;
    return ut(this.configuration).deleteRideUtilityEvent(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "finalizeRide", value: function(n, r, s) {
    var i = this;
    return ut(this.configuration).finalizeRide(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "getRide", value: function(n, r) {
    var s = this;
    return ut(this.configuration).getRide(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listRideUtilityEvents", value: function(n, r) {
    var s = this;
    return ut(this.configuration).listRideUtilityEvents(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listRides", value: function(n, r, s, i, o, a, u, c) {
    var l = this;
    return ut(this.configuration).listRides(n, r, s, i, o, a, u, c).then(function(d) {
      return d(l.axios, l.basePath);
    });
  } }, { key: "resolveManualRide", value: function(n, r, s) {
    var i = this;
    return ut(this.configuration).resolveManualRide(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setRideStatus", value: function(n, r, s) {
    var i = this;
    return ut(this.configuration).setRideStatus(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(We);
var Df = function(t) {
  return { completeScoreSheet: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return U("completeScoreSheet", "id", e), r = "/scoresheet/{id}/complete".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, D), t && (i = t.baseOptions), o = w({ method: "POST" }, i, n), u = {}, [4, M(a = {}, t)];
          case 1:
            return l.sent(), $(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, confirmScoreSheetMarks: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return U("confirmScoreSheetMarks", "id", e), r = "/scoresheet/{id}/confirm-marks".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, D), t && (i = t.baseOptions), o = w({ method: "POST" }, i, n), u = {}, [4, M(a = {}, t)];
          case 1:
            return l.sent(), $(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, createScoreSheet: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/scoresheet", D), t && (s = t.baseOptions), i = w({ method: "POST" }, s, n), a = {}, [4, M(o = {}, t)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", $(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), i.data = we(e, i, t), [2, { url: F(r), options: i }];
        }
      });
    })();
  }, getRideAuditTrail: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return U("getRideAuditTrail", "rideId", e), r = "/ride/{rideId}/audit".replace("{rideId}", encodeURIComponent(String(e))), s = new URL(r, D), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, M(a = {}, t)];
          case 1:
            return l.sent(), $(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, getScoreSheet: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return U("getScoreSheet", "id", e), r = "/scoresheet/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, D), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, M(a = {}, t)];
          case 1:
            return l.sent(), $(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, getScoreSheetAuditTrail: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return U("getScoreSheetAuditTrail", "id", e), r = "/scoresheet/{id}/audit".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, D), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, M(a = {}, t)];
          case 1:
            return l.sent(), $(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, getScoreSheetSignature: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return U("getScoreSheetSignature", "id", e), r = "/scoresheet/{id}/signature".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, D), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, M(a = {}, t)];
          case 1:
            return l.sent(), $(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, listScoreSheets: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return s = new URL("/scoresheet", D), t && (i = t.baseOptions), o = w({ method: "GET" }, i, r), u = {}, [4, M(a = {}, t)];
          case 1:
            return l.sent(), e !== void 0 && (u.rideId = e), n !== void 0 && (u.judgeId = n), $(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, r.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, reopenScoreSheet: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return U("reopenScoreSheet", "id", e), U("reopenScoreSheet", "reopenScoreSheetRequest", n), s = "/scoresheet/{id}/reopen".replace("{id}", encodeURIComponent(String(e))), i = new URL(s, D), t && (o = t.baseOptions), a = w({ method: "POST" }, o, r), c = {}, [4, M(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", $(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = we(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  }, updateScoreSheet: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return U("updateScoreSheet", "id", e), s = "/scoresheet/{id}".replace("{id}", encodeURIComponent(String(e))), i = new URL(s, D), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, M(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", $(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = we(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  } };
}, ct = function(t) {
  var e = Df(t);
  return { completeScoreSheet: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.completeScoreSheet(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["ScoreSheetsApi.completeScoreSheet"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, confirmScoreSheetMarks: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.confirmScoreSheetMarks(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["ScoreSheetsApi.confirmScoreSheetMarks"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, createScoreSheet: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.createScoreSheet(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["ScoreSheetsApi.createScoreSheet"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, getRideAuditTrail: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getRideAuditTrail(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["ScoreSheetsApi.getRideAuditTrail"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, getScoreSheet: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getScoreSheet(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["ScoreSheetsApi.getScoreSheet"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, getScoreSheetAuditTrail: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getScoreSheetAuditTrail(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["ScoreSheetsApi.getScoreSheetAuditTrail"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, getScoreSheetSignature: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getScoreSheetSignature(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["ScoreSheetsApi.getScoreSheetSignature"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, listScoreSheets: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.listScoreSheets(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = N["ScoreSheetsApi.listScoreSheets"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, p) {
              return B(a, A, I, t)(f, l || p);
            }];
        }
      });
    })();
  }, reopenScoreSheet: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.reopenScoreSheet(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = N["ScoreSheetsApi.reopenScoreSheet"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, p) {
              return B(a, A, I, t)(f, l || p);
            }];
        }
      });
    })();
  }, updateScoreSheet: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.updateScoreSheet(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = N["ScoreSheetsApi.updateScoreSheet"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, p) {
              return B(a, A, I, t)(f, l || p);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ve(this, e), Je(this, e, arguments);
  }
  return Ge(e, t), Ke(e, [{ key: "completeScoreSheet", value: function(n, r) {
    var s = this;
    return ct(this.configuration).completeScoreSheet(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "confirmScoreSheetMarks", value: function(n, r) {
    var s = this;
    return ct(this.configuration).confirmScoreSheetMarks(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "createScoreSheet", value: function(n, r) {
    var s = this;
    return ct(this.configuration).createScoreSheet(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getRideAuditTrail", value: function(n, r) {
    var s = this;
    return ct(this.configuration).getRideAuditTrail(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getScoreSheet", value: function(n, r) {
    var s = this;
    return ct(this.configuration).getScoreSheet(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getScoreSheetAuditTrail", value: function(n, r) {
    var s = this;
    return ct(this.configuration).getScoreSheetAuditTrail(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getScoreSheetSignature", value: function(n, r) {
    var s = this;
    return ct(this.configuration).getScoreSheetSignature(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listScoreSheets", value: function(n, r, s) {
    var i = this;
    return ct(this.configuration).listScoreSheets(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "reopenScoreSheet", value: function(n, r, s) {
    var i = this;
    return ct(this.configuration).reopenScoreSheet(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "updateScoreSheet", value: function(n, r, s) {
    var i = this;
    return ct(this.configuration).updateScoreSheet(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(We);
var $f = function(t) {
  return { getShow: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return U("getShow", "id", e), r = "/show/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, D), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, M(a = {}, t)];
          case 1:
            return l.sent(), $(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, listShows: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return x(function() {
      var n, r, s, i, o, a;
      return S(this, function(u) {
        switch (u.label) {
          case 0:
            return n = new URL("/show", D), t && (r = t.baseOptions), s = w({ method: "GET" }, r, e), o = {}, [4, M(i = {}, t)];
          case 1:
            return u.sent(), $(n, o), a = r && r.headers ? r.headers : {}, s.headers = w({}, i, a, e.headers), [2, { url: F(n), options: s }];
        }
      });
    })();
  } };
}, Vo = function(t) {
  var e = $f(t);
  return { getShow: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getShow(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["ShowsApi.getShow"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, listShows: function(n) {
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, e.listShows(n)];
          case 1:
            return i = c.sent(), a = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, u = (s = N["ShowsApi.listShows"]) === null || s === void 0 || (r = s[a]) === null || r === void 0 ? void 0 : r.url, [2, function(l, d) {
              return B(i, A, I, t)(l, u || d);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ve(this, e), Je(this, e, arguments);
  }
  return Ge(e, t), Ke(e, [{ key: "getShow", value: function(n, r) {
    var s = this;
    return Vo(this.configuration).getShow(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listShows", value: function(n) {
    var r = this;
    return Vo(this.configuration).listShows(n).then(function(s) {
      return s(r.axios, r.basePath);
    });
  } }]), e;
})(We);
var Ff = function(t) {
  return { createTest: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/test", D), t && (s = t.baseOptions), i = w({ method: "POST" }, s, n), a = {}, [4, M(o = {}, t)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", $(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), i.data = we(e, i, t), [2, { url: F(r), options: i }];
        }
      });
    })();
  }, deleteTest: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return U("deleteTest", "id", e), r = "/test/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, D), t && (i = t.baseOptions), o = w({ method: "DELETE" }, i, n), u = {}, [4, M(a = {}, t)];
          case 1:
            return l.sent(), $(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, getTest: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return U("getTest", "id", e), r = "/test/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, D), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, M(a = {}, t)];
          case 1:
            return l.sent(), $(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, listTests: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/test", D), t && (s = t.baseOptions), i = w({ method: "GET" }, s, n), a = {}, [4, M(o = {}, t)];
          case 1:
            return c.sent(), e !== void 0 && (a.showId = e), $(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), [2, { url: F(r), options: i }];
        }
      });
    })();
  }, updateTest: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return U("updateTest", "id", e), s = "/test/{id}".replace("{id}", encodeURIComponent(String(e))), i = new URL(s, D), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, M(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", $(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = we(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  } };
}, bn = function(t) {
  var e = Ff(t);
  return { createTest: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.createTest(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["TestsApi.createTest"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, deleteTest: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.deleteTest(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["TestsApi.deleteTest"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, getTest: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getTest(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["TestsApi.getTest"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, listTests: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.listTests(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = N["TestsApi.listTests"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return B(o, A, I, t)(d, c || f);
            }];
        }
      });
    })();
  }, updateTest: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.updateTest(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = N["TestsApi.updateTest"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, p) {
              return B(a, A, I, t)(f, l || p);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return Ve(this, e), Je(this, e, arguments);
  }
  return Ge(e, t), Ke(e, [{ key: "createTest", value: function(n, r) {
    var s = this;
    return bn(this.configuration).createTest(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "deleteTest", value: function(n, r) {
    var s = this;
    return bn(this.configuration).deleteTest(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getTest", value: function(n, r) {
    var s = this;
    return bn(this.configuration).getTest(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listTests", value: function(n, r) {
    var s = this;
    return bn(this.configuration).listTests(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "updateTest", value: function(n, r, s) {
    var i = this;
    return bn(this.configuration).updateTest(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(We);
function Bf(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function yt(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function Ko(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(s) {
      return Object.getOwnPropertyDescriptor(n, s).enumerable;
    }))), r.forEach(function(s) {
      yt(t, s, n[s]);
    });
  }
  return t;
}
(function() {
  function t() {
    var r, s, i, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (function(a, u) {
      if (!(a instanceof u)) throw new TypeError("Cannot call a class as a function");
    })(this, t), yt(this, "apiKey", void 0), yt(this, "username", void 0), yt(this, "password", void 0), yt(this, "accessToken", void 0), yt(this, "basePath", void 0), yt(this, "serverIndex", void 0), yt(this, "baseOptions", void 0), yt(this, "formDataCtor", void 0), this.apiKey = o.apiKey, this.username = o.username, this.password = o.password, this.accessToken = o.accessToken, this.basePath = o.basePath, this.serverIndex = o.serverIndex, this.baseOptions = (s = Ko({}, o.baseOptions), i = (i = { headers: Ko({}, (r = o.baseOptions) === null || r === void 0 ? void 0 : r.headers) }) != null ? i : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(i)) : function(a) {
      var u = Object.keys(a);
      if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(a);
        u.push.apply(u, c);
      }
      return u;
    }(Object(i)).forEach(function(a) {
      Object.defineProperty(s, a, Object.getOwnPropertyDescriptor(i, a));
    }), s), this.formDataCtor = o.formDataCtor;
  }
  var e, n;
  return e = t, (n = [{ key: "isJsonMime", value: function(r) {
    var s = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return r !== null && (s.test(r) || r.toLowerCase() === "application/json-patch+json");
  } }]) && Bf(e.prototype, n), t;
})();
const Mf = {
  [Ht.PENDING]: { color: "default", label: "Scheduled" },
  [Ht.IN_PROGRESS]: { color: "info", label: "In ring" },
  // #696 — score confirmed/frozen and released to the announcer + FVD, judge
  // may still be writing comments. Green like FINAL ("score ready"); the label
  // is what tells the two apart.
  [Ht.CONFIRMED]: { color: "success", label: "Confirmed" },
  [Ht.COMPLETED]: { color: "warning", label: "Scored" },
  [Ht.FINAL]: { color: "success", label: "Final" },
  [Ht.SCRATCHED]: { color: "error", label: "Scratched" }
}, zf = { color: "default", label: "—" };
function up({ status: t, labels: e, size: n = "small", ...r }) {
  const s = Mf[t] ?? zf, i = (e == null ? void 0 : e[t]) ?? s.label;
  return /* @__PURE__ */ m.jsx(ia, { size: n, color: s.color, label: i, ...r });
}
function cp(t, e, { intervalMs: n, enabled: r = !0 } = {}) {
  const [s, i] = z({}), [o, a] = z(!1), [u, c] = z(null), [l, d] = z(null), f = Array.from(new Set((t ?? []).filter(Boolean))), p = f.join(","), v = $t(e);
  v.current = e;
  const h = $t(f);
  h.current = f;
  const R = r && f.length > 0 && typeof e == "function", J = Dt(async () => {
    const j = h.current;
    if (!(!j.length || typeof v.current != "function")) {
      a(!0);
      try {
        const W = await v.current(j), L = {};
        for (const ne of W ?? []) L[ne.rideId] = ne.status;
        i(L), c(null), d(/* @__PURE__ */ new Date());
      } catch (W) {
        c(W);
      } finally {
        a(!1);
      }
    }
  }, []);
  return ye(() => {
    if (!f.length) {
      i({});
      return;
    }
    if (!R)
      return;
    if (!n) {
      J();
      return;
    }
    document.visibilityState !== "hidden" && J();
    let j = null;
    const W = () => {
      document.visibilityState !== "hidden" && j == null && (j = setInterval(J, n));
    }, L = () => {
      j != null && (clearInterval(j), j = null);
    }, ne = () => {
      document.visibilityState === "hidden" ? L() : (J(), W());
    };
    return W(), document.addEventListener("visibilitychange", ne), () => {
      L(), document.removeEventListener("visibilitychange", ne);
    };
  }, [p, R, n, J]), { statuses: s, loading: o, error: u, refresh: J, lastUpdated: l };
}
function lp({
  judgeName: t,
  url: e,
  loading: n = !1,
  label: r = "Judge signature",
  ...s
}) {
  return n ? /* @__PURE__ */ m.jsxs(gr, { spacing: 1, alignItems: "center", sx: { mt: 3 }, ...s, children: [
    /* @__PURE__ */ m.jsx(mr, { variant: "rounded", width: 240, height: 90 }),
    /* @__PURE__ */ m.jsx(mr, { variant: "text", width: 140 })
  ] }) : e ? /* @__PURE__ */ m.jsxs(
    gr,
    {
      spacing: 1,
      alignItems: "center",
      "data-testid": "signature-box",
      sx: { mt: 3, pt: 2, borderTop: 1, borderColor: "divider" },
      ...s,
      children: [
        /* @__PURE__ */ m.jsx(vr, { variant: "caption", color: "text.secondary", children: r }),
        /* @__PURE__ */ m.jsx(
          Ce,
          {
            sx: {
              border: 1,
              borderColor: "divider",
              borderRadius: 1,
              bgcolor: "#ffffff",
              p: 1,
              display: "flex",
              justifyContent: "center"
            },
            children: /* @__PURE__ */ m.jsx(
              Ce,
              {
                component: "img",
                src: e,
                alt: t || r,
                "data-testid": "signature-box-image",
                sx: { maxWidth: 240, maxHeight: 90, objectFit: "contain" }
              }
            )
          }
        ),
        t && /* @__PURE__ */ m.jsx(
          vr,
          {
            variant: "body2",
            color: "text.primary",
            fontWeight: 600,
            "data-testid": "signature-box-name",
            children: t
          }
        )
      ]
    }
  ) : null;
}
function dp(t, e, { enabled: n = !0 } = {}) {
  const [r, s] = z(null), [i, o] = z(!1), [a, u] = z(null), c = $t(e);
  c.current = e;
  const l = n && !!t && typeof e == "function";
  return ye(() => {
    if (!l) {
      s(null);
      return;
    }
    let d = !1;
    return o(!0), u(null), (async () => {
      try {
        const f = await c.current(t);
        d || s(f ?? null);
      } catch (f) {
        d || u(f);
      } finally {
        d || o(!1);
      }
    })(), () => {
      d = !0;
    };
  }, [l, t]), { signature: r, loading: i, error: a };
}
function fp({ buildId: t, testId: e = "build-badge" }) {
  const n = t ?? (typeof __BUILD_ID__ < "u" ? __BUILD_ID__ : "dev");
  return n ? /* @__PURE__ */ m.jsx(
    ue,
    {
      "data-testid": e,
      "aria-hidden": "true",
      sx: {
        position: "fixed",
        bottom: 2,
        left: 86,
        // Above AppBar/NavRail (both 1300/1200 in common-fe) so it's never
        // hidden by app chrome, but below modals/dialogs so it doesn't cover
        // interactive overlays. It's pointer-events:none anyway.
        zIndex: 1250,
        pointerEvents: "none",
        userSelect: "none",
        // A subtle themed pill so the text reads on top of any content —
        // proven legible in both light and dark (mirrors PinLock's approach).
        px: 0.5,
        py: "1px",
        borderRadius: 0.5,
        bgcolor: "background.paper",
        opacity: 0.75,
        // text.secondary reads on both light and dark backgrounds; never MUI
        // `primary` (dark-grey, vanishes on dark).
        color: "text.secondary",
        fontFamily: "monospace",
        fontSize: "9px",
        lineHeight: 1.2,
        letterSpacing: 0,
        whiteSpace: "nowrap"
      },
      children: n
    }
  ) : null;
}
function hp({ testId: t = "usa-badge" }) {
  return /* @__PURE__ */ m.jsxs(
    ue,
    {
      "data-testid": t,
      "aria-hidden": "true",
      sx: {
        position: "fixed",
        bottom: 2,
        left: 2,
        width: 80,
        // Above AppBar/NavRail (both 1300/1200 in common-fe), same layer as
        // BuildBadge so the pair reads as one unit; below modals/dialogs.
        zIndex: 1250,
        pointerEvents: "none",
        userSelect: "none",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        opacity: 0.75
      },
      children: [
        /* @__PURE__ */ m.jsx(
          ue,
          {
            component: "svg",
            viewBox: "0 0 1200 1200",
            "aria-label": "Made in the USA",
            sx: {
              width: 28,
              height: 28,
              // text.secondary reads on both light and dark backgrounds; never
              // MUI `primary` (dark-grey, vanishes on dark) — same rule as
              // BuildBadge.
              color: "text.secondary",
              fill: "currentColor"
            },
            children: /* @__PURE__ */ m.jsx("path", { d: "m60.84 823.92h1078.4v-49.801h-1078.4zm0-99.48h1078.4v-49.801h-1078.4zm1078.3-398.16v-49.801h-1078.3v348.61h1078.4v-49.801l-647.16-0.003906v-49.801h647.04v-49.801h-647.04v-49.801h647.04v-49.801h-647.04v-49.801zm-718.92 0.95703 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.238 6.3633 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm12.363 107.52-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm0 69.719-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36 34.801-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-35.883-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36 34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-35.879-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36 34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-35.879 34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.8398-9.7227 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-32.16-93.121 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68zm283.8-11.398-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm0 69.598-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-28.32-58.199-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48zm-43.562 58.199-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.2773-83.277 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm-26.043 25.078-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48zm-43.559 58.199-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.3984-83.277 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm-25.922 25.078-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48zm-43.559 58.199-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.4023-83.277 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm199.56-81.48 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188zm-29.762 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm-42.121-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm-29.758 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm-42.121-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm-29.758 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm-42.121-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm-29.762 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.957-9.8359 13.801-2.0391zm-42.117-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm0 69.719 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm0 69.719 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.363-6.4766-12.359 6.4805 2.3984-13.68-9.957-9.8398zm0 69.602 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9648 9.7227 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.957-9.7227zm18.477 95.16-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.957-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.957-9.8398 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.242 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.238 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.238 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.242 41.281-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.637-41.281-12.238 6.3594 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.242 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.2812-83.398 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm0-69.723 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm0-69.598 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm0-69.723 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm-405.36 606.96h1078.4v-49.801h-1078.4z" })
          }
        ),
        /* @__PURE__ */ m.jsx(
          ue,
          {
            sx: {
              mt: "1px",
              fontSize: "12px",
              fontWeight: 600,
              lineHeight: 1.15,
              letterSpacing: "0.2px",
              textAlign: "center",
              textTransform: "uppercase",
              whiteSpace: "normal",
              // text.secondary reads on both light and dark backgrounds; never
              // MUI `primary` (dark-grey, vanishes on dark).
              color: "text.secondary"
            },
            children: "Made in the USA"
          }
        )
      ]
    }
  );
}
const qf = "5432";
function pp({
  pin: t = qf,
  onUnlock: e,
  testId: n = "pin-lock",
  ariaLabel: r = "Unlock"
}) {
  const [s, i] = z(!1), [o, a] = z(""), [u, c] = z(!1), l = $t(null);
  return ye(() => {
    s || (a(""), c(!1));
  }, [s]), ye(() => {
    if (!s || o.length !== t.length) return;
    const d = setTimeout(() => {
      o === t ? (i(!1), e == null || e()) : (c(!0), setTimeout(() => {
        var f;
        a(""), c(!1), (f = l.current) == null || f.focus();
      }, 600));
    }, 80);
    return () => clearTimeout(d);
  }, [o, s, t, e]), /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
    /* @__PURE__ */ m.jsx(
      pr,
      {
        onClick: () => i(!0),
        "aria-label": r,
        "data-testid": n,
        sx: {
          position: "fixed",
          bottom: 12,
          right: 12,
          zIndex: 1300,
          // #628 — discreet, but actually findable and tappable: a scribe has to
          // hit it on a tablet when an admin walks over, so it can't be a 16px
          // ghost. Themed text color reads on both light and dark backgrounds.
          color: "text.secondary",
          bgcolor: "background.paper",
          border: 1,
          borderColor: "divider",
          width: 40,
          height: 40,
          "&:hover": { bgcolor: "action.hover" }
        },
        children: /* @__PURE__ */ m.jsx(mc, { sx: { fontSize: 20 } })
      }
    ),
    /* @__PURE__ */ m.jsxs(
      Vn,
      {
        open: s,
        onClose: () => i(!1),
        maxWidth: "xs",
        fullWidth: !0,
        children: [
          /* @__PURE__ */ m.jsx(Kn, { children: /* @__PURE__ */ m.jsx(ue, { sx: { pt: 1 }, children: /* @__PURE__ */ m.jsx(
            En,
            {
              inputRef: l,
              autoFocus: !0,
              fullWidth: !0,
              type: "password",
              value: o,
              onChange: (d) => (
                // Strip non-digits + cap to PIN length so paste-overflow
                // doesn't sneak past the auto-submit threshold.
                a(
                  d.target.value.replace(/\D/g, "").slice(0, t.length)
                )
              ),
              inputProps: {
                inputMode: "numeric",
                pattern: "[0-9]*",
                maxLength: t.length,
                style: {
                  textAlign: "center",
                  fontFamily: "monospace",
                  fontSize: 24,
                  letterSpacing: 8
                }
              },
              error: u,
              helperText: u ? "Wrong PIN" : " "
            }
          ) }) }),
          /* @__PURE__ */ m.jsx(fs, { children: /* @__PURE__ */ m.jsx(Ie, { color: "inherit", onClick: () => i(!1), children: "Cancel" }) })
        ]
      }
    )
  ] });
}
function mp(t, e, n = [], r = !0) {
  const [s, i] = z({ data: null, loading: !0, error: null });
  return ye(() => {
    let o = !1;
    return (async () => {
      let a;
      try {
        a = await t();
      } catch {
        a = void 0;
      }
      const u = a != null;
      if (!o && u && i({ data: a, loading: !1, error: null }), r)
        try {
          const c = await e();
          o || i({ data: c, loading: !1, error: null });
        } catch (c) {
          !o && !u && i({ data: null, loading: !1, error: c });
        }
      else !o && !u && i({ data: null, loading: !1, error: null });
    })(), () => {
      o = !0;
    };
  }, [...n, r]), s;
}
function gp(t, e = []) {
  const [n, r] = z({ data: null, loading: !0, error: null });
  return ye(() => {
    let s = !1;
    return r({ data: null, loading: !0, error: null }), t().then((i) => {
      s || r({ data: i, loading: !1, error: null });
    }).catch((i) => {
      s || r({ data: null, loading: !1, error: i });
    }), () => {
      s = !0;
    };
  }, e), n;
}
function Zf({ clientId: t, cognitoDomain: e, logoutUri: n }) {
  if (t && e && n) {
    const r = `https://${e}/logout?client_id=${t}&logout_uri=${encodeURIComponent(n)}`;
    window.location.replace(r);
  }
}
function vp() {
  const { mode: t, setMode: e } = sc();
  return { mode: t, toggleTheme: () => {
    e(t === "dark" ? "light" : "dark");
  } };
}
function yp({ t, mode: e, toggleTheme: n, navigate: r, cognitoConfig: s, settingsLink: i = "/settings" }) {
  return [
    {
      icon: /* @__PURE__ */ m.jsx(ta, {}),
      text: t("navigation.homeLink"),
      onClick: () => r("/")
    },
    {
      icon: /* @__PURE__ */ m.jsx(na, {}),
      text: t("navigation.settingsLink"),
      onClick: () => window.location.href = i
    },
    {
      icon: e === "dark" ? /* @__PURE__ */ m.jsx(vc, { fontSize: "small" }) : /* @__PURE__ */ m.jsx(gc, { fontSize: "small" }),
      text: t(e === "dark" ? "navigation.theme.switchToLightMode" : "navigation.theme.switchToDarkMode"),
      onClick: n
    },
    {
      icon: /* @__PURE__ */ m.jsx(yc, {}),
      text: t("navigation.logoutLink"),
      onClick: () => Zf(s)
    }
  ];
}
const Hf = "Server Error";
let Go = !1;
function bp(t = bc) {
  Go || (Go = !0, t.interceptors.response.use(
    (e) => e,
    (e) => {
      var s, i, o;
      const n = (s = e == null ? void 0 : e.response) == null ? void 0 : s.data, r = ((i = n == null ? void 0 : n.data) == null ? void 0 : i.message) || (n == null ? void 0 : n.message) || (n == null ? void 0 : n.error) || (n == null ? void 0 : n.code) || (e == null ? void 0 : e.message);
      return console.error("[api error]", (o = e == null ? void 0 : e.response) == null ? void 0 : o.status, r, n), e && (e.serverErrorDetail = r, e.message = Hf), Promise.reject(e);
    }
  ));
}
export {
  kh as AccountMenu,
  Vh as ActiveOrgProvider,
  Kh as ActiveShowProvider,
  Ph as AppBar,
  Ah as AppFooter,
  Ih as AppLayout,
  fp as BuildBadge,
  Lh as CallbackPage,
  Nh as CognitoAuthProvider,
  Dh as ConfirmButton,
  Gn as FullScreenLoader,
  Jh as ItemCard,
  Fh as LoggedOutPage,
  Bh as LogoutPage,
  Oc as MainContent,
  tp as MockAuthProvider,
  rp as MockLoginPage,
  np as MockProtectedRoute,
  Mh as MuiThemeProvider,
  zh as NavRail,
  Wh as NewItemCard,
  ep as OrgSwitcher,
  Zh as PageLayout,
  Yh as PermissionProvider,
  pp as PinLock,
  qh as ProtectedRoute,
  Mf as RIDE_STATUS_DISPLAY,
  Kl as ReportList,
  Ql as ReportParamsForm,
  ad as ReportViewer,
  ap as Reports,
  up as RideStatusBadge,
  id as RunHistory,
  Hf as SERVER_ERROR_MESSAGE,
  Gh as ShowSwitcher,
  lp as SignatureBox,
  Hh as StyledBreadcrumb,
  $h as TableSkeleton,
  qf as UNLOCK_PIN,
  hp as UsaBadge,
  Qh as UserDisplayName,
  Uh as beginSignOut,
  yp as getDefaultAccountMenuItems,
  bp as installServerErrorInterceptor,
  Tc as isSigningOut,
  Zf as logoutCognito,
  en as unwrapReport,
  la as useActiveOrg,
  zc as useActiveShow,
  Hl as useApiConfig,
  gp as useApiResource,
  mp as useCachedResource,
  ma as useMockAuth,
  Xh as usePermission,
  Wl as useReportApi,
  cp as useRideStatuses,
  dp as useSheetSignature,
  vp as useThemeSwitcher
};
//# sourceMappingURL=common-fe.js.map
